
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequire49d7"];
var parcelRegister = parcelRequire.register;
parcelRegister("vtgYF", function(module, exports) {

$parcel$export(module.exports, "CookieConsentBanner", () => $73be3348c53dc4e4$export$48911bd645a2a0a2);
/* CookieConsentBanner.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $bwpsq = parcelRequire("bwpsq");

var $5uXOq = parcelRequire("5uXOq");

var $34ck9 = parcelRequire("34ck9");

var $gJlZe = parcelRequire("gJlZe");

var $aWDoc = parcelRequire("aWDoc");

var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");


var $gubdC = parcelRequire("gubdC");
const $73be3348c53dc4e4$export$48911bd645a2a0a2 = ()=>{
    const [{ height: height }] = (0, $gubdC.useCookieConsentBannerSettings)();
    const { onDismiss: onDismiss, setHeight: setHeight } = (0, $gubdC.useCookieConsentBannerSettingsActions)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const ref = (0, $5uXOq.useRef)(null);
    // banner height is set either due to screen width changes or consent banner finishes rendering
    const setBannerHeight = ()=>{
        ref.current && setHeight(ref.current.clientHeight);
    };
    // throttled banner height setter is used for dynamic banner height when screen width changes
    const throttledSetBannerHeight = (0, (/*@__PURE__*/$parcel$interopDefault($34ck9)))(setBannerHeight, 50);
    (0, $5uXOq.useEffect)(()=>{
        const action = 'rendered';
        const actionSubject = 'cookieConsentBanner';
        const event = createAnalyticsEvent({
            action: action,
            actionSubject: actionSubject
        });
        (0, $8zOmE.fireUIAnalytics)(event, `${actionSubject} ${action}`);
    }, [
        createAnalyticsEvent
    ]);
    const onConsentBannerBailOut = (0, $5uXOq.useCallback)(()=>{
        const actionSubject = 'consentBanner';
        const action = 'bailedOut';
        const event = createAnalyticsEvent({
            action: action,
            actionSubject: actionSubject
        });
        (0, $8zOmE.fireTrackAnalytics)(event, `${actionSubject} ${action}`);
        // consider banner as dismissed if it reports a bail out
        onDismiss();
    }, [
        onDismiss,
        createAnalyticsEvent
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gJlZe.WidthObserver), {
        setWidth: throttledSetBannerHeight
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
        ref: ref,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
        className: (0, $bwpsq.default)([
            !height && "_3um015vq"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $aWDoc.ConsentBanner), {
        onHide: onDismiss,
        onShow: setBannerHeight,
        minWidth: (0, $91be75e714d10b24$export$ff6e18f7d82b549c),
        onConsentBannerBailOut: onConsentBannerBailOut,
        product: "Jira"
    })));
};

});
parcelRegister("gJlZe", function(module, exports) {

$parcel$export(module.exports, "WidthObserver", () => $f3c667de71b5760d$export$b2ad68b9bc407b80);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $jWz2c = parcelRequire("jWz2c");
const $f3c667de71b5760d$export$b2ad68b9bc407b80 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).memo((props)=>{
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $jWz2c.WidthDetectorObserver), {
        setWidth: props.setWidth,
        offscreen: props.offscreen
    });
});
var $f3c667de71b5760d$export$2e2bcd8739ae039 = $f3c667de71b5760d$export$b2ad68b9bc407b80;

});
parcelRegister("jWz2c", function(module, exports) {

$parcel$export(module.exports, "WidthDetectorObserver", () => $76470ef26276f9f4$export$ff983d2a2b6112ea);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $1LwQL = parcelRequire("1LwQL");
const $76470ef26276f9f4$export$ff983d2a2b6112ea = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).memo(({ setWidth: setWidth, offscreen: offscreen })=>{
    const [inViewRef, inView, target] = (0, $1LwQL.useInView)({
        /* Optional options */ threshold: 0
    });
    const observer = (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).useRef(()=>{
        if (typeof window === 'undefined') return null;
        // https://github.com/DefinitelyTyped/DefinitelyTyped/pull/40909
        // @ts-ignore
        return new ResizeObserver((entries)=>{
            if (!Array.isArray(entries) || !entries.length) return;
            const { width: width } = entries[0].contentRect;
            setWidth(Math.round(width));
        });
    });
    (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).useEffect(()=>{
        const { current: currentObserver } = observer;
        const resizeObserver = currentObserver();
        if (resizeObserver === null) return;
        if (target) {
            if (inView || offscreen) resizeObserver.observe(target);
            else resizeObserver.unobserve(target);
        }
        return ()=>{
            resizeObserver.disconnect();
        };
    }, [
        target,
        inView,
        offscreen
    ]);
    return /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            display: 'block',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            width: '100%',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            position: 'absolute'
        },
        ref: inViewRef
    });
});

});
parcelRegister("1LwQL", function(module, exports) {

$parcel$export(module.exports, "useInView", () => $1dfb7d23cdbb03d0$export$2f62ee6831462844);

var $5uXOq = parcelRequire("5uXOq");
function $1dfb7d23cdbb03d0$export$2f62ee6831462844(options = {}) {
    const ref = (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).useRef();
    const observerInstance = (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).useRef();
    const [state, setState] = (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).useState({
        inView: false,
        entry: undefined,
        target: undefined
    });
    const { threshold: threshold, root: root, rootMargin: rootMargin } = options;
    const setRef = (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).useCallback((node)=>{
        observerInstance.current = new IntersectionObserver((entries)=>{
            if (entries && entries.length) {
                const intersection = entries[0];
                const { isIntersecting: isIntersecting, intersectionRatio: intersectionRatio } = intersection;
                if (intersectionRatio >= 0) {
                    // Note: `0` will be used here when an array of numbers is passed as the threshold, which doesn't feel right
                    const numericThreshold = typeof threshold === 'number' ? threshold : 0;
                    let inView = intersectionRatio >= numericThreshold;
                    if (isIntersecting !== undefined) inView = inView && isIntersecting;
                    setState({
                        inView: inView,
                        entry: intersection,
                        target: node
                    });
                }
            }
        }, {
            threshold: threshold,
            root: root,
            rootMargin: rootMargin
        });
        if (ref.current) observerInstance.current.unobserve(ref.current);
        if (node) observerInstance.current.observe(node);
        // Store a reference to the node
        ref.current = node;
    }, [
        threshold,
        root,
        rootMargin
    ]);
    /**
	 * Unsubscribe IntersectionObserver before unmounting a component.
	 */ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).useEffect(()=>{
        return ()=>{
            if (observerInstance.current && ref.current) observerInstance.current.unobserve(ref.current);
        };
    }, []);
    return [
        setRef,
        state.inView,
        state.target,
        state.entry
    ];
}

});



parcelRegister("aWDoc", function(module, exports) {

$parcel$export(module.exports, "ConsentBanner", () => $4b059d06b5eeee42$export$903b95b8397e77e9);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $f4cXA = parcelRequire("f4cXA");

var $bKCvK = parcelRequire("bKCvK");

var $VSDnB = parcelRequire("VSDnB");

var $Dyz2r = parcelRequire("Dyz2r");

var $6wmTk = parcelRequire("6wmTk");
const $4b059d06b5eeee42$export$903b95b8397e77e9 = (props)=>{
    if ((0, $VSDnB.fg)('platform_moonjelly_bsc_master_killswitch') || (0, $VSDnB.fg)('platform_moonjelly_bsc_ui_killswitch')) {
        const { onConsentBannerBailOut: onConsentBannerBailOut } = props;
        // eslint-disable-next-line react-hooks/rules-of-hooks
        (0, $5uXOq.useEffect)(()=>{
            onConsentBannerBailOut?.();
        }, [
            onConsentBannerBailOut
        ]);
        // Don't render the consent banner if the killswitch is enabled
        return null;
    }
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $f4cXA.ErrorBoundary), {
        FallbackComponent: ()=>/*#__PURE__*/ (0, $2OMIu.jsx)("div", {
                "data-testid": "consent-banner-render-error"
            }),
        onError: (e)=>{
            (0, $Dyz2r.Logger).errorWithOperationalEvent({
                action: 'renderConsentBannerError',
                message: e.message || ''
            });
        },
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $bKCvK.FlagsProvider), {
            children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $6wmTk.ConsentBannerImpl), {
                ...props
            })
        })
    });
};

});
parcelRegister("6wmTk", function(module, exports) {

$parcel$export(module.exports, "ConsentBannerImpl", () => $429e8dff35b76682$export$24af610f9b900e82);
/* eslint-disable @atlassian/tangerine/import/no-parent-imports */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $koVbs = parcelRequire("koVbs");

var $bKCvK = parcelRequire("bKCvK");

var $VSDnB = parcelRequire("VSDnB");

var $8eCQi = parcelRequire("8eCQi");

var $gMWuT = parcelRequire("gMWuT");
var $3MsQ9 = parcelRequire("3MsQ9");

var $djexG = parcelRequire("djexG");

var $Dyz2r = parcelRequire("Dyz2r");

var $21KEY = parcelRequire("21KEY");

var $61tZN = parcelRequire("61tZN");
var $4uHy1 = parcelRequire("4uHy1");

var $k49WR = parcelRequire("k49WR");

var $lhsMz = parcelRequire("lhsMz");

var $ajT7X = parcelRequire("ajT7X");

var $bLuwV = parcelRequire("bLuwV");

var $dAiBk = parcelRequire("dAiBk");

var $j4fP5 = parcelRequire("j4fP5");

var $faR9h = parcelRequire("faR9h");
const $429e8dff35b76682$export$24af610f9b900e82 = ({ onShow: onShow, onHide: onHide, initialPreferences: initialPreferences, minWidth: minWidth = 400, product: product, onConsentBannerBailOut: onConsentBannerBailOut, analyticsEnabled: analyticsEnabled = true, localConsentMode: localConsentMode = false, isSSRPrefetchImplemented: isSSRPrefetchImplemented = false })=>{
    const firstRender = (0, $5uXOq.useRef)(true);
    (0, $5uXOq.useEffect)(()=>{
        if (!firstRender.current) return;
        // Send an operational event if the banner is shown after previously having
        // been dismissed. This will help prevent issues with the banner
        // inappropriately reappearing.
        const lastBannerDismissal = (0, $4uHy1.getCookie)((0, $21KEY.ATLASSIAN_BANNER_LAST_DISMISSED_TIME_COOKIE_KEY));
        if (lastBannerDismissal) {
            const timeSinceDismissal = Date.now() - new Date(Number.parseInt(lastBannerDismissal)).getTime();
            const lessThanOneHour = timeSinceDismissal < 3600000;
            const lessThanOneDay = timeSinceDismissal < 86400000;
            const lessThanOneWeek = timeSinceDismissal < 604800000;
            (0, $3MsQ9.sendPackageOperationalEvent)({
                action: 'bannerAppearanceAfterDismissal',
                attributes: {
                    timeSinceDismissal: timeSinceDismissal,
                    lessThanOneHour: lessThanOneHour,
                    lessThanOneDay: lessThanOneDay,
                    lessThanOneWeek: lessThanOneWeek
                }
            });
            (0, $61tZN.deleteCookie)((0, $21KEY.ATLASSIAN_BANNER_LAST_DISMISSED_TIME_COOKIE_KEY));
        }
        firstRender.current = false;
    }, []);
    (0, $5uXOq.useEffect)(()=>{
        (0, $gMWuT.initializeGlobalState)({
            analyticsEnabled: analyticsEnabled,
            product: product,
            localConsentMode: localConsentMode
        });
    }, [
        analyticsEnabled,
        product,
        localConsentMode
    ]);
    const [isPreferencesModalOpen, setIsPreferencesModalOpen] = (0, $5uXOq.useState)(false);
    const intl = (0, $koVbs.default)();
    const { showFlag: showFlag } = (0, $bKCvK.useFlags)();
    const { preferences: preferences, isPrefetchedPreferencesState: isPrefetchedPreferencesState, isInitialRender: isInitialRender } = (0, $bLuwV.default)({
        initialPreferences: initialPreferences
    });
    const { showBanner: showBanner, setIsDismissed: setIsDismissed } = (0, $j4fP5.default)({
        preferences: preferences,
        isPrefetchedPreferencesState: isPrefetchedPreferencesState,
        initialPreferences: initialPreferences,
        isInitialRender: isInitialRender,
        isSSRPrefetchImplemented: isSSRPrefetchImplemented
    });
    const closePreferenceModal = (0, $5uXOq.useCallback)(()=>{
        setIsPreferencesModalOpen(false);
    }, [
        setIsPreferencesModalOpen
    ]);
    const onPreferenceModalSubmit = (0, $5uXOq.useCallback)(()=>{
        closePreferenceModal();
        setIsDismissed(true);
    }, [
        closePreferenceModal,
        setIsDismissed
    ]);
    const onClickPreferences = (0, $5uXOq.useCallback)(()=>{
        setIsPreferencesModalOpen(true);
        (0, $3MsQ9.sendUIEvent)({
            action: 'clicked',
            actionSubject: 'button',
            actionSubjectId: 'preferences',
            source: 'cookieConsentBanner'
        });
    }, []);
    const showSuccessFlag = (0, $5uXOq.useCallback)(()=>{
        if (localConsentMode) showFlag({
            ...(0, $8eCQi.successToastProps)(),
            id: 'cookieConsentBanner',
            description: intl.formatMessage((0, $lhsMz.i18n).successFlagDescriptionLocalOnly),
            title: intl.formatMessage((0, $lhsMz.i18n).successFlagTitle)
        });
        else showFlag({
            ...(0, $8eCQi.successToastProps)(),
            id: 'cookieConsentBanner',
            description: intl.formatMessage((0, $lhsMz.i18n).successFlagDescription),
            title: intl.formatMessage((0, $lhsMz.i18n).successFlagTitle)
        });
    }, [
        intl,
        localConsentMode,
        showFlag
    ]);
    const showErrorFlag = (0, $5uXOq.useCallback)(()=>{
        showFlag({
            ...(0, $8eCQi.errorToastProps)(),
            id: 'cookieConsentBanner',
            description: intl.formatMessage((0, $lhsMz.i18n).errorFlagDescription),
            title: intl.formatMessage((0, $lhsMz.i18n).errorFlagTitle)
        });
    }, [
        intl,
        showFlag
    ]);
    // Sets preferences to allow only Strictly Necessary cookies
    const onClickOnlyNecessary = (0, $5uXOq.useCallback)(async (displayedTextMap)=>{
        try {
            (0, $3MsQ9.sendUIEvent)({
                action: 'clicked',
                actionSubject: 'button',
                actionSubjectId: 'onlyNecessary',
                source: 'cookieConsentBanner'
            });
            await (0, $k49WR.updatePreferences)((0, $21KEY.ONLY_NECESSARY_PREFERENCES), displayedTextMap);
            (0, $3MsQ9.sendTrackEvent)({
                source: 'cookieConsentBanner',
                action: 'submitted',
                actionSubject: 'cookieConsentPreferences'
            });
            showSuccessFlag();
        } catch (e) {
            (0, $Dyz2r.Logger).errorWithOperationalEvent({
                action: 'updatePreferencesError',
                attributes: {
                    preferences: (0, $21KEY.ONLY_NECESSARY_PREFERENCES),
                    product: product
                },
                message: `Failed to update preferences from banner. ${e.message || ''}`
            });
            showErrorFlag();
        } finally{
            setIsDismissed(true);
        }
    }, [
        product,
        showErrorFlag,
        showSuccessFlag,
        setIsDismissed
    ]);
    // Sets preferences to allow all categories of cookies
    const onClickAcceptAll = (0, $5uXOq.useCallback)(async (displayedTextMap)=>{
        try {
            (0, $3MsQ9.sendUIEvent)({
                action: 'clicked',
                actionSubject: 'button',
                actionSubjectId: 'acceptAll',
                source: 'cookieConsentBanner'
            });
            await (0, $k49WR.updatePreferences)((0, $21KEY.ACCEPT_ALL_PREFERENCES), displayedTextMap);
            (0, $3MsQ9.sendTrackEvent)({
                source: 'cookieConsentBanner',
                action: 'submitted',
                actionSubject: 'cookieConsentPreferences'
            });
            showSuccessFlag();
        } catch (e) {
            (0, $Dyz2r.Logger).errorWithOperationalEvent({
                action: 'updatePreferencesError',
                attributes: {
                    preferences: (0, $21KEY.ACCEPT_ALL_PREFERENCES),
                    product: product
                },
                message: `Failed to update preferences from banner. ${e.message || ''}`
            });
            showErrorFlag();
        } finally{
            setIsDismissed(true);
        }
    }, [
        product,
        showErrorFlag,
        showSuccessFlag,
        setIsDismissed
    ]);
    const onClickTrackingNoticeLink = (0, $5uXOq.useCallback)(()=>{
        (0, $3MsQ9.sendUIEvent)({
            action: 'clicked',
            actionSubject: 'link',
            actionSubjectId: 'cookiesTrackingNotice',
            source: 'cookieConsentBanner'
        });
    }, []);
    // Call onShow/onHide as a side effect of showBanner changing, rather than
    // possibly having to call them in multiple places.
    const prevShowBanner = (0, $faR9h.default)(showBanner);
    (0, $5uXOq.useEffect)(()=>{
        if (showBanner && (!prevShowBanner || (0, $VSDnB.fg)('platform_fix_blank_cookie_banner_bug'))) onShow?.();
        else if (!showBanner && (prevShowBanner || (0, $VSDnB.fg)('platform_fix_blank_cookie_banner_bug'))) onHide?.();
    }, [
        showBanner,
        prevShowBanner,
        onShow,
        onHide
    ]);
    (0, $5uXOq.useEffect)(()=>{
        // when banner is not visible and isPrefetchedPreferencesState is in "resolved" state
        if (!showBanner && isPrefetchedPreferencesState !== undefined) // report "banner decided not to show" to sync decision with other components
        onConsentBannerBailOut?.();
    }, [
        showBanner,
        isPrefetchedPreferencesState,
        onConsentBannerBailOut
    ]);
    if (!showBanner) return null;
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $bKCvK.FlagsProvider), {
        children: /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $djexG.BSCIntlProvider), {
            children: [
                /*#__PURE__*/ (0, $2OMIu.jsx)((0, $dAiBk.PresentationalConsentBanner), {
                    onClickOnlyNecessary: onClickOnlyNecessary,
                    onClickAcceptAll: onClickAcceptAll,
                    onClickPreferences: onClickPreferences,
                    onClickTrackingNoticeLink: onClickTrackingNoticeLink,
                    minWidth: minWidth
                }),
                isPreferencesModalOpen && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ajT7X.PreferenceModal), {
                    onClose: closePreferenceModal,
                    onSubmit: onPreferenceModalSubmit,
                    showSuccessFlag: showSuccessFlag,
                    showErrorFlag: showErrorFlag
                })
            ]
        })
    });
};

});
parcelRegister("8eCQi", function(module, exports) {

$parcel$export(module.exports, "errorToastProps", () => $06a51a880a3faae2$export$c37f1e5051cd0bbc);
$parcel$export(module.exports, "warningToastProps", () => $06a51a880a3faae2$export$fe81a150e4e6ac02);
$parcel$export(module.exports, "infoToastProps", () => $06a51a880a3faae2$export$e70d6574d157a39b);
$parcel$export(module.exports, "successToastProps", () => $06a51a880a3faae2$export$b56198a940066d8f);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $8RXs9 = parcelRequire("8RXs9");

var $dD7Zc = parcelRequire("dD7Zc");

var $1jWct = parcelRequire("1jWct");

var $c2i4s = parcelRequire("c2i4s");

var $bU3PY = parcelRequire("bU3PY");

var $VSDnB = parcelRequire("VSDnB");


var $2bUsm = parcelRequire("2bUsm");
const $06a51a880a3faae2$var$ErrorWithIntl = (0, $8RXs9.default)(({ intl: intl })=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($dD7Zc))), {
        color: `var(--ds-icon-danger, ${(0, $829f609a65d26a98$export$4a7404f376229999)})`,
        LEGACY_size: "medium",
        label: intl.formatMessage((0, $2bUsm.default).error),
        spacing: (0, $VSDnB.fg)('eoc-visual-refresh-phase-two') ? 'spacious' : 'none'
    }));
const $06a51a880a3faae2$var$WarningWithIntl = (0, $8RXs9.default)(({ intl: intl })=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($bU3PY))), {
        color: `var(--ds-icon-warning, ${(0, $829f609a65d26a98$export$c6930421db9fa514)})`,
        LEGACY_size: "medium",
        label: intl.formatMessage((0, $2bUsm.default).warning),
        spacing: (0, $VSDnB.fg)('eoc-visual-refresh-phase-two') ? 'spacious' : 'none'
    }));
const $06a51a880a3faae2$var$InfoWithIntl = (0, $8RXs9.default)(({ intl: intl })=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($1jWct))), {
        color: `var(--ds-icon-discovery, ${(0, $829f609a65d26a98$export$b48405b95304b5a1)})`,
        LEGACY_size: "medium",
        label: intl.formatMessage((0, $2bUsm.default).info),
        spacing: (0, $VSDnB.fg)('eoc-visual-refresh-phase-two') ? 'spacious' : 'none'
    }));
const $06a51a880a3faae2$var$SuccessWithIntl = (0, $8RXs9.default)(({ intl: intl })=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($c2i4s))), {
        color: `var(--ds-icon-success, ${(0, $829f609a65d26a98$export$940e1f69e873f202)})`,
        LEGACY_size: "medium",
        label: intl.formatMessage((0, $2bUsm.default).success),
        spacing: (0, $VSDnB.fg)('eoc-visual-refresh-phase-two') ? 'spacious' : 'none'
    }));
const $06a51a880a3faae2$export$c37f1e5051cd0bbc = ()=>({
        icon: /*#__PURE__*/ (0, $2OMIu.jsx)($06a51a880a3faae2$var$ErrorWithIntl, {}),
        appearance: 'normal'
    });
const $06a51a880a3faae2$export$fe81a150e4e6ac02 = ()=>({
        icon: /*#__PURE__*/ (0, $2OMIu.jsx)($06a51a880a3faae2$var$WarningWithIntl, {}),
        appearance: 'normal'
    });
const $06a51a880a3faae2$export$e70d6574d157a39b = ()=>({
        icon: /*#__PURE__*/ (0, $2OMIu.jsx)($06a51a880a3faae2$var$InfoWithIntl, {}),
        appearance: 'normal'
    });
const $06a51a880a3faae2$export$b56198a940066d8f = ()=>({
        icon: /*#__PURE__*/ (0, $2OMIu.jsx)($06a51a880a3faae2$var$SuccessWithIntl, {}),
        appearance: 'normal',
        isAutoDismiss: true
    });

});
var $829f609a65d26a98$exports = {};

$parcel$export($829f609a65d26a98$exports, "R50", () => $829f609a65d26a98$export$4b84fd0e2c617bd);
$parcel$export($829f609a65d26a98$exports, "R75", () => $829f609a65d26a98$export$b34b069eff244586);
$parcel$export($829f609a65d26a98$exports, "R100", () => $829f609a65d26a98$export$be802dd0d8b57f35);
$parcel$export($829f609a65d26a98$exports, "R200", () => $829f609a65d26a98$export$60847d42f9da92a6);
$parcel$export($829f609a65d26a98$exports, "R300", () => $829f609a65d26a98$export$4a7404f376229999);
$parcel$export($829f609a65d26a98$exports, "R400", () => $829f609a65d26a98$export$2010d0fb4295b346);
$parcel$export($829f609a65d26a98$exports, "R500", () => $829f609a65d26a98$export$2837b5a1a71d5c02);
$parcel$export($829f609a65d26a98$exports, "Y50", () => $829f609a65d26a98$export$8d9596b529bbb9cf);
$parcel$export($829f609a65d26a98$exports, "Y75", () => $829f609a65d26a98$export$41060a744ab0b7ae);
$parcel$export($829f609a65d26a98$exports, "Y100", () => $829f609a65d26a98$export$1cc05bbbf340e559);
$parcel$export($829f609a65d26a98$exports, "Y200", () => $829f609a65d26a98$export$5aae31392d72caaa);
$parcel$export($829f609a65d26a98$exports, "Y300", () => $829f609a65d26a98$export$c6930421db9fa514);
$parcel$export($829f609a65d26a98$exports, "Y400", () => $829f609a65d26a98$export$59619663aa6500fb);
$parcel$export($829f609a65d26a98$exports, "Y500", () => $829f609a65d26a98$export$874739ea9e379ab6);
$parcel$export($829f609a65d26a98$exports, "G50", () => $829f609a65d26a98$export$8a6341c32b6a3ee6);
$parcel$export($829f609a65d26a98$exports, "G75", () => $829f609a65d26a98$export$69a3bf21b9686c2b);
$parcel$export($829f609a65d26a98$exports, "G100", () => $829f609a65d26a98$export$afbce1382ec95f73);
$parcel$export($829f609a65d26a98$exports, "G200", () => $829f609a65d26a98$export$747d86715d4175de);
$parcel$export($829f609a65d26a98$exports, "G300", () => $829f609a65d26a98$export$940e1f69e873f202);
$parcel$export($829f609a65d26a98$exports, "G400", () => $829f609a65d26a98$export$a49394138f7b8e85);
$parcel$export($829f609a65d26a98$exports, "G500", () => $829f609a65d26a98$export$6fa04827ac68a4fb);
$parcel$export($829f609a65d26a98$exports, "B50", () => $829f609a65d26a98$export$226de0355ed012f8);
$parcel$export($829f609a65d26a98$exports, "B75", () => $829f609a65d26a98$export$8c13c2ee36917869);
$parcel$export($829f609a65d26a98$exports, "B100", () => $829f609a65d26a98$export$ecfc1dff386a3e7a);
$parcel$export($829f609a65d26a98$exports, "B200", () => $829f609a65d26a98$export$215b7063051591f1);
$parcel$export($829f609a65d26a98$exports, "B300", () => $829f609a65d26a98$export$e62e8919cca44969);
$parcel$export($829f609a65d26a98$exports, "B400", () => $829f609a65d26a98$export$b3de0ae08da2ce64);
$parcel$export($829f609a65d26a98$exports, "B500", () => $829f609a65d26a98$export$a6ee3d71bc067634);
$parcel$export($829f609a65d26a98$exports, "B600", () => $829f609a65d26a98$export$67f15409e87642a1);
$parcel$export($829f609a65d26a98$exports, "B700", () => $829f609a65d26a98$export$f0539dbc42dbb067);
$parcel$export($829f609a65d26a98$exports, "P50", () => $829f609a65d26a98$export$363e4475840015bb);
$parcel$export($829f609a65d26a98$exports, "P75", () => $829f609a65d26a98$export$4b0a4417ed59760f);
$parcel$export($829f609a65d26a98$exports, "P100", () => $829f609a65d26a98$export$6011520a64d9a187);
$parcel$export($829f609a65d26a98$exports, "P200", () => $829f609a65d26a98$export$a7175d4e9206bc80);
$parcel$export($829f609a65d26a98$exports, "P300", () => $829f609a65d26a98$export$b48405b95304b5a1);
$parcel$export($829f609a65d26a98$exports, "P400", () => $829f609a65d26a98$export$c71e4279dd54a18d);
$parcel$export($829f609a65d26a98$exports, "P500", () => $829f609a65d26a98$export$147899de772240ec);
$parcel$export($829f609a65d26a98$exports, "T50", () => $829f609a65d26a98$export$2cf711fe14c66f06);
$parcel$export($829f609a65d26a98$exports, "T75", () => $829f609a65d26a98$export$7a8f4d33f6f9772c);
$parcel$export($829f609a65d26a98$exports, "T100", () => $829f609a65d26a98$export$776c9c497ef08533);
$parcel$export($829f609a65d26a98$exports, "T200", () => $829f609a65d26a98$export$69cb3ca10c1e330e);
$parcel$export($829f609a65d26a98$exports, "T300", () => $829f609a65d26a98$export$9dc1ef0f3f48059b);
$parcel$export($829f609a65d26a98$exports, "T400", () => $829f609a65d26a98$export$7c835c78b6fcdef8);
$parcel$export($829f609a65d26a98$exports, "T500", () => $829f609a65d26a98$export$6036577f95c3877e);
$parcel$export($829f609a65d26a98$exports, "N0", () => $829f609a65d26a98$export$29a4f05edc054374);
$parcel$export($829f609a65d26a98$exports, "N10", () => $829f609a65d26a98$export$e655ef011c4aa1a2);
$parcel$export($829f609a65d26a98$exports, "N20", () => $829f609a65d26a98$export$9fdfb749e33cdf97);
$parcel$export($829f609a65d26a98$exports, "N30", () => $829f609a65d26a98$export$3e51e8f1440314ba);
$parcel$export($829f609a65d26a98$exports, "N40", () => $829f609a65d26a98$export$1ce2d1575d444ceb);
$parcel$export($829f609a65d26a98$exports, "N50", () => $829f609a65d26a98$export$8754fc7e6d8b3000);
$parcel$export($829f609a65d26a98$exports, "N60", () => $829f609a65d26a98$export$c2e91cbeada39b8b);
$parcel$export($829f609a65d26a98$exports, "N70", () => $829f609a65d26a98$export$5f71e19f3a7ad9de);
$parcel$export($829f609a65d26a98$exports, "N80", () => $829f609a65d26a98$export$eaa8c8a70ac22806);
$parcel$export($829f609a65d26a98$exports, "N90", () => $829f609a65d26a98$export$7c87d337fb91a97d);
$parcel$export($829f609a65d26a98$exports, "N100", () => $829f609a65d26a98$export$d6447c357493214f);
$parcel$export($829f609a65d26a98$exports, "N200", () => $829f609a65d26a98$export$f563ee71e9ee74cd);
$parcel$export($829f609a65d26a98$exports, "N300", () => $829f609a65d26a98$export$e2ef2124cf4024b1);
$parcel$export($829f609a65d26a98$exports, "N400", () => $829f609a65d26a98$export$eece5f492e429f08);
$parcel$export($829f609a65d26a98$exports, "N500", () => $829f609a65d26a98$export$c39c0fe0f26207ae);
$parcel$export($829f609a65d26a98$exports, "N600", () => $829f609a65d26a98$export$7090862dc3038a9f);
$parcel$export($829f609a65d26a98$exports, "N700", () => $829f609a65d26a98$export$ad0bacf983b7ddaa);
$parcel$export($829f609a65d26a98$exports, "N800", () => $829f609a65d26a98$export$7d61b15e0da132af);
$parcel$export($829f609a65d26a98$exports, "N900", () => $829f609a65d26a98$export$fbda843f0a27fe96);
$parcel$export($829f609a65d26a98$exports, "N10A", () => $829f609a65d26a98$export$791e57b27ca738ef);
$parcel$export($829f609a65d26a98$exports, "N20A", () => $829f609a65d26a98$export$8d43898f60b96a82);
$parcel$export($829f609a65d26a98$exports, "N30A", () => $829f609a65d26a98$export$920c0d5c49070351);
$parcel$export($829f609a65d26a98$exports, "N40A", () => $829f609a65d26a98$export$46987b49aab6d1a8);
$parcel$export($829f609a65d26a98$exports, "N50A", () => $829f609a65d26a98$export$7d3359664e8bb0e5);
$parcel$export($829f609a65d26a98$exports, "N60A", () => $829f609a65d26a98$export$d2d3bedfb276cac0);
$parcel$export($829f609a65d26a98$exports, "N70A", () => $829f609a65d26a98$export$6e5e7499ff054f6d);
$parcel$export($829f609a65d26a98$exports, "N80A", () => $829f609a65d26a98$export$59264b346c877fa7);
$parcel$export($829f609a65d26a98$exports, "N90A", () => $829f609a65d26a98$export$d092757d7c64925c);
$parcel$export($829f609a65d26a98$exports, "N100A", () => $829f609a65d26a98$export$486ab785e4bac3c6);
$parcel$export($829f609a65d26a98$exports, "N200A", () => $829f609a65d26a98$export$fba592bbc6419fea);
$parcel$export($829f609a65d26a98$exports, "N300A", () => $829f609a65d26a98$export$13609db0e6812ab8);
$parcel$export($829f609a65d26a98$exports, "N400A", () => $829f609a65d26a98$export$fbae4efaa892d883);
$parcel$export($829f609a65d26a98$exports, "N500A", () => $829f609a65d26a98$export$f13946d26f440ce6);
$parcel$export($829f609a65d26a98$exports, "N600A", () => $829f609a65d26a98$export$19f58225ac52a306);
$parcel$export($829f609a65d26a98$exports, "N700A", () => $829f609a65d26a98$export$6384f09da70e7b62);
$parcel$export($829f609a65d26a98$exports, "N800A", () => $829f609a65d26a98$export$d0dccc730683edc2);
$parcel$export($829f609a65d26a98$exports, "DN900", () => $829f609a65d26a98$export$2f6319cf7d736c2a);
$parcel$export($829f609a65d26a98$exports, "DN800", () => $829f609a65d26a98$export$95126bc8884d6634);
$parcel$export($829f609a65d26a98$exports, "DN700", () => $829f609a65d26a98$export$8338d8c35d44ff1);
$parcel$export($829f609a65d26a98$exports, "DN600", () => $829f609a65d26a98$export$5368d76ae4fbbda7);
$parcel$export($829f609a65d26a98$exports, "DN500", () => $829f609a65d26a98$export$9f0a771d16ec8d36);
$parcel$export($829f609a65d26a98$exports, "DN400", () => $829f609a65d26a98$export$abcf8c38338b4aa5);
$parcel$export($829f609a65d26a98$exports, "DN300", () => $829f609a65d26a98$export$97e81faa16a182c7);
$parcel$export($829f609a65d26a98$exports, "DN200", () => $829f609a65d26a98$export$bfe21c59123ecf33);
$parcel$export($829f609a65d26a98$exports, "DN100", () => $829f609a65d26a98$export$ee82aa2ea6a1558);
$parcel$export($829f609a65d26a98$exports, "DN90", () => $829f609a65d26a98$export$682927c6ed76be02);
$parcel$export($829f609a65d26a98$exports, "DN80", () => $829f609a65d26a98$export$91fd9994c5be9757);
$parcel$export($829f609a65d26a98$exports, "DN70", () => $829f609a65d26a98$export$d281fbfe3cff2df6);
$parcel$export($829f609a65d26a98$exports, "DN60", () => $829f609a65d26a98$export$3902c91d8b98a753);
$parcel$export($829f609a65d26a98$exports, "DN50", () => $829f609a65d26a98$export$8e8133c1ba5845b5);
$parcel$export($829f609a65d26a98$exports, "DN40", () => $829f609a65d26a98$export$33ff357f6620b39);
$parcel$export($829f609a65d26a98$exports, "DN30", () => $829f609a65d26a98$export$633847cf062b69e0);
$parcel$export($829f609a65d26a98$exports, "DN20", () => $829f609a65d26a98$export$9776a6e503bdbf76);
$parcel$export($829f609a65d26a98$exports, "DN10", () => $829f609a65d26a98$export$6c813d5160dff5db);
$parcel$export($829f609a65d26a98$exports, "DN0", () => $829f609a65d26a98$export$3d4f271a500072a);
$parcel$export($829f609a65d26a98$exports, "DN800A", () => $829f609a65d26a98$export$fe151285c22759ec);
$parcel$export($829f609a65d26a98$exports, "DN700A", () => $829f609a65d26a98$export$a101c6190d0da34);
$parcel$export($829f609a65d26a98$exports, "DN600A", () => $829f609a65d26a98$export$4b16f52932fda51);
$parcel$export($829f609a65d26a98$exports, "DN500A", () => $829f609a65d26a98$export$a74bcd7b9845b0d8);
$parcel$export($829f609a65d26a98$exports, "DN400A", () => $829f609a65d26a98$export$9209c179316d1751);
$parcel$export($829f609a65d26a98$exports, "DN300A", () => $829f609a65d26a98$export$88f55133f636c8dd);
$parcel$export($829f609a65d26a98$exports, "DN200A", () => $829f609a65d26a98$export$51126f85d1009512);
$parcel$export($829f609a65d26a98$exports, "DN100A", () => $829f609a65d26a98$export$a069b547bd23af78);
$parcel$export($829f609a65d26a98$exports, "DN90A", () => $829f609a65d26a98$export$40cce05af3b2600a);
$parcel$export($829f609a65d26a98$exports, "DN80A", () => $829f609a65d26a98$export$b78942185925a0d);
$parcel$export($829f609a65d26a98$exports, "DN70A", () => $829f609a65d26a98$export$e058fb44b8eaafca);
$parcel$export($829f609a65d26a98$exports, "DN60A", () => $829f609a65d26a98$export$92b0b8de26920c18);
$parcel$export($829f609a65d26a98$exports, "DN50A", () => $829f609a65d26a98$export$67564f7459d3fc9e);
$parcel$export($829f609a65d26a98$exports, "DN40A", () => $829f609a65d26a98$export$77868e1ca884ffa3);
$parcel$export($829f609a65d26a98$exports, "DN30A", () => $829f609a65d26a98$export$2afd71d7d3ea2cd5);
$parcel$export($829f609a65d26a98$exports, "DN20A", () => $829f609a65d26a98$export$f2a0acaab9972c70);
$parcel$export($829f609a65d26a98$exports, "DN10A", () => $829f609a65d26a98$export$9ab70e67d6475361);
$parcel$export($829f609a65d26a98$exports, "T30", () => $829f609a65d26a98$export$d2adc5dedf09fced);
$parcel$export($829f609a65d26a98$exports, "L50", () => $829f609a65d26a98$export$f51762073d2bb381);
$parcel$export($829f609a65d26a98$exports, "L75", () => $829f609a65d26a98$export$95e26d54def96891);
// Reds
const $829f609a65d26a98$export$4b84fd0e2c617bd = '#FFEBE6';
const $829f609a65d26a98$export$b34b069eff244586 = '#FFBDAD';
const $829f609a65d26a98$export$be802dd0d8b57f35 = '#FF8F73';
const $829f609a65d26a98$export$60847d42f9da92a6 = '#FF7452';
const $829f609a65d26a98$export$4a7404f376229999 = '#FF5630';
const $829f609a65d26a98$export$2010d0fb4295b346 = '#DE350B';
const $829f609a65d26a98$export$2837b5a1a71d5c02 = '#BF2600';
const $829f609a65d26a98$export$8d9596b529bbb9cf = '#FFFAE6';
const $829f609a65d26a98$export$41060a744ab0b7ae = '#FFF0B3';
const $829f609a65d26a98$export$1cc05bbbf340e559 = '#FFE380';
const $829f609a65d26a98$export$5aae31392d72caaa = '#FFC400';
const $829f609a65d26a98$export$c6930421db9fa514 = '#FFAB00';
const $829f609a65d26a98$export$59619663aa6500fb = '#FF991F';
const $829f609a65d26a98$export$874739ea9e379ab6 = '#FF8B00';
const $829f609a65d26a98$export$8a6341c32b6a3ee6 = '#E3FCEF';
const $829f609a65d26a98$export$69a3bf21b9686c2b = '#ABF5D1';
const $829f609a65d26a98$export$afbce1382ec95f73 = '#79F2C0';
const $829f609a65d26a98$export$747d86715d4175de = '#57D9A3';
const $829f609a65d26a98$export$940e1f69e873f202 = '#36B37E';
const $829f609a65d26a98$export$a49394138f7b8e85 = '#00875A';
const $829f609a65d26a98$export$6fa04827ac68a4fb = '#006644';
const $829f609a65d26a98$export$226de0355ed012f8 = '#DEEBFF';
const $829f609a65d26a98$export$8c13c2ee36917869 = '#B3D4FF';
const $829f609a65d26a98$export$ecfc1dff386a3e7a = '#4C9AFF';
const $829f609a65d26a98$export$215b7063051591f1 = '#2684FF';
const $829f609a65d26a98$export$e62e8919cca44969 = '#0065FF';
const $829f609a65d26a98$export$b3de0ae08da2ce64 = '#0052CC';
const $829f609a65d26a98$export$a6ee3d71bc067634 = '#0747A6';
const $829f609a65d26a98$export$67f15409e87642a1 = '#669DF1';
const $829f609a65d26a98$export$f0539dbc42dbb067 = '#8FB8F6';
const $829f609a65d26a98$export$363e4475840015bb = '#EAE6FF';
const $829f609a65d26a98$export$4b0a4417ed59760f = '#C0B6F2';
const $829f609a65d26a98$export$6011520a64d9a187 = '#998DD9';
const $829f609a65d26a98$export$a7175d4e9206bc80 = '#8777D9';
const $829f609a65d26a98$export$b48405b95304b5a1 = '#6554C0';
const $829f609a65d26a98$export$c71e4279dd54a18d = '#5243AA';
const $829f609a65d26a98$export$147899de772240ec = '#403294';
const $829f609a65d26a98$export$2cf711fe14c66f06 = '#E6FCFF';
const $829f609a65d26a98$export$7a8f4d33f6f9772c = '#B3F5FF';
const $829f609a65d26a98$export$776c9c497ef08533 = '#79E2F2';
const $829f609a65d26a98$export$69cb3ca10c1e330e = '#00C7E6';
const $829f609a65d26a98$export$9dc1ef0f3f48059b = '#00B8D9';
const $829f609a65d26a98$export$7c835c78b6fcdef8 = '#00A3BF';
const $829f609a65d26a98$export$6036577f95c3877e = '#008DA6';
const $829f609a65d26a98$export$29a4f05edc054374 = '#FFFFFF';
const $829f609a65d26a98$export$e655ef011c4aa1a2 = '#FAFBFC';
const $829f609a65d26a98$export$9fdfb749e33cdf97 = '#F4F5F7';
const $829f609a65d26a98$export$3e51e8f1440314ba = '#EBECF0';
const $829f609a65d26a98$export$1ce2d1575d444ceb = '#DFE1E6';
const $829f609a65d26a98$export$8754fc7e6d8b3000 = '#C1C7D0';
const $829f609a65d26a98$export$c2e91cbeada39b8b = '#B3BAC5';
const $829f609a65d26a98$export$5f71e19f3a7ad9de = '#A5ADBA';
const $829f609a65d26a98$export$eaa8c8a70ac22806 = '#97A0AF';
const $829f609a65d26a98$export$7c87d337fb91a97d = '#8993A4';
const $829f609a65d26a98$export$d6447c357493214f = '#7A869A';
const $829f609a65d26a98$export$f563ee71e9ee74cd = '#6B778C';
const $829f609a65d26a98$export$e2ef2124cf4024b1 = '#5E6C84';
const $829f609a65d26a98$export$eece5f492e429f08 = '#505F79';
const $829f609a65d26a98$export$c39c0fe0f26207ae = '#42526E';
const $829f609a65d26a98$export$7090862dc3038a9f = '#344563';
const $829f609a65d26a98$export$ad0bacf983b7ddaa = '#253858';
const $829f609a65d26a98$export$7d61b15e0da132af = '#172B4D';
const $829f609a65d26a98$export$fbda843f0a27fe96 = '#091E42';
const $829f609a65d26a98$export$791e57b27ca738ef = 'rgba(9, 30, 66, 0.02)';
const $829f609a65d26a98$export$8d43898f60b96a82 = 'rgba(9, 30, 66, 0.04)';
const $829f609a65d26a98$export$920c0d5c49070351 = 'rgba(9, 30, 66, 0.08)';
const $829f609a65d26a98$export$46987b49aab6d1a8 = 'rgba(9, 30, 66, 0.13)';
const $829f609a65d26a98$export$7d3359664e8bb0e5 = 'rgba(9, 30, 66, 0.25)';
const $829f609a65d26a98$export$d2d3bedfb276cac0 = 'rgba(9, 30, 66, 0.31)';
const $829f609a65d26a98$export$6e5e7499ff054f6d = 'rgba(9, 30, 66, 0.36)';
const $829f609a65d26a98$export$59264b346c877fa7 = 'rgba(9, 30, 66, 0.42)';
const $829f609a65d26a98$export$d092757d7c64925c = 'rgba(9, 30, 66, 0.48)';
const $829f609a65d26a98$export$486ab785e4bac3c6 = 'rgba(9, 30, 66, 0.54)';
const $829f609a65d26a98$export$fba592bbc6419fea = 'rgba(9, 30, 66, 0.60)';
const $829f609a65d26a98$export$13609db0e6812ab8 = 'rgba(9, 30, 66, 0.66)';
const $829f609a65d26a98$export$fbae4efaa892d883 = 'rgba(9, 30, 66, 0.71)';
const $829f609a65d26a98$export$f13946d26f440ce6 = 'rgba(9, 30, 66, 0.77)';
const $829f609a65d26a98$export$19f58225ac52a306 = 'rgba(9, 30, 66, 0.82)';
const $829f609a65d26a98$export$6384f09da70e7b62 = 'rgba(9, 30, 66, 0.89)';
const $829f609a65d26a98$export$d0dccc730683edc2 = 'rgba(9, 30, 66, 0.95)';
const $829f609a65d26a98$export$2f6319cf7d736c2a = '#E6EDFA';
const $829f609a65d26a98$export$95126bc8884d6634 = '#DCE5F5';
const $829f609a65d26a98$export$8338d8c35d44ff1 = '#CED9EB';
const $829f609a65d26a98$export$5368d76ae4fbbda7 = '#B8C7E0';
const $829f609a65d26a98$export$9f0a771d16ec8d36 = '#ABBBD6';
const $829f609a65d26a98$export$abcf8c38338b4aa5 = '#9FB0CC';
const $829f609a65d26a98$export$97e81faa16a182c7 = '#8C9CB8';
const $829f609a65d26a98$export$bfe21c59123ecf33 = '#7988A3';
const $829f609a65d26a98$export$ee82aa2ea6a1558 = '#67758F';
const $829f609a65d26a98$export$682927c6ed76be02 = '#56637A';
const $829f609a65d26a98$export$91fd9994c5be9757 = '#455166';
const $829f609a65d26a98$export$d281fbfe3cff2df6 = '#3B475C';
const $829f609a65d26a98$export$3902c91d8b98a753 = '#313D52';
const $829f609a65d26a98$export$8e8133c1ba5845b5 = '#283447';
const $829f609a65d26a98$export$33ff357f6620b39 = '#202B3D';
const $829f609a65d26a98$export$633847cf062b69e0 = '#1B2638';
const $829f609a65d26a98$export$9776a6e503bdbf76 = '#121A29';
const $829f609a65d26a98$export$6c813d5160dff5db = '#0E1624';
const $829f609a65d26a98$export$3d4f271a500072a = '#0D1424';
const $829f609a65d26a98$export$fe151285c22759ec = 'rgba(13, 20, 36, 0.06)';
const $829f609a65d26a98$export$a101c6190d0da34 = 'rgba(13, 20, 36, 0.14)';
const $829f609a65d26a98$export$4b16f52932fda51 = 'rgba(13, 20, 36, 0.18)';
const $829f609a65d26a98$export$a74bcd7b9845b0d8 = 'rgba(13, 20, 36, 0.29)';
const $829f609a65d26a98$export$9209c179316d1751 = 'rgba(13, 20, 36, 0.36)';
const $829f609a65d26a98$export$88f55133f636c8dd = 'rgba(13, 20, 36, 0.40)';
const $829f609a65d26a98$export$51126f85d1009512 = 'rgba(13, 20, 36, 0.47)';
const $829f609a65d26a98$export$a069b547bd23af78 = 'rgba(13, 20, 36, 0.53)';
const $829f609a65d26a98$export$40cce05af3b2600a = 'rgba(13, 20, 36, 0.63)';
const $829f609a65d26a98$export$b78942185925a0d = 'rgba(13, 20, 36, 0.73)';
const $829f609a65d26a98$export$e058fb44b8eaafca = 'rgba(13, 20, 36, 0.78)';
const $829f609a65d26a98$export$92b0b8de26920c18 = 'rgba(13, 20, 36, 0.81)';
const $829f609a65d26a98$export$67564f7459d3fc9e = 'rgba(13, 20, 36, 0.85)';
const $829f609a65d26a98$export$77868e1ca884ffa3 = 'rgba(13, 20, 36, 0.89)';
const $829f609a65d26a98$export$2afd71d7d3ea2cd5 = 'rgba(13, 20, 36, 0.92)';
const $829f609a65d26a98$export$f2a0acaab9972c70 = 'rgba(13, 20, 36, 0.95)';
const $829f609a65d26a98$export$9ab70e67d6475361 = 'rgba(13, 20, 36, 0.97)';
const $829f609a65d26a98$export$d2adc5dedf09fced = '#292A2E';
const $829f609a65d26a98$export$f51762073d2bb381 = '#94C748';
const $829f609a65d26a98$export$95e26d54def96891 = '#B3DF72';

parcelRegister("2bUsm", function(module, exports) {

$parcel$export(module.exports, "default", () => $7145ce6f0cfaef60$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
const $7145ce6f0cfaef60$var$messages = (0, $7VHMR.defineMessages)({
    error: {
        id: 'eoc.common.toast.error',
        defaultMessage: 'Error',
        description: 'The title for an error as a single word.'
    },
    warning: {
        id: 'eoc.common.toast.warning',
        defaultMessage: 'Warning',
        description: 'The title for a warning as a single word.'
    },
    success: {
        id: 'eoc.common.toast.success',
        defaultMessage: 'Success',
        description: 'The title for success as a single word.'
    },
    info: {
        id: 'eoc.common.toast.info',
        defaultMessage: 'Information',
        description: 'The title for an information as a single word.'
    }
});
var $7145ce6f0cfaef60$export$2e2bcd8739ae039 = $7145ce6f0cfaef60$var$messages;

});


parcelRegister("djexG", function(module, exports) {

$parcel$export(module.exports, "BSCIntlProvider", () => $d9b84b1a7fd55cdf$export$9aa38aed134c207f);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $96nTn = parcelRequire("96nTn");

var $7UrIA = parcelRequire("7UrIA");

var $9tzb4 = parcelRequire("9tzb4");
const $d9b84b1a7fd55cdf$export$9aa38aed134c207f = ({ children: children })=>{
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $96nTn.default), {
        defaultMessages: (0, $7UrIA.default),
        loaderFn: (0, $9tzb4.fetchMessagesForLocale),
        children: children
    });
};

});
parcelRegister("7UrIA", function(module, exports) {

$parcel$export(module.exports, "default", () => $bf2ad8d7b0129a3e$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //
var $bf2ad8d7b0129a3e$export$2e2bcd8739ae039 = {
    'browser-storage-controls.consent-banner-modal.analytical.description.101024': 'Measures usage to improve product performance.',
    'browser-storage-controls.consent-banner-modal.analytical.option.082624': 'Allow analytical cookies',
    'browser-storage-controls.consent-banner-modal.cancel.button': 'Cancel',
    'browser-storage-controls.consent-banner-modal.confirm.button': 'Confirm',
    'browser-storage-controls.consent-banner-modal.functional.description.082624': 'Provides enhanced functionality and personalization.',
    'browser-storage-controls.consent-banner-modal.functional.option.082624': 'Allow functional cookies',
    'browser-storage-controls.consent-banner-modal.marketing.description.082624': 'Used for targeted advertising.',
    'browser-storage-controls.consent-banner-modal.marketing.option.082624': 'Allow marketing cookies',
    'browser-storage-controls.consent-banner-modal.strict.description.082624': "Atlassian tracks <bold>strictly necessary</bold> cookies that are essential for our products to function, so you can't adjust these. These cookies don't store personally identifiable information or track browsing habits.",
    'browser-storage-controls.consent-banner-modal.summary.description.082624': 'Because we value your privacy, you can select which cookies you allow. {link}',
    'browser-storage-controls.consent-banner-modal.title': 'Cookie preferences',
    'browser-storage-controls.consent-banner-modal.tracking.link.082624': 'Review our cookies and tracking notice',
    'browser-storage-controls.consent-banner.accept-all.button': 'Accept all',
    'browser-storage-controls.consent-banner.cookies-description.text': 'Atlassian uses cookies to improve your browsing experience, perform analytics and research, and conduct advertising. Accept all cookies to indicate that you agree to our use of cookies on your device. {linkToCookiesTrackingNotice}',
    'browser-storage-controls.consent-banner.cookies-tracking-notice.text.101024': 'Atlassian cookies and tracking notice',
    'browser-storage-controls.consent-banner.error-flag.description': 'Try again in a few minutes.',
    'browser-storage-controls.consent-banner.error-flag.title': "We're unable to update the policy",
    'browser-storage-controls.consent-banner.only-necessary.button': 'Only necessary',
    'browser-storage-controls.consent-banner.preferences.button': 'Preferences',
    'browser-storage-controls.consent-banner.success-flag.description': 'You can change this at any time in your Atlassian account.',
    'browser-storage-controls.consent-banner.success-flag.description-local-only': 'Your preferences will only affect this site.',
    'browser-storage-controls.consent-banner.success-flag.title': 'Cookie preferences saved'
};

});

parcelRegister("9tzb4", function(module, exports) {

$parcel$export(module.exports, "fetchMessagesForLocale", () => $113ce03047996193$export$2b153a2030b0feb2);
const $113ce03047996193$export$2b153a2030b0feb2 = async (locale)=>{
    try {
        const messages = await import(/* webpackChunkName: "@atlaskit-internal_browser-storage-controls" */ `../../../i18n/${locale}`);
        return messages.default;
    } catch (e) {
    // ignore
    }
    try {
        const parentLocale = locale.split(/[-_]/)[0];
        const messages = await import(/* webpackChunkName: "@atlaskit-internal_browser-storage-controls" */ `../../../i18n/${parentLocale}`);
        return messages.default;
    } catch (e) {
    // ignore
    }
};

});


parcelRegister("61tZN", function(module, exports) {

$parcel$export(module.exports, "deleteCookie", () => $2b041de1366f03a9$export$b43e45590305ffaa);

var $eYli8 = parcelRequire("eYli8");

var $VSDnB = parcelRequire("VSDnB");

var $3MsQ9 = parcelRequire("3MsQ9");

var $Dyz2r = parcelRequire("Dyz2r");
const $2b041de1366f03a9$export$b43e45590305ffaa = (key, attributes)=>{
    if ((0, $VSDnB.fg)('platform_moonjelly_bsc_master_killswitch')) // Delete the cookie without package operational events
    // when master killswitch is enabled
    (0, (/*@__PURE__*/$parcel$interopDefault($eYli8))).remove(key, attributes);
    else try {
        (0, $3MsQ9.sendPackageOperationalEvent)({
            action: 'usedDeleteCookie',
            attributes: {
                cookieKey: key
            }
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($eYli8))).remove(key, attributes);
    } catch (e) {
        (0, $Dyz2r.Logger).errorWithOperationalEvent({
            action: 'usedDeleteCookieError',
            attributes: {
                cookieKey: key
            },
            message: `Failed to use delete cookie. ${e.message || ''}`
        });
    }
};

});

parcelRegister("k49WR", function(module, exports) {

$parcel$export(module.exports, "updatePreferences", () => $c286b237a219cb9c$export$7bb3e177c1a1e841);

var $gMWuT = parcelRequire("gMWuT");

var $21KEY = parcelRequire("21KEY");

var $8FFpF = parcelRequire("8FFpF");

var $gZtVL = parcelRequire("gZtVL");

var $7RRGT = parcelRequire("7RRGT");

var $gHrGQ = parcelRequire("gHrGQ");
const $c286b237a219cb9c$var$emptyDisplayedTextMap = {
    [(0, $8FFpF.PreferenceCategory).Analytics]: '',
    [(0, $8FFpF.PreferenceCategory).Functional]: '',
    [(0, $8FFpF.PreferenceCategory).Marketing]: '',
    [(0, $8FFpF.PreferenceCategory).StrictlyNecessary]: '',
    [(0, $8FFpF.PreferenceCategory).Unknown]: ''
};
async function $c286b237a219cb9c$export$7bb3e177c1a1e841(preferences, displayedTextMap = $c286b237a219cb9c$var$emptyDisplayedTextMap, usingPrefetchedData) {
    if ((0, $gMWuT.getBscGlobalState)().localConsentMode) {
        const packedPrefs = (0, $gHrGQ.packUserPreferences)(preferences);
        (0, $7RRGT.setStrictlyNecessaryCookie)((0, $21KEY.LEGACY_ATLASSIAN_GDPR_COOKIE_KEY), packedPrefs, {
            expires: 365,
            path: '/'
        });
    } else await (0, $gZtVL.setConsentToken)(preferences, displayedTextMap, usingPrefetchedData);
}

});
parcelRegister("gZtVL", function(module, exports) {

$parcel$export(module.exports, "setConsentToken", () => $ab5f861c391f24f6$export$fbf549fe6f0e91dc);

var $VSDnB = parcelRequire("VSDnB");

var $Dyz2r = parcelRequire("Dyz2r");

var $jhSue = parcelRequire("jhSue");

var $bF6aU = parcelRequire("bF6aU");

var $8FFpF = parcelRequire("8FFpF");

var $2BKtx = parcelRequire("2BKtx");

var $gHrGQ = parcelRequire("gHrGQ");

var $6M8yp = parcelRequire("6M8yp");
const $ab5f861c391f24f6$export$c8a8f3474b56fa5f = (mergedPrefs, usingPrefetchedData)=>{
    // If platform_moonjelly_bsc_fallback_token_audit feature gate is on,
    // use new fallback consent token logic
    if ((0, $VSDnB.fg)('platform_moonjelly_bsc_fallback_token_audit')) {
        // On a successful save, transform the prefs object into a formatted consentToken bit string
        // Then store the new token in a 10min-expiry consent cookie and a 1yr-expiry fallback cookie
        const consentToken = (0, $gHrGQ.packUserPreferences)(mergedPrefs);
        // Check if the token is prefetched and set to default.
        if (usingPrefetchedData && (0, $bF6aU.checkIfTokenIsDefault)(consentToken)) return;
        if (usingPrefetchedData) (0, $6M8yp.onlySetFallbackIfDifferent)(consentToken);
        else (0, $2BKtx.setConsentTokenFallbackCookie)(consentToken);
        (0, $2BKtx.setConsentTokenCookie)(consentToken);
        (0, $2BKtx.setShouldShowBannerCookie)(consentToken);
    } else {
        // On a successful save, transform the prefs object into a formatted consentToken bit string
        // Then store the new token in a 10min-expiry consent cookie and a 1yr-expiry fallback cookie
        const consentToken = (0, $gHrGQ.packUserPreferences)(mergedPrefs);
        // If the token is prefetched and a default, we should rely on the existing cookie data rather than re-setting
        // cookies that are already set
        const tokenIsPrefetchedDefault = usingPrefetchedData && (0, $bF6aU.checkIfTokenIsDefault)(consentToken);
        if (!tokenIsPrefetchedDefault) {
            if (usingPrefetchedData) // If the fallback token already exists, we don't want to nuke the expiration inadvertently (since this happens on every page load).
            (0, $6M8yp.onlySetFallbackIfDifferent)(consentToken);
            else // This has originated from a user saving their consents in the UI, so set a fallback to their new consents immediately.
            (0, $2BKtx.setConsentTokenFallbackCookie)(consentToken);
            (0, $2BKtx.setConsentTokenCookie)(consentToken);
            (0, $2BKtx.setShouldShowBannerCookie)(consentToken);
        }
    }
};
const $ab5f861c391f24f6$export$2c4e14a9e4d984da = (err, mergedPrefs)=>{
    const errorDueToUnauthenticatedRequest = err instanceof (0, $bF6aU.StatusCodeError) && err.status === 401;
    const errorDueToConsentHubBeingInaccessible = err instanceof (0, $bF6aU.StatusCodeError) && err.status >= 500 && err.status < 600; // Any 5xx error
    // Indicates the user is genuinely logged out instead of ConsentHub being inaccessible
    // If we dont explicitly 401, defer to the previous auth state
    const updatedAuthState = errorDueToUnauthenticatedRequest ? !errorDueToUnauthenticatedRequest : !!mergedPrefs[(0, $8FFpF.ContextualConsentProperty).UserIsAuthenticated];
    const consentToken = (0, $gHrGQ.packUserPreferences)({
        ...mergedPrefs,
        [(0, $8FFpF.ContextualConsentProperty).UserIsAuthenticated]: updatedAuthState,
        [(0, $8FFpF.ContextualConsentProperty).ConsentDataUnavailable]: errorDueToConsentHubBeingInaccessible
    });
    if (errorDueToUnauthenticatedRequest) {
        // When the failure is derived from a local-only/unauthenticated user, we need to also set the consent token
        // Otherwise, we will never actually adhere to their consents, as they'll continue to receive default every time we attempt to unsuccessfully fetch their prefs
        (0, $Dyz2r.Logger).error(`User is unauthenticated. ${err.message}`);
        (0, $6M8yp.onlySetFallbackIfDifferent)(consentToken);
        (0, $2BKtx.setConsentTokenCookie)(consentToken);
        (0, $2BKtx.setShouldShowBannerCookie)(consentToken);
        return;
    }
    // When there's an actual failure, we only store data in the fallbackConsentToken cookie
    // This allows us to still track consents when ConsentHub is down > 10 minute expiry
    // But do _not_ set a consentToken cookie so we attempt to re-request from ConsentHub on sequential loads
    // This circumvents an issue of a user thinking they saved consents to CH, but when we request them later,
    // CH has no record of them, and they get shown the banner again
    (0, $Dyz2r.Logger).error('Token failed to save');
    (0, $6M8yp.onlySetFallbackIfDifferent)(consentToken);
    (0, $2BKtx.setShouldShowBannerCookie)(consentToken);
};
const $ab5f861c391f24f6$export$fbf549fe6f0e91dc = async (updatedPreferences, displayedTextMap, usingPrefetchedData)=>{
    const mergedPrefs = (0, $6M8yp.mergeConsentUpdates)(updatedPreferences, usingPrefetchedData);
    try {
        if (!usingPrefetchedData) // Attempts to save the newly updated preferences object
        // Can only be saved when a user is logged in, so this error will be caught if unauthed
        await (0, $jhSue.saveConsentPreferences)(mergedPrefs, displayedTextMap);
        $ab5f861c391f24f6$export$c8a8f3474b56fa5f(mergedPrefs, usingPrefetchedData);
    } catch (err) {
        // If we fail to save to ConsentHub, it could be due to ConsentHub being down, the user being unauthenticated/local-only,
        // or an exception somewhere in the stack. Ensure we pack that information into the token where applicable.
        $ab5f861c391f24f6$export$2c4e14a9e4d984da(err, mergedPrefs);
    }
};

});
parcelRegister("6M8yp", function(module, exports) {

$parcel$export(module.exports, "mergeConsentUpdates", () => $cb984131c5c33cd6$export$c0214a364df3006f);
$parcel$export(module.exports, "onlySetFallbackIfDifferent", () => $cb984131c5c33cd6$export$a023a0b818522757);

var $21KEY = parcelRequire("21KEY");

var $8FFpF = parcelRequire("8FFpF");

var $4uHy1 = parcelRequire("4uHy1");

var $2BKtx = parcelRequire("2BKtx");

var $gHrGQ = parcelRequire("gHrGQ");
const $cb984131c5c33cd6$var$pruneLegacyProperties = (updatedPreferences)=>{
    // Strips any possible V002/legacy properties from the preferences by excluding everything but the core prefs
    return {
        [(0, $8FFpF.PreferenceCategory).StrictlyNecessary]: updatedPreferences[(0, $8FFpF.PreferenceCategory).StrictlyNecessary],
        [(0, $8FFpF.PreferenceCategory).Functional]: updatedPreferences[(0, $8FFpF.PreferenceCategory).Functional],
        [(0, $8FFpF.PreferenceCategory).Analytics]: updatedPreferences[(0, $8FFpF.PreferenceCategory).Analytics],
        [(0, $8FFpF.PreferenceCategory).Marketing]: updatedPreferences[(0, $8FFpF.PreferenceCategory).Marketing],
        [(0, $8FFpF.PreferenceCategory).Unknown]: updatedPreferences[(0, $8FFpF.PreferenceCategory).Unknown]
    };
};
const $cb984131c5c33cd6$var$setContextualConsentProperties = (consentPreferences, usingPrefetchedData)=>{
    // When merging during this phase, retain the "unauthed/authed" context of the preferences
    const existingUserAuthenticatedState = consentPreferences?.[(0, $8FFpF.ContextualConsentProperty).UserIsAuthenticated];
    const existingConsentHubUnavailableState = !!consentPreferences?.[(0, $8FFpF.ContextualConsentProperty).ConsentDataUnavailable];
    // When processing a legacy token, UserIsAuthenticated will be missing, so we need to backfill it with context from ConsentHubUnavailable
    const existingOrBackfilledAuthState = existingUserAuthenticatedState === undefined ? !existingConsentHubUnavailableState : existingUserAuthenticatedState;
    // Overwriting this flag while merging here gets us into a situation where a prefetched/cached, default cookie is just being set in the system,
    // but we mark the consents as "genuine", when they haven't actually been saved.
    // Doing this would have negative downstream effects, as we invoke logic dependent on if a token is a default or not
    const existingDefaultState = !!consentPreferences?.[(0, $8FFpF.ContextualConsentProperty).ConsentsAreDefault];
    const consentsAreDefault = usingPrefetchedData ? existingDefaultState : false;
    return {
        [(0, $8FFpF.ContextualConsentProperty).ConsentsAreDefault]: consentsAreDefault,
        [(0, $8FFpF.ContextualConsentProperty).UserIsAuthenticated]: existingOrBackfilledAuthState,
        [(0, $8FFpF.ContextualConsentProperty).ConsentDataUnavailable]: existingConsentHubUnavailableState
    };
};
const $cb984131c5c33cd6$export$c0214a364df3006f = (updatedPreferences, usingPrefetchedData)=>{
    // DEFAULT_PREFERENCES now gives us "CH unavailable" and "is default" bits
    const existingPrefs = (0, $4uHy1.getCookie)((0, $21KEY.ATLASSIAN_CONSENT_COOKIE_KEY));
    if (existingPrefs) {
        // Unpacking a V2 should now result in a V3 token anyway, but ensure we have proper bits
        const unpackedExistingPrefs = (0, $gHrGQ.unpackUserPreferencesCookie)(existingPrefs);
        // Capture any missed options (shouldn't have any if we have existing consent token), and
        // ensure we write the bit dictating that these consents are no longer defaults since they're being saved
        if (unpackedExistingPrefs) return {
            ...(0, $21KEY.DEFAULT_PREFERENCES),
            ...unpackedExistingPrefs,
            ...$cb984131c5c33cd6$var$pruneLegacyProperties(updatedPreferences),
            ...$cb984131c5c33cd6$var$setContextualConsentProperties(unpackedExistingPrefs, usingPrefetchedData)
        };
        return {
            ...(0, $21KEY.DEFAULT_PREFERENCES),
            ...$cb984131c5c33cd6$var$pruneLegacyProperties(updatedPreferences)
        };
    }
    // If we don't have existing prefs, this is likely a first time save for this domain
    // Ensure we note this is a successful, genuine set of prefs by updating the contextual properties as needed
    return {
        ...(0, $21KEY.DEFAULT_PREFERENCES),
        ...$cb984131c5c33cd6$var$pruneLegacyProperties(updatedPreferences),
        ...$cb984131c5c33cd6$var$setContextualConsentProperties(updatedPreferences, usingPrefetchedData)
    };
};
const $cb984131c5c33cd6$export$a023a0b818522757 = (consentToken)=>{
    // Diff the token we're trying to set vs. any existing fallback, and only set a new fallback if the value has changed.
    // A difference would mean the user made a change since their original fallback was stored and we should update.
    // Otherwise, we would be unintentionally overriding the "1 year" expiration date the fallback token tracks.
    const existingFallbackToken = (0, $4uHy1.getCookie)((0, $21KEY.ATLASSIAN_CONSENT_FALLBACK_COOKIE_KEY));
    const tokenDiffersFromOldFallback = existingFallbackToken !== consentToken;
    if (!existingFallbackToken || tokenDiffersFromOldFallback) (0, $2BKtx.setConsentTokenFallbackCookie)(consentToken);
};

});



parcelRegister("lhsMz", function(module, exports) {

$parcel$export(module.exports, "i18n", () => $e5b0c8fc49fb7e08$export$a7357cdd1f0b0168);

var $7VHMR = parcelRequire("7VHMR");
const $e5b0c8fc49fb7e08$export$a7357cdd1f0b0168 = (0, $7VHMR.defineMessages)({
    preferencesBtn: {
        id: 'browser-storage-controls.consent-banner.preferences.button',
        defaultMessage: 'Preferences',
        description: 'Preferences button that opens consent modal dialog.'
    },
    onlyNecessaryBtn: {
        id: 'browser-storage-controls.consent-banner.only-necessary.button',
        defaultMessage: 'Only necessary',
        description: 'Only necessary button that saves user preferences - only necessary cookies.'
    },
    acceptAllBtn: {
        id: 'browser-storage-controls.consent-banner.accept-all.button',
        defaultMessage: 'Accept all',
        description: 'Accept all button that saves user preferences - accepts all cookies.'
    },
    cookiesTrackingNotice: {
        id: 'browser-storage-controls.consent-banner.cookies-tracking-notice.text.101024',
        defaultMessage: 'Atlassian cookies and tracking notice',
        description: 'Link that leads to Atlassian cookies/tracking legal notice text on Atlassian website.'
    },
    useCookiesDescription: {
        id: 'browser-storage-controls.consent-banner.cookies-description.text',
        defaultMessage: 'Atlassian uses cookies to improve your browsing experience, perform analytics and research, and conduct advertising. Accept all cookies to indicate that you agree to our use of cookies on your device. {linkToCookiesTrackingNotice}',
        description: 'Description that explains Atlassian cookie controls and how it is used.'
    },
    successFlagTitle: {
        id: 'browser-storage-controls.consent-banner.success-flag.title',
        defaultMessage: 'Cookie preferences saved',
        description: 'Title for the success flag shown when cookie preferences are saved initially.'
    },
    successFlagDescription: {
        id: 'browser-storage-controls.consent-banner.success-flag.description',
        defaultMessage: 'You can change this at any time in your Atlassian account.',
        description: 'Description for the success flag shown when cookie preferences are saved initially.'
    },
    successFlagDescriptionLocalOnly: {
        id: 'browser-storage-controls.consent-banner.success-flag.description-local-only',
        defaultMessage: 'Your preferences will only affect this site.',
        description: 'Description for the success flag shown when cookie preferences are saved locally, meaning that those preferences will only affect the current domain.'
    },
    errorFlagTitle: {
        id: 'browser-storage-controls.consent-banner.error-flag.title',
        defaultMessage: "We're unable to update the policy",
        description: 'Title for the error flag shown when cookie preferences are not saved.'
    },
    errorFlagDescription: {
        id: 'browser-storage-controls.consent-banner.error-flag.description',
        defaultMessage: 'Try again in a few minutes.',
        description: 'Description for the error flag shown when cookie preferences are not saved.'
    }
});

});

parcelRegister("ajT7X", function(module, exports) {

$parcel$export(module.exports, "PreferenceModal", () => $1d6a7cf4153d618a$export$94c5684831c222e7);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $VSDnB = parcelRequire("VSDnB");

var $3MsQ9 = parcelRequire("3MsQ9");

var $Dyz2r = parcelRequire("Dyz2r");

var $21KEY = parcelRequire("21KEY");

var $k49WR = parcelRequire("k49WR");

var $89WID = parcelRequire("89WID");

var $bLuwV = parcelRequire("bLuwV");
const $1d6a7cf4153d618a$export$94c5684831c222e7 = (props)=>{
    if ((0, $VSDnB.fg)('platform_moonjelly_bsc_master_killswitch') || (0, $VSDnB.fg)('platform_moonjelly_bsc_ui_killswitch')) // Don't render the preference modal if the killswitch is enabled
    return null;
    return /*#__PURE__*/ (0, $2OMIu.jsx)($1d6a7cf4153d618a$export$30df3cfccbe10e6e, {
        ...props
    });
};
const $1d6a7cf4153d618a$export$30df3cfccbe10e6e = ({ onClose: onClose, onSubmit: onSubmit, showSuccessFlag: showSuccessFlag, showErrorFlag: showErrorFlag })=>{
    const [isModalOpen, setIsModalOpen] = (0, $5uXOq.useState)(true);
    const isEventSent = (0, $5uXOq.useRef)(false);
    (0, $5uXOq.useEffect)(()=>{
        if (!isEventSent.current) {
            (0, $3MsQ9.sendScreenEvent)({
                name: 'cookieConsentModal'
            });
            isEventSent.current = true;
        }
    }, [
        isEventSent
    ]);
    const { preferences: preferences, setPreferencesData: setPreferencesData } = (0, $bLuwV.default)({});
    // If we don't have preferences, set default preferences
    // for modal interactions
    if (!preferences) setPreferencesData({
        prefs: (0, $21KEY.ONLY_NECESSARY_PREFERENCES),
        isPrefetchedPrefsInternalState: false
    });
    const handleOnSubmit = (0, $5uXOq.useCallback)(async (displayedTextMap)=>{
        if (preferences) {
            const selectedPreferences = preferences;
            (0, $3MsQ9.sendUIEvent)({
                action: 'clicked',
                actionSubject: 'button',
                actionSubjectId: 'confirm',
                source: 'cookieConsentModal'
            });
            try {
                await (0, $k49WR.updatePreferences)(selectedPreferences, displayedTextMap);
                (0, $3MsQ9.sendTrackEvent)({
                    source: 'cookieConsentModal',
                    action: 'submitted',
                    actionSubject: 'cookieConsentPreferences'
                });
                showSuccessFlag?.();
            } catch (e) {
                (0, $Dyz2r.Logger).errorWithOperationalEvent({
                    action: 'updatePreferencesError',
                    attributes: {
                        preferences: selectedPreferences
                    },
                    message: `Failed to update preferences from modal. ${e.message || ''}`
                });
                showErrorFlag?.();
            }
            setIsModalOpen(false);
            onSubmit?.();
        } else // Preferences have reached an invalid state, show error flag
        showErrorFlag?.();
    }, [
        preferences,
        onSubmit,
        showSuccessFlag,
        showErrorFlag
    ]);
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $2OMIu.Fragment), {
        children: isModalOpen && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $89WID.PresentationalPreferenceModal), {
            onSubmit: handleOnSubmit,
            onClose: onClose,
            setIsOpen: setIsModalOpen,
            preferences: preferences ?? (0, $21KEY.ONLY_NECESSARY_PREFERENCES),
            setPreferencesData: setPreferencesData
        })
    });
};

});
parcelRegister("89WID", function(module, exports) {

$parcel$export(module.exports, "PresentationalPreferenceModal", () => $3823314bd9b45775$export$9921ee7829a3ba4);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $9joA7 = parcelRequire("9joA7");

var $ousew = parcelRequire("ousew");
var $koVbs = parcelRequire("koVbs");

var $fVnbM = parcelRequire("fVnbM");

var $efXp3 = parcelRequire("efXp3");

var $1R1Ge = parcelRequire("1R1Ge");
var $7QSqG = parcelRequire("7QSqG");
var $juxqI = parcelRequire("juxqI");
var $jgVsb = parcelRequire("jgVsb");
var $gofOI = parcelRequire("gofOI");
var $i8Qvm = parcelRequire("i8Qvm");

var $jhmo0 = parcelRequire("jhmo0");
var $dC5iT = parcelRequire("dC5iT");
var $luBm6 = parcelRequire("luBm6");
var $cgL5K = parcelRequire("cgL5K");
var $8CUq3 = parcelRequire("8CUq3");

var $3MsQ9 = parcelRequire("3MsQ9");

var $j7UP0 = parcelRequire("j7UP0");

var $8FFpF = parcelRequire("8FFpF");

var $krMbB = parcelRequire("krMbB");

var $bcqPo = parcelRequire("bcqPo");
const $3823314bd9b45775$var$categoryNameStyles = (0, $8CUq3.xcss)({
    fontWeight: 'font.weight.bold'
});
const $3823314bd9b45775$var$getDefaultText = (intl)=>{
    const link = intl.formatMessage((0, $bcqPo.i18n).trackingLink);
    const defaultSummaryDescriptionDisplayedText = intl.formatMessage((0, $bcqPo.i18n).summaryDescription, {
        link: link
    });
    const defaultStrictDescriptionDisplayedTextNode = intl.formatMessage((0, $bcqPo.i18n).strictDescription, {
        bold: (msg)=>msg
    });
    // ReactIntl requires interpolated values to be passed in, and this particular string requires a <bold> modifier.
    // Unfortunately, this converts the above formatted message to a ReactNode but ConsentHub needs strings for `displayedText`,
    // thus, we have to render to a static HTML string first and sanitize the result
    const defaultStrictDescriptionDisplayedText = (0, (/*@__PURE__*/$parcel$interopDefault($9joA7))).renderToStaticMarkup(defaultStrictDescriptionDisplayedTextNode);
    let defaultDisplayedText = `${defaultSummaryDescriptionDisplayedText}. ${defaultStrictDescriptionDisplayedText}`;
    // This outputs an encoded string that jacks up apostrophes, so clean 'em up
    const sanitizedText = defaultDisplayedText.replace(/&#x27;/g, "'");
    return sanitizedText;
};
const $3823314bd9b45775$var$getCookieCategories = (intl)=>{
    const cookieCategoriesToTranslate = [
        {
            // Tracks Functional related cookies like preferences
            category: (0, $8FFpF.PreferenceCategory).Functional,
            title: (0, $bcqPo.i18n).functionalOption,
            description: (0, $bcqPo.i18n).functionalOptionDescription
        },
        {
            // Tracks Performance related cookies like analytics
            category: (0, $8FFpF.PreferenceCategory).Analytics,
            title: (0, $bcqPo.i18n).analyticalOption,
            description: (0, $bcqPo.i18n).analyticalOptionDescription
        },
        {
            // Tracks Targeting related cookies like marketing and advertising
            category: (0, $8FFpF.PreferenceCategory).Marketing,
            title: (0, $bcqPo.i18n).marketingOption,
            description: (0, $bcqPo.i18n).marketingOptionDescription
        }
    ];
    // We'll use this mapping to send the `displayedText` for each checkbox when saving to ConsentHub
    const displayedTextMap = (0, $j7UP0.CONSENT_DISPLAYED_TEXT_ITEMS).reduce((translatedTextMap, category)=>{
        // Set the description as the default for all items (including items with checkboxes in the UI)
        // and we'll override as needed. Prefs that are not visually displayed in the UI anymore will use this default.
        translatedTextMap[category] = $3823314bd9b45775$var$getDefaultText(intl);
        return translatedTextMap;
    }, {});
    const checkboxes = cookieCategoriesToTranslate.map(({ category: category, title: title, description: description })=>{
        const translatedTitle = intl.formatMessage(title);
        const translatedDescription = intl.formatMessage(description);
        // If we are showing individual checkboxes, use that description for auditing purposes
        displayedTextMap[category] = translatedDescription;
        return {
            category: category,
            titleElement: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $dC5iT.default), {
                xcss: $3823314bd9b45775$var$categoryNameStyles,
                children: translatedTitle
            }),
            descriptionElement: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $dC5iT.default), {
                children: translatedDescription
            }),
            titleString: title.defaultMessage
        };
    });
    return {
        checkboxes: checkboxes,
        displayedTextMap: displayedTextMap
    };
};
const $3823314bd9b45775$var$noop = ()=>{};
const $3823314bd9b45775$export$9921ee7829a3ba4 = ({ preferences: preferences, setPreferencesData: setPreferencesData = $3823314bd9b45775$var$noop, onSubmit: onSubmit = $3823314bd9b45775$var$noop, onClose: onClose = $3823314bd9b45775$var$noop, setIsOpen: setIsOpen = $3823314bd9b45775$var$noop })=>{
    const intl = (0, $koVbs.default)();
    const onCloseModal = (0, $5uXOq.useCallback)(()=>{
        setIsOpen(false);
        onClose();
    }, [
        setIsOpen,
        onClose
    ]);
    const onClickCancel = (0, $5uXOq.useCallback)(()=>{
        onCloseModal();
        (0, $3MsQ9.sendUIEvent)({
            action: 'clicked',
            actionSubject: 'button',
            actionSubjectId: 'cancel',
            source: 'cookieConsentModal'
        });
    }, [
        onCloseModal
    ]);
    const onClickBackground = (0, $5uXOq.useCallback)(()=>{
        onCloseModal();
        (0, $3MsQ9.sendUIEvent)({
            action: 'clicked',
            actionSubject: 'area',
            actionSubjectId: 'background',
            source: 'cookieConsentModal'
        });
    }, [
        onCloseModal
    ]);
    const onClickTrackingNoticeLink = (0, $5uXOq.useCallback)(()=>{
        (0, $3MsQ9.sendUIEvent)({
            action: 'clicked',
            actionSubject: 'link',
            actionSubjectId: 'cookiesTrackingNotice',
            source: 'cookieConsentModal'
        });
    }, []);
    const cookieCategories = (0, $5uXOq.useMemo)(()=>{
        return $3823314bd9b45775$var$getCookieCategories(intl);
    }, [
        intl
    ]);
    const handleSubmission = (0, $5uXOq.useCallback)(()=>{
        const { displayedTextMap: displayedTextMap } = cookieCategories;
        onSubmit(displayedTextMap);
    }, [
        onSubmit,
        cookieCategories
    ]);
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $i8Qvm.default), {
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $1R1Ge.default), {
            onClose: onClickBackground,
            children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $efXp3.default), {
                onSubmit: handleSubmission,
                children: ({ formProps: formProps })=>/*#__PURE__*/ (0, $2OMIu.jsxs)("form", {
                        ...formProps,
                        children: [
                            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $jgVsb.default), {
                                children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $gofOI.default), {
                                    children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
                                        ...(0, $bcqPo.i18n).title
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $7QSqG.default), {
                                children: [
                                    /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $dC5iT.default), {
                                        children: [
                                            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
                                                ...(0, $bcqPo.i18n).summaryDescription,
                                                values: {
                                                    link: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $jhmo0.default), {
                                                        href: "https://www.atlassian.com/legal/cookies#cookies-and-other-tracking-technologies",
                                                        target: "_blank",
                                                        onClick: onClickTrackingNoticeLink,
                                                        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
                                                            ...(0, $bcqPo.i18n).trackingLink
                                                        })
                                                    })
                                                },
                                                tagName: 'p'
                                            }),
                                            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
                                                ...(0, $bcqPo.i18n).strictDescription,
                                                values: {
                                                    bold: (msg)=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $cgL5K.default), {
                                                            weight: "bold",
                                                            children: msg
                                                        })
                                                },
                                                tagName: 'p'
                                            })
                                        ]
                                    }),
                                    cookieCategories.checkboxes.map(({ category: category, titleElement: titleElement, titleString: titleString, descriptionElement: description }, index)=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $luBm6.default), {
                                            children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $krMbB.CookieCategorySection), {
                                                category: category,
                                                titleElement: titleElement,
                                                titleString: titleString,
                                                descriptionElement: description,
                                                isChecked: (preferences && preferences[category]) ?? false,
                                                setPreferencesData: setPreferencesData
                                            })
                                        }, index))
                                ]
                            }),
                            /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $juxqI.default), {
                                children: [
                                    /*#__PURE__*/ (0, $2OMIu.jsx)((0, $fVnbM.default), {
                                        appearance: "subtle",
                                        onClick: onClickCancel,
                                        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
                                            ...(0, $bcqPo.i18n).cancelBtn
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $2OMIu.jsx)((0, $fVnbM.default), {
                                        type: "submit",
                                        appearance: "primary",
                                        onClick: handleSubmission,
                                        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
                                            ...(0, $bcqPo.i18n).confirmBtn
                                        })
                                    })
                                ]
                            })
                        ]
                    })
            })
        })
    });
};

});
parcelRegister("9joA7", function(module, exports) {

$parcel$export(module.exports, "version", () => $6c78f4cae7505685$export$83d89fbfd8236492, (v) => $6c78f4cae7505685$export$83d89fbfd8236492 = v);
$parcel$export(module.exports, "renderToString", () => $6c78f4cae7505685$export$80e7718417253a51, (v) => $6c78f4cae7505685$export$80e7718417253a51 = v);
$parcel$export(module.exports, "renderToStaticMarkup", () => $6c78f4cae7505685$export$eb3a06aef9e6ee51, (v) => $6c78f4cae7505685$export$eb3a06aef9e6ee51 = v);
$parcel$export(module.exports, "renderToNodeStream", () => $6c78f4cae7505685$export$307591e98609eddd, (v) => $6c78f4cae7505685$export$307591e98609eddd = v);
$parcel$export(module.exports, "renderToStaticNodeStream", () => $6c78f4cae7505685$export$b23711c915539651, (v) => $6c78f4cae7505685$export$b23711c915539651 = v);
$parcel$export(module.exports, "renderToReadableStream", () => $6c78f4cae7505685$export$7020a3240b287705, (v) => $6c78f4cae7505685$export$7020a3240b287705 = v);
var $6c78f4cae7505685$export$83d89fbfd8236492;
var $6c78f4cae7505685$export$80e7718417253a51;
var $6c78f4cae7505685$export$eb3a06aef9e6ee51;
var $6c78f4cae7505685$export$307591e98609eddd;
var $6c78f4cae7505685$export$b23711c915539651;
var $6c78f4cae7505685$export$7020a3240b287705;
'use strict';
var $6c78f4cae7505685$var$l, $6c78f4cae7505685$var$s;

$6c78f4cae7505685$var$l = (parcelRequire("6aMuy"));

$6c78f4cae7505685$var$s = (parcelRequire("l7JfX"));
$6c78f4cae7505685$export$83d89fbfd8236492 = $6c78f4cae7505685$var$l.version;
$6c78f4cae7505685$export$80e7718417253a51 = $6c78f4cae7505685$var$l.renderToString;
$6c78f4cae7505685$export$eb3a06aef9e6ee51 = $6c78f4cae7505685$var$l.renderToStaticMarkup;
$6c78f4cae7505685$export$307591e98609eddd = $6c78f4cae7505685$var$l.renderToNodeStream;
$6c78f4cae7505685$export$b23711c915539651 = $6c78f4cae7505685$var$l.renderToStaticNodeStream;
$6c78f4cae7505685$export$7020a3240b287705 = $6c78f4cae7505685$var$s.renderToReadableStream;

});
parcelRegister("6aMuy", function(module, exports) {

$parcel$export(module.exports, "renderToNodeStream", () => $47e94abb28b53633$export$307591e98609eddd, (v) => $47e94abb28b53633$export$307591e98609eddd = v);
$parcel$export(module.exports, "renderToStaticMarkup", () => $47e94abb28b53633$export$eb3a06aef9e6ee51, (v) => $47e94abb28b53633$export$eb3a06aef9e6ee51 = v);
$parcel$export(module.exports, "renderToStaticNodeStream", () => $47e94abb28b53633$export$b23711c915539651, (v) => $47e94abb28b53633$export$b23711c915539651 = v);
$parcel$export(module.exports, "renderToString", () => $47e94abb28b53633$export$80e7718417253a51, (v) => $47e94abb28b53633$export$80e7718417253a51 = v);
$parcel$export(module.exports, "version", () => $47e94abb28b53633$export$83d89fbfd8236492, (v) => $47e94abb28b53633$export$83d89fbfd8236492 = v);
/**
 * @license React
 * react-dom-server-legacy.browser.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $47e94abb28b53633$export$307591e98609eddd;
var $47e94abb28b53633$export$eb3a06aef9e6ee51;
var $47e94abb28b53633$export$b23711c915539651;
var $47e94abb28b53633$export$80e7718417253a51;
var $47e94abb28b53633$export$83d89fbfd8236492;
'use strict';

var $5uXOq = parcelRequire("5uXOq");
function $47e94abb28b53633$var$l(a) {
    for(var b = "https://reactjs.org/docs/error-decoder.html?invariant=" + a, c = 1; c < arguments.length; c++)b += "&args[]=" + encodeURIComponent(arguments[c]);
    return "Minified React error #" + a + "; visit " + b + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
var $47e94abb28b53633$var$p = Object.prototype.hasOwnProperty, $47e94abb28b53633$var$fa = /^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/, $47e94abb28b53633$var$ha = {}, $47e94abb28b53633$var$ia = {};
function $47e94abb28b53633$var$ja(a) {
    if ($47e94abb28b53633$var$p.call($47e94abb28b53633$var$ia, a)) return !0;
    if ($47e94abb28b53633$var$p.call($47e94abb28b53633$var$ha, a)) return !1;
    if ($47e94abb28b53633$var$fa.test(a)) return $47e94abb28b53633$var$ia[a] = !0;
    $47e94abb28b53633$var$ha[a] = !0;
    return !1;
}
function $47e94abb28b53633$var$r(a, b, c, d, f, e, g) {
    this.acceptsBooleans = 2 === b || 3 === b || 4 === b;
    this.attributeName = d;
    this.attributeNamespace = f;
    this.mustUseProperty = c;
    this.propertyName = a;
    this.type = b;
    this.sanitizeURL = e;
    this.removeEmptyString = g;
}
var $47e94abb28b53633$var$t = {};
"children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(a) {
    $47e94abb28b53633$var$t[a] = new $47e94abb28b53633$var$r(a, 0, !1, a, null, !1, !1);
});
[
    [
        "acceptCharset",
        "accept-charset"
    ],
    [
        "className",
        "class"
    ],
    [
        "htmlFor",
        "for"
    ],
    [
        "httpEquiv",
        "http-equiv"
    ]
].forEach(function(a) {
    var b = a[0];
    $47e94abb28b53633$var$t[b] = new $47e94abb28b53633$var$r(b, 1, !1, a[1], null, !1, !1);
});
[
    "contentEditable",
    "draggable",
    "spellCheck",
    "value"
].forEach(function(a) {
    $47e94abb28b53633$var$t[a] = new $47e94abb28b53633$var$r(a, 2, !1, a.toLowerCase(), null, !1, !1);
});
[
    "autoReverse",
    "externalResourcesRequired",
    "focusable",
    "preserveAlpha"
].forEach(function(a) {
    $47e94abb28b53633$var$t[a] = new $47e94abb28b53633$var$r(a, 2, !1, a, null, !1, !1);
});
"allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture disableRemotePlayback formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(a) {
    $47e94abb28b53633$var$t[a] = new $47e94abb28b53633$var$r(a, 3, !1, a.toLowerCase(), null, !1, !1);
});
[
    "checked",
    "multiple",
    "muted",
    "selected"
].forEach(function(a) {
    $47e94abb28b53633$var$t[a] = new $47e94abb28b53633$var$r(a, 3, !0, a, null, !1, !1);
});
[
    "capture",
    "download"
].forEach(function(a) {
    $47e94abb28b53633$var$t[a] = new $47e94abb28b53633$var$r(a, 4, !1, a, null, !1, !1);
});
[
    "cols",
    "rows",
    "size",
    "span"
].forEach(function(a) {
    $47e94abb28b53633$var$t[a] = new $47e94abb28b53633$var$r(a, 6, !1, a, null, !1, !1);
});
[
    "rowSpan",
    "start"
].forEach(function(a) {
    $47e94abb28b53633$var$t[a] = new $47e94abb28b53633$var$r(a, 5, !1, a.toLowerCase(), null, !1, !1);
});
var $47e94abb28b53633$var$ka = /[\-:]([a-z])/g;
function $47e94abb28b53633$var$la(a) {
    return a[1].toUpperCase();
}
"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(a) {
    var b = a.replace($47e94abb28b53633$var$ka, $47e94abb28b53633$var$la);
    $47e94abb28b53633$var$t[b] = new $47e94abb28b53633$var$r(b, 1, !1, a, null, !1, !1);
});
"xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(a) {
    var b = a.replace($47e94abb28b53633$var$ka, $47e94abb28b53633$var$la);
    $47e94abb28b53633$var$t[b] = new $47e94abb28b53633$var$r(b, 1, !1, a, "http://www.w3.org/1999/xlink", !1, !1);
});
[
    "xml:base",
    "xml:lang",
    "xml:space"
].forEach(function(a) {
    var b = a.replace($47e94abb28b53633$var$ka, $47e94abb28b53633$var$la);
    $47e94abb28b53633$var$t[b] = new $47e94abb28b53633$var$r(b, 1, !1, a, "http://www.w3.org/XML/1998/namespace", !1, !1);
});
[
    "tabIndex",
    "crossOrigin"
].forEach(function(a) {
    $47e94abb28b53633$var$t[a] = new $47e94abb28b53633$var$r(a, 1, !1, a.toLowerCase(), null, !1, !1);
});
$47e94abb28b53633$var$t.xlinkHref = new $47e94abb28b53633$var$r("xlinkHref", 1, !1, "xlink:href", "http://www.w3.org/1999/xlink", !0, !1);
[
    "src",
    "href",
    "action",
    "formAction"
].forEach(function(a) {
    $47e94abb28b53633$var$t[a] = new $47e94abb28b53633$var$r(a, 1, !1, a.toLowerCase(), null, !0, !0);
});
var $47e94abb28b53633$var$u = {
    animationIterationCount: !0,
    aspectRatio: !0,
    borderImageOutset: !0,
    borderImageSlice: !0,
    borderImageWidth: !0,
    boxFlex: !0,
    boxFlexGroup: !0,
    boxOrdinalGroup: !0,
    columnCount: !0,
    columns: !0,
    flex: !0,
    flexGrow: !0,
    flexPositive: !0,
    flexShrink: !0,
    flexNegative: !0,
    flexOrder: !0,
    gridArea: !0,
    gridRow: !0,
    gridRowEnd: !0,
    gridRowSpan: !0,
    gridRowStart: !0,
    gridColumn: !0,
    gridColumnEnd: !0,
    gridColumnSpan: !0,
    gridColumnStart: !0,
    fontWeight: !0,
    lineClamp: !0,
    lineHeight: !0,
    opacity: !0,
    order: !0,
    orphans: !0,
    tabSize: !0,
    widows: !0,
    zIndex: !0,
    zoom: !0,
    fillOpacity: !0,
    floodOpacity: !0,
    stopOpacity: !0,
    strokeDasharray: !0,
    strokeDashoffset: !0,
    strokeMiterlimit: !0,
    strokeOpacity: !0,
    strokeWidth: !0
}, $47e94abb28b53633$var$ma = [
    "Webkit",
    "ms",
    "Moz",
    "O"
];
Object.keys($47e94abb28b53633$var$u).forEach(function(a) {
    $47e94abb28b53633$var$ma.forEach(function(b) {
        b = b + a.charAt(0).toUpperCase() + a.substring(1);
        $47e94abb28b53633$var$u[b] = $47e94abb28b53633$var$u[a];
    });
});
var $47e94abb28b53633$var$na = /["'&<>]/;
function $47e94abb28b53633$var$v(a) {
    if ("boolean" === typeof a || "number" === typeof a) return "" + a;
    a = "" + a;
    var b = $47e94abb28b53633$var$na.exec(a);
    if (b) {
        var c = "", d, f = 0;
        for(d = b.index; d < a.length; d++){
            switch(a.charCodeAt(d)){
                case 34:
                    b = "&quot;";
                    break;
                case 38:
                    b = "&amp;";
                    break;
                case 39:
                    b = "&#x27;";
                    break;
                case 60:
                    b = "&lt;";
                    break;
                case 62:
                    b = "&gt;";
                    break;
                default:
                    continue;
            }
            f !== d && (c += a.substring(f, d));
            f = d + 1;
            c += b;
        }
        a = f !== d ? c + a.substring(f, d) : c;
    }
    return a;
}
var $47e94abb28b53633$var$oa = /([A-Z])/g, $47e94abb28b53633$var$pa = /^ms-/, $47e94abb28b53633$var$qa = Array.isArray;
function $47e94abb28b53633$var$w(a, b) {
    return {
        insertionMode: a,
        selectedValue: b
    };
}
function $47e94abb28b53633$var$ra(a, b, c) {
    switch(b){
        case "select":
            return $47e94abb28b53633$var$w(1, null != c.value ? c.value : c.defaultValue);
        case "svg":
            return $47e94abb28b53633$var$w(2, null);
        case "math":
            return $47e94abb28b53633$var$w(3, null);
        case "foreignObject":
            return $47e94abb28b53633$var$w(1, null);
        case "table":
            return $47e94abb28b53633$var$w(4, null);
        case "thead":
        case "tbody":
        case "tfoot":
            return $47e94abb28b53633$var$w(5, null);
        case "colgroup":
            return $47e94abb28b53633$var$w(7, null);
        case "tr":
            return $47e94abb28b53633$var$w(6, null);
    }
    return 4 <= a.insertionMode || 0 === a.insertionMode ? $47e94abb28b53633$var$w(1, null) : a;
}
var $47e94abb28b53633$var$sa = new Map;
function $47e94abb28b53633$var$ta(a, b, c) {
    if ("object" !== typeof c) throw Error($47e94abb28b53633$var$l(62));
    b = !0;
    for(var d in c)if ($47e94abb28b53633$var$p.call(c, d)) {
        var f = c[d];
        if (null != f && "boolean" !== typeof f && "" !== f) {
            if (0 === d.indexOf("--")) {
                var e = $47e94abb28b53633$var$v(d);
                f = $47e94abb28b53633$var$v(("" + f).trim());
            } else {
                e = d;
                var g = $47e94abb28b53633$var$sa.get(e);
                void 0 !== g ? e = g : (g = $47e94abb28b53633$var$v(e.replace($47e94abb28b53633$var$oa, "-$1").toLowerCase().replace($47e94abb28b53633$var$pa, "-ms-")), $47e94abb28b53633$var$sa.set(e, g), e = g);
                f = "number" === typeof f ? 0 === f || $47e94abb28b53633$var$p.call($47e94abb28b53633$var$u, d) ? "" + f : f + "px" : $47e94abb28b53633$var$v(("" + f).trim());
            }
            b ? (b = !1, a.push(' style="', e, ":", f)) : a.push(";", e, ":", f);
        }
    }
    b || a.push('"');
}
function $47e94abb28b53633$var$x(a, b, c, d) {
    switch(c){
        case "style":
            $47e94abb28b53633$var$ta(a, b, d);
            return;
        case "defaultValue":
        case "defaultChecked":
        case "innerHTML":
        case "suppressContentEditableWarning":
        case "suppressHydrationWarning":
            return;
    }
    if (!(2 < c.length) || "o" !== c[0] && "O" !== c[0] || "n" !== c[1] && "N" !== c[1]) {
        if (b = $47e94abb28b53633$var$t.hasOwnProperty(c) ? $47e94abb28b53633$var$t[c] : null, null !== b) {
            switch(typeof d){
                case "function":
                case "symbol":
                    return;
                case "boolean":
                    if (!b.acceptsBooleans) return;
            }
            c = b.attributeName;
            switch(b.type){
                case 3:
                    d && a.push(" ", c, '=""');
                    break;
                case 4:
                    !0 === d ? a.push(" ", c, '=""') : !1 !== d && a.push(" ", c, '="', $47e94abb28b53633$var$v(d), '"');
                    break;
                case 5:
                    isNaN(d) || a.push(" ", c, '="', $47e94abb28b53633$var$v(d), '"');
                    break;
                case 6:
                    !isNaN(d) && 1 <= d && a.push(" ", c, '="', $47e94abb28b53633$var$v(d), '"');
                    break;
                default:
                    b.sanitizeURL && (d = "" + d), a.push(" ", c, '="', $47e94abb28b53633$var$v(d), '"');
            }
        } else if ($47e94abb28b53633$var$ja(c)) {
            switch(typeof d){
                case "function":
                case "symbol":
                    return;
                case "boolean":
                    if (b = c.toLowerCase().slice(0, 5), "data-" !== b && "aria-" !== b) return;
            }
            a.push(" ", c, '="', $47e94abb28b53633$var$v(d), '"');
        }
    }
}
function $47e94abb28b53633$var$y(a, b, c) {
    if (null != b) {
        if (null != c) throw Error($47e94abb28b53633$var$l(60));
        if ("object" !== typeof b || !("__html" in b)) throw Error($47e94abb28b53633$var$l(61));
        b = b.__html;
        null !== b && void 0 !== b && a.push("" + b);
    }
}
function $47e94abb28b53633$var$ua(a) {
    var b = "";
    $5uXOq.Children.forEach(a, function(a) {
        null != a && (b += a);
    });
    return b;
}
function $47e94abb28b53633$var$va(a, b, c, d) {
    a.push($47e94abb28b53633$var$A(c));
    var f = c = null, e;
    for(e in b)if ($47e94abb28b53633$var$p.call(b, e)) {
        var g = b[e];
        if (null != g) switch(e){
            case "children":
                c = g;
                break;
            case "dangerouslySetInnerHTML":
                f = g;
                break;
            default:
                $47e94abb28b53633$var$x(a, d, e, g);
        }
    }
    a.push(">");
    $47e94abb28b53633$var$y(a, f, c);
    return "string" === typeof c ? (a.push($47e94abb28b53633$var$v(c)), null) : c;
}
var $47e94abb28b53633$var$wa = /^[a-zA-Z][a-zA-Z:_\.\-\d]*$/, $47e94abb28b53633$var$xa = new Map;
function $47e94abb28b53633$var$A(a) {
    var b = $47e94abb28b53633$var$xa.get(a);
    if (void 0 === b) {
        if (!$47e94abb28b53633$var$wa.test(a)) throw Error($47e94abb28b53633$var$l(65, a));
        b = "<" + a;
        $47e94abb28b53633$var$xa.set(a, b);
    }
    return b;
}
function $47e94abb28b53633$var$ya(a, b, c, d, f) {
    switch(b){
        case "select":
            a.push($47e94abb28b53633$var$A("select"));
            var e = null, g = null;
            for(n in c)if ($47e94abb28b53633$var$p.call(c, n)) {
                var h = c[n];
                if (null != h) switch(n){
                    case "children":
                        e = h;
                        break;
                    case "dangerouslySetInnerHTML":
                        g = h;
                        break;
                    case "defaultValue":
                    case "value":
                        break;
                    default:
                        $47e94abb28b53633$var$x(a, d, n, h);
                }
            }
            a.push(">");
            $47e94abb28b53633$var$y(a, g, e);
            return e;
        case "option":
            g = f.selectedValue;
            a.push($47e94abb28b53633$var$A("option"));
            var k = h = null, m = null;
            var n = null;
            for(e in c)if ($47e94abb28b53633$var$p.call(c, e)) {
                var q = c[e];
                if (null != q) switch(e){
                    case "children":
                        h = q;
                        break;
                    case "selected":
                        m = q;
                        break;
                    case "dangerouslySetInnerHTML":
                        n = q;
                        break;
                    case "value":
                        k = q;
                    default:
                        $47e94abb28b53633$var$x(a, d, e, q);
                }
            }
            if (null != g) {
                if (c = null !== k ? "" + k : $47e94abb28b53633$var$ua(h), $47e94abb28b53633$var$qa(g)) {
                    for(d = 0; d < g.length; d++)if ("" + g[d] === c) {
                        a.push(' selected=""');
                        break;
                    }
                } else "" + g === c && a.push(' selected=""');
            } else m && a.push(' selected=""');
            a.push(">");
            $47e94abb28b53633$var$y(a, n, h);
            return h;
        case "textarea":
            a.push($47e94abb28b53633$var$A("textarea"));
            n = g = e = null;
            for(h in c)if ($47e94abb28b53633$var$p.call(c, h) && (k = c[h], null != k)) switch(h){
                case "children":
                    n = k;
                    break;
                case "value":
                    e = k;
                    break;
                case "defaultValue":
                    g = k;
                    break;
                case "dangerouslySetInnerHTML":
                    throw Error($47e94abb28b53633$var$l(91));
                default:
                    $47e94abb28b53633$var$x(a, d, h, k);
            }
            null === e && null !== g && (e = g);
            a.push(">");
            if (null != n) {
                if (null != e) throw Error($47e94abb28b53633$var$l(92));
                if ($47e94abb28b53633$var$qa(n) && 1 < n.length) throw Error($47e94abb28b53633$var$l(93));
                e = "" + n;
            }
            "string" === typeof e && "\n" === e[0] && a.push("\n");
            null !== e && a.push($47e94abb28b53633$var$v("" + e));
            return null;
        case "input":
            a.push($47e94abb28b53633$var$A("input"));
            k = n = h = e = null;
            for(g in c)if ($47e94abb28b53633$var$p.call(c, g) && (m = c[g], null != m)) switch(g){
                case "children":
                case "dangerouslySetInnerHTML":
                    throw Error($47e94abb28b53633$var$l(399, "input"));
                case "defaultChecked":
                    k = m;
                    break;
                case "defaultValue":
                    h = m;
                    break;
                case "checked":
                    n = m;
                    break;
                case "value":
                    e = m;
                    break;
                default:
                    $47e94abb28b53633$var$x(a, d, g, m);
            }
            null !== n ? $47e94abb28b53633$var$x(a, d, "checked", n) : null !== k && $47e94abb28b53633$var$x(a, d, "checked", k);
            null !== e ? $47e94abb28b53633$var$x(a, d, "value", e) : null !== h && $47e94abb28b53633$var$x(a, d, "value", h);
            a.push("/>");
            return null;
        case "menuitem":
            a.push($47e94abb28b53633$var$A("menuitem"));
            for(var C in c)if ($47e94abb28b53633$var$p.call(c, C) && (e = c[C], null != e)) switch(C){
                case "children":
                case "dangerouslySetInnerHTML":
                    throw Error($47e94abb28b53633$var$l(400));
                default:
                    $47e94abb28b53633$var$x(a, d, C, e);
            }
            a.push(">");
            return null;
        case "title":
            a.push($47e94abb28b53633$var$A("title"));
            e = null;
            for(q in c)if ($47e94abb28b53633$var$p.call(c, q) && (g = c[q], null != g)) switch(q){
                case "children":
                    e = g;
                    break;
                case "dangerouslySetInnerHTML":
                    throw Error($47e94abb28b53633$var$l(434));
                default:
                    $47e94abb28b53633$var$x(a, d, q, g);
            }
            a.push(">");
            return e;
        case "listing":
        case "pre":
            a.push($47e94abb28b53633$var$A(b));
            g = e = null;
            for(k in c)if ($47e94abb28b53633$var$p.call(c, k) && (h = c[k], null != h)) switch(k){
                case "children":
                    e = h;
                    break;
                case "dangerouslySetInnerHTML":
                    g = h;
                    break;
                default:
                    $47e94abb28b53633$var$x(a, d, k, h);
            }
            a.push(">");
            if (null != g) {
                if (null != e) throw Error($47e94abb28b53633$var$l(60));
                if ("object" !== typeof g || !("__html" in g)) throw Error($47e94abb28b53633$var$l(61));
                c = g.__html;
                null !== c && void 0 !== c && ("string" === typeof c && 0 < c.length && "\n" === c[0] ? a.push("\n", c) : a.push("" + c));
            }
            "string" === typeof e && "\n" === e[0] && a.push("\n");
            return e;
        case "area":
        case "base":
        case "br":
        case "col":
        case "embed":
        case "hr":
        case "img":
        case "keygen":
        case "link":
        case "meta":
        case "param":
        case "source":
        case "track":
        case "wbr":
            a.push($47e94abb28b53633$var$A(b));
            for(var D in c)if ($47e94abb28b53633$var$p.call(c, D) && (e = c[D], null != e)) switch(D){
                case "children":
                case "dangerouslySetInnerHTML":
                    throw Error($47e94abb28b53633$var$l(399, b));
                default:
                    $47e94abb28b53633$var$x(a, d, D, e);
            }
            a.push("/>");
            return null;
        case "annotation-xml":
        case "color-profile":
        case "font-face":
        case "font-face-src":
        case "font-face-uri":
        case "font-face-format":
        case "font-face-name":
        case "missing-glyph":
            return $47e94abb28b53633$var$va(a, c, b, d);
        case "html":
            return 0 === f.insertionMode && a.push("<!DOCTYPE html>"), $47e94abb28b53633$var$va(a, c, b, d);
        default:
            if (-1 === b.indexOf("-") && "string" !== typeof c.is) return $47e94abb28b53633$var$va(a, c, b, d);
            a.push($47e94abb28b53633$var$A(b));
            g = e = null;
            for(m in c)if ($47e94abb28b53633$var$p.call(c, m) && (h = c[m], null != h)) switch(m){
                case "children":
                    e = h;
                    break;
                case "dangerouslySetInnerHTML":
                    g = h;
                    break;
                case "style":
                    $47e94abb28b53633$var$ta(a, d, h);
                    break;
                case "suppressContentEditableWarning":
                case "suppressHydrationWarning":
                    break;
                default:
                    $47e94abb28b53633$var$ja(m) && "function" !== typeof h && "symbol" !== typeof h && a.push(" ", m, '="', $47e94abb28b53633$var$v(h), '"');
            }
            a.push(">");
            $47e94abb28b53633$var$y(a, g, e);
            return e;
    }
}
function $47e94abb28b53633$var$za(a, b, c) {
    a.push('\x3c!--$?--\x3e<template id="');
    if (null === c) throw Error($47e94abb28b53633$var$l(395));
    a.push(c);
    return a.push('"></template>');
}
function $47e94abb28b53633$var$Aa(a, b, c, d) {
    switch(c.insertionMode){
        case 0:
        case 1:
            return a.push('<div hidden id="'), a.push(b.segmentPrefix), b = d.toString(16), a.push(b), a.push('">');
        case 2:
            return a.push('<svg aria-hidden="true" style="display:none" id="'), a.push(b.segmentPrefix), b = d.toString(16), a.push(b), a.push('">');
        case 3:
            return a.push('<math aria-hidden="true" style="display:none" id="'), a.push(b.segmentPrefix), b = d.toString(16), a.push(b), a.push('">');
        case 4:
            return a.push('<table hidden id="'), a.push(b.segmentPrefix), b = d.toString(16), a.push(b), a.push('">');
        case 5:
            return a.push('<table hidden><tbody id="'), a.push(b.segmentPrefix), b = d.toString(16), a.push(b), a.push('">');
        case 6:
            return a.push('<table hidden><tr id="'), a.push(b.segmentPrefix), b = d.toString(16), a.push(b), a.push('">');
        case 7:
            return a.push('<table hidden><colgroup id="'), a.push(b.segmentPrefix), b = d.toString(16), a.push(b), a.push('">');
        default:
            throw Error($47e94abb28b53633$var$l(397));
    }
}
function $47e94abb28b53633$var$Ba(a, b) {
    switch(b.insertionMode){
        case 0:
        case 1:
            return a.push("</div>");
        case 2:
            return a.push("</svg>");
        case 3:
            return a.push("</math>");
        case 4:
            return a.push("</table>");
        case 5:
            return a.push("</tbody></table>");
        case 6:
            return a.push("</tr></table>");
        case 7:
            return a.push("</colgroup></table>");
        default:
            throw Error($47e94abb28b53633$var$l(397));
    }
}
var $47e94abb28b53633$var$Ca = /[<\u2028\u2029]/g;
function $47e94abb28b53633$var$Da(a) {
    return JSON.stringify(a).replace($47e94abb28b53633$var$Ca, function(a) {
        switch(a){
            case "<":
                return "\\u003c";
            case "\u2028":
                return "\\u2028";
            case "\u2029":
                return "\\u2029";
            default:
                throw Error("escapeJSStringsForInstructionScripts encountered a match it does not know how to replace. this means the match regex and the replacement characters are no longer in sync. This is a bug in React");
        }
    });
}
function $47e94abb28b53633$var$Ea(a, b) {
    b = void 0 === b ? "" : b;
    return {
        bootstrapChunks: [],
        startInlineScript: "<script>",
        placeholderPrefix: b + "P:",
        segmentPrefix: b + "S:",
        boundaryPrefix: b + "B:",
        idPrefix: b,
        nextSuspenseID: 0,
        sentCompleteSegmentFunction: !1,
        sentCompleteBoundaryFunction: !1,
        sentClientRenderFunction: !1,
        generateStaticMarkup: a
    };
}
function $47e94abb28b53633$var$Fa(a, b, c, d) {
    if (c.generateStaticMarkup) return a.push($47e94abb28b53633$var$v(b)), !1;
    "" === b ? a = d : (d && a.push("\x3c!-- --\x3e"), a.push($47e94abb28b53633$var$v(b)), a = !0);
    return a;
}
var $47e94abb28b53633$var$B = Object.assign, $47e94abb28b53633$var$Ga = Symbol.for("react.element"), $47e94abb28b53633$var$Ha = Symbol.for("react.portal"), $47e94abb28b53633$var$Ia = Symbol.for("react.fragment"), $47e94abb28b53633$var$Ja = Symbol.for("react.strict_mode"), $47e94abb28b53633$var$Ka = Symbol.for("react.profiler"), $47e94abb28b53633$var$La = Symbol.for("react.provider"), $47e94abb28b53633$var$Ma = Symbol.for("react.context"), $47e94abb28b53633$var$Na = Symbol.for("react.forward_ref"), $47e94abb28b53633$var$Oa = Symbol.for("react.suspense"), $47e94abb28b53633$var$Pa = Symbol.for("react.suspense_list"), $47e94abb28b53633$var$Qa = Symbol.for("react.memo"), $47e94abb28b53633$var$Ra = Symbol.for("react.lazy"), $47e94abb28b53633$var$Sa = Symbol.for("react.scope"), $47e94abb28b53633$var$Ta = Symbol.for("react.debug_trace_mode"), $47e94abb28b53633$var$Ua = Symbol.for("react.legacy_hidden"), $47e94abb28b53633$var$Va = Symbol.for("react.default_value"), $47e94abb28b53633$var$Wa = Symbol.iterator;
function $47e94abb28b53633$var$Xa(a) {
    if (null == a) return null;
    if ("function" === typeof a) return a.displayName || a.name || null;
    if ("string" === typeof a) return a;
    switch(a){
        case $47e94abb28b53633$var$Ia:
            return "Fragment";
        case $47e94abb28b53633$var$Ha:
            return "Portal";
        case $47e94abb28b53633$var$Ka:
            return "Profiler";
        case $47e94abb28b53633$var$Ja:
            return "StrictMode";
        case $47e94abb28b53633$var$Oa:
            return "Suspense";
        case $47e94abb28b53633$var$Pa:
            return "SuspenseList";
    }
    if ("object" === typeof a) switch(a.$$typeof){
        case $47e94abb28b53633$var$Ma:
            return (a.displayName || "Context") + ".Consumer";
        case $47e94abb28b53633$var$La:
            return (a._context.displayName || "Context") + ".Provider";
        case $47e94abb28b53633$var$Na:
            var b = a.render;
            a = a.displayName;
            a || (a = b.displayName || b.name || "", a = "" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
            return a;
        case $47e94abb28b53633$var$Qa:
            return b = a.displayName || null, null !== b ? b : $47e94abb28b53633$var$Xa(a.type) || "Memo";
        case $47e94abb28b53633$var$Ra:
            b = a._payload;
            a = a._init;
            try {
                return $47e94abb28b53633$var$Xa(a(b));
            } catch (c) {}
    }
    return null;
}
var $47e94abb28b53633$var$Ya = {};
function $47e94abb28b53633$var$Za(a, b) {
    a = a.contextTypes;
    if (!a) return $47e94abb28b53633$var$Ya;
    var c = {}, d;
    for(d in a)c[d] = b[d];
    return c;
}
var $47e94abb28b53633$var$E = null;
function $47e94abb28b53633$var$F(a, b) {
    if (a !== b) {
        a.context._currentValue2 = a.parentValue;
        a = a.parent;
        var c = b.parent;
        if (null === a) {
            if (null !== c) throw Error($47e94abb28b53633$var$l(401));
        } else {
            if (null === c) throw Error($47e94abb28b53633$var$l(401));
            $47e94abb28b53633$var$F(a, c);
        }
        b.context._currentValue2 = b.value;
    }
}
function $47e94abb28b53633$var$$a(a) {
    a.context._currentValue2 = a.parentValue;
    a = a.parent;
    null !== a && $47e94abb28b53633$var$$a(a);
}
function $47e94abb28b53633$var$ab(a) {
    var b = a.parent;
    null !== b && $47e94abb28b53633$var$ab(b);
    a.context._currentValue2 = a.value;
}
function $47e94abb28b53633$var$bb(a, b) {
    a.context._currentValue2 = a.parentValue;
    a = a.parent;
    if (null === a) throw Error($47e94abb28b53633$var$l(402));
    a.depth === b.depth ? $47e94abb28b53633$var$F(a, b) : $47e94abb28b53633$var$bb(a, b);
}
function $47e94abb28b53633$var$cb(a, b) {
    var c = b.parent;
    if (null === c) throw Error($47e94abb28b53633$var$l(402));
    a.depth === c.depth ? $47e94abb28b53633$var$F(a, c) : $47e94abb28b53633$var$cb(a, c);
    b.context._currentValue2 = b.value;
}
function $47e94abb28b53633$var$G(a) {
    var b = $47e94abb28b53633$var$E;
    b !== a && (null === b ? $47e94abb28b53633$var$ab(a) : null === a ? $47e94abb28b53633$var$$a(b) : b.depth === a.depth ? $47e94abb28b53633$var$F(b, a) : b.depth > a.depth ? $47e94abb28b53633$var$bb(b, a) : $47e94abb28b53633$var$cb(b, a), $47e94abb28b53633$var$E = a);
}
var $47e94abb28b53633$var$db = {
    isMounted: function() {
        return !1;
    },
    enqueueSetState: function(a, b) {
        a = a._reactInternals;
        null !== a.queue && a.queue.push(b);
    },
    enqueueReplaceState: function(a, b) {
        a = a._reactInternals;
        a.replace = !0;
        a.queue = [
            b
        ];
    },
    enqueueForceUpdate: function() {}
};
function $47e94abb28b53633$var$eb(a, b, c, d) {
    var f = void 0 !== a.state ? a.state : null;
    a.updater = $47e94abb28b53633$var$db;
    a.props = c;
    a.state = f;
    var e = {
        queue: [],
        replace: !1
    };
    a._reactInternals = e;
    var g = b.contextType;
    a.context = "object" === typeof g && null !== g ? g._currentValue2 : d;
    g = b.getDerivedStateFromProps;
    "function" === typeof g && (g = g(c, f), f = null === g || void 0 === g ? f : $47e94abb28b53633$var$B({}, f, g), a.state = f);
    if ("function" !== typeof b.getDerivedStateFromProps && "function" !== typeof a.getSnapshotBeforeUpdate && ("function" === typeof a.UNSAFE_componentWillMount || "function" === typeof a.componentWillMount)) {
        if (b = a.state, "function" === typeof a.componentWillMount && a.componentWillMount(), "function" === typeof a.UNSAFE_componentWillMount && a.UNSAFE_componentWillMount(), b !== a.state && $47e94abb28b53633$var$db.enqueueReplaceState(a, a.state, null), null !== e.queue && 0 < e.queue.length) {
            if (b = e.queue, g = e.replace, e.queue = null, e.replace = !1, g && 1 === b.length) a.state = b[0];
            else {
                e = g ? b[0] : a.state;
                f = !0;
                for(g = g ? 1 : 0; g < b.length; g++){
                    var h = b[g];
                    h = "function" === typeof h ? h.call(a, e, c, d) : h;
                    null != h && (f ? (f = !1, e = $47e94abb28b53633$var$B({}, e, h)) : $47e94abb28b53633$var$B(e, h));
                }
                a.state = e;
            }
        } else e.queue = null;
    }
}
var $47e94abb28b53633$var$fb = {
    id: 1,
    overflow: ""
};
function $47e94abb28b53633$var$gb(a, b, c) {
    var d = a.id;
    a = a.overflow;
    var f = 32 - $47e94abb28b53633$var$H(d) - 1;
    d &= ~(1 << f);
    c += 1;
    var e = 32 - $47e94abb28b53633$var$H(b) + f;
    if (30 < e) {
        var g = f - f % 5;
        e = (d & (1 << g) - 1).toString(32);
        d >>= g;
        f -= g;
        return {
            id: 1 << 32 - $47e94abb28b53633$var$H(b) + f | c << f | d,
            overflow: e + a
        };
    }
    return {
        id: 1 << e | c << f | d,
        overflow: a
    };
}
var $47e94abb28b53633$var$H = Math.clz32 ? Math.clz32 : $47e94abb28b53633$var$hb, $47e94abb28b53633$var$ib = Math.log, $47e94abb28b53633$var$jb = Math.LN2;
function $47e94abb28b53633$var$hb(a) {
    a >>>= 0;
    return 0 === a ? 32 : 31 - ($47e94abb28b53633$var$ib(a) / $47e94abb28b53633$var$jb | 0) | 0;
}
function $47e94abb28b53633$var$kb(a, b) {
    return a === b && (0 !== a || 1 / a === 1 / b) || a !== a && b !== b;
}
var $47e94abb28b53633$var$lb = "function" === typeof Object.is ? Object.is : $47e94abb28b53633$var$kb, $47e94abb28b53633$var$I = null, $47e94abb28b53633$var$ob = null, $47e94abb28b53633$var$J = null, $47e94abb28b53633$var$K = null, $47e94abb28b53633$var$L = !1, $47e94abb28b53633$var$M = !1, $47e94abb28b53633$var$N = 0, $47e94abb28b53633$var$O = null, $47e94abb28b53633$var$P = 0;
function $47e94abb28b53633$var$Q() {
    if (null === $47e94abb28b53633$var$I) throw Error($47e94abb28b53633$var$l(321));
    return $47e94abb28b53633$var$I;
}
function $47e94abb28b53633$var$pb() {
    if (0 < $47e94abb28b53633$var$P) throw Error($47e94abb28b53633$var$l(312));
    return {
        memoizedState: null,
        queue: null,
        next: null
    };
}
function $47e94abb28b53633$var$qb() {
    null === $47e94abb28b53633$var$K ? null === $47e94abb28b53633$var$J ? ($47e94abb28b53633$var$L = !1, $47e94abb28b53633$var$J = $47e94abb28b53633$var$K = $47e94abb28b53633$var$pb()) : ($47e94abb28b53633$var$L = !0, $47e94abb28b53633$var$K = $47e94abb28b53633$var$J) : null === $47e94abb28b53633$var$K.next ? ($47e94abb28b53633$var$L = !1, $47e94abb28b53633$var$K = $47e94abb28b53633$var$K.next = $47e94abb28b53633$var$pb()) : ($47e94abb28b53633$var$L = !0, $47e94abb28b53633$var$K = $47e94abb28b53633$var$K.next);
    return $47e94abb28b53633$var$K;
}
function $47e94abb28b53633$var$rb() {
    $47e94abb28b53633$var$ob = $47e94abb28b53633$var$I = null;
    $47e94abb28b53633$var$M = !1;
    $47e94abb28b53633$var$J = null;
    $47e94abb28b53633$var$P = 0;
    $47e94abb28b53633$var$K = $47e94abb28b53633$var$O = null;
}
function $47e94abb28b53633$var$sb(a, b) {
    return "function" === typeof b ? b(a) : b;
}
function $47e94abb28b53633$var$tb(a, b, c) {
    $47e94abb28b53633$var$I = $47e94abb28b53633$var$Q();
    $47e94abb28b53633$var$K = $47e94abb28b53633$var$qb();
    if ($47e94abb28b53633$var$L) {
        var d = $47e94abb28b53633$var$K.queue;
        b = d.dispatch;
        if (null !== $47e94abb28b53633$var$O && (c = $47e94abb28b53633$var$O.get(d), void 0 !== c)) {
            $47e94abb28b53633$var$O.delete(d);
            d = $47e94abb28b53633$var$K.memoizedState;
            do d = a(d, c.action), c = c.next;
            while (null !== c);
            $47e94abb28b53633$var$K.memoizedState = d;
            return [
                d,
                b
            ];
        }
        return [
            $47e94abb28b53633$var$K.memoizedState,
            b
        ];
    }
    a = a === $47e94abb28b53633$var$sb ? "function" === typeof b ? b() : b : void 0 !== c ? c(b) : b;
    $47e94abb28b53633$var$K.memoizedState = a;
    a = $47e94abb28b53633$var$K.queue = {
        last: null,
        dispatch: null
    };
    a = a.dispatch = $47e94abb28b53633$var$ub.bind(null, $47e94abb28b53633$var$I, a);
    return [
        $47e94abb28b53633$var$K.memoizedState,
        a
    ];
}
function $47e94abb28b53633$var$vb(a, b) {
    $47e94abb28b53633$var$I = $47e94abb28b53633$var$Q();
    $47e94abb28b53633$var$K = $47e94abb28b53633$var$qb();
    b = void 0 === b ? null : b;
    if (null !== $47e94abb28b53633$var$K) {
        var c = $47e94abb28b53633$var$K.memoizedState;
        if (null !== c && null !== b) {
            var d = c[1];
            a: if (null === d) d = !1;
            else {
                for(var f = 0; f < d.length && f < b.length; f++)if (!$47e94abb28b53633$var$lb(b[f], d[f])) {
                    d = !1;
                    break a;
                }
                d = !0;
            }
            if (d) return c[0];
        }
    }
    a = a();
    $47e94abb28b53633$var$K.memoizedState = [
        a,
        b
    ];
    return a;
}
function $47e94abb28b53633$var$ub(a, b, c) {
    if (25 <= $47e94abb28b53633$var$P) throw Error($47e94abb28b53633$var$l(301));
    if (a === $47e94abb28b53633$var$I) {
        if ($47e94abb28b53633$var$M = !0, a = {
            action: c,
            next: null
        }, null === $47e94abb28b53633$var$O && ($47e94abb28b53633$var$O = new Map), c = $47e94abb28b53633$var$O.get(b), void 0 === c) $47e94abb28b53633$var$O.set(b, a);
        else {
            for(b = c; null !== b.next;)b = b.next;
            b.next = a;
        }
    }
}
function $47e94abb28b53633$var$wb() {
    throw Error($47e94abb28b53633$var$l(394));
}
function $47e94abb28b53633$var$R() {}
var $47e94abb28b53633$var$xb = {
    readContext: function(a) {
        return a._currentValue2;
    },
    useContext: function(a) {
        $47e94abb28b53633$var$Q();
        return a._currentValue2;
    },
    useMemo: $47e94abb28b53633$var$vb,
    useReducer: $47e94abb28b53633$var$tb,
    useRef: function(a) {
        $47e94abb28b53633$var$I = $47e94abb28b53633$var$Q();
        $47e94abb28b53633$var$K = $47e94abb28b53633$var$qb();
        var b = $47e94abb28b53633$var$K.memoizedState;
        return null === b ? (a = {
            current: a
        }, $47e94abb28b53633$var$K.memoizedState = a) : b;
    },
    useState: function(a) {
        return $47e94abb28b53633$var$tb($47e94abb28b53633$var$sb, a);
    },
    useInsertionEffect: $47e94abb28b53633$var$R,
    useLayoutEffect: function() {},
    useCallback: function(a, b) {
        return $47e94abb28b53633$var$vb(function() {
            return a;
        }, b);
    },
    useImperativeHandle: $47e94abb28b53633$var$R,
    useEffect: $47e94abb28b53633$var$R,
    useDebugValue: $47e94abb28b53633$var$R,
    useDeferredValue: function(a) {
        $47e94abb28b53633$var$Q();
        return a;
    },
    useTransition: function() {
        $47e94abb28b53633$var$Q();
        return [
            !1,
            $47e94abb28b53633$var$wb
        ];
    },
    useId: function() {
        var a = $47e94abb28b53633$var$ob.treeContext;
        var b = a.overflow;
        a = a.id;
        a = (a & ~(1 << 32 - $47e94abb28b53633$var$H(a) - 1)).toString(32) + b;
        var c = $47e94abb28b53633$var$S;
        if (null === c) throw Error($47e94abb28b53633$var$l(404));
        b = $47e94abb28b53633$var$N++;
        a = ":" + c.idPrefix + "R" + a;
        0 < b && (a += "H" + b.toString(32));
        return a + ":";
    },
    useMutableSource: function(a, b) {
        $47e94abb28b53633$var$Q();
        return b(a._source);
    },
    useSyncExternalStore: function(a, b, c) {
        if (void 0 === c) throw Error($47e94abb28b53633$var$l(407));
        return c();
    }
}, $47e94abb28b53633$var$S = null, $47e94abb28b53633$var$yb = $5uXOq.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentDispatcher;
function $47e94abb28b53633$var$zb(a) {
    console.error(a);
    return null;
}
function $47e94abb28b53633$var$T() {}
function $47e94abb28b53633$var$Ab(a, b, c, d, f, e, g, h, k) {
    var m = [], n = new Set;
    b = {
        destination: null,
        responseState: b,
        progressiveChunkSize: void 0 === d ? 12800 : d,
        status: 0,
        fatalError: null,
        nextSegmentId: 0,
        allPendingTasks: 0,
        pendingRootTasks: 0,
        completedRootSegment: null,
        abortableTasks: n,
        pingedTasks: m,
        clientRenderedBoundaries: [],
        completedBoundaries: [],
        partialBoundaries: [],
        onError: void 0 === f ? $47e94abb28b53633$var$zb : f,
        onAllReady: void 0 === e ? $47e94abb28b53633$var$T : e,
        onShellReady: void 0 === g ? $47e94abb28b53633$var$T : g,
        onShellError: void 0 === h ? $47e94abb28b53633$var$T : h,
        onFatalError: void 0 === k ? $47e94abb28b53633$var$T : k
    };
    c = $47e94abb28b53633$var$U(b, 0, null, c, !1, !1);
    c.parentFlushed = !0;
    a = $47e94abb28b53633$var$Bb(b, a, null, c, n, $47e94abb28b53633$var$Ya, null, $47e94abb28b53633$var$fb);
    m.push(a);
    return b;
}
function $47e94abb28b53633$var$Bb(a, b, c, d, f, e, g, h) {
    a.allPendingTasks++;
    null === c ? a.pendingRootTasks++ : c.pendingTasks++;
    var k = {
        node: b,
        ping: function() {
            var b = a.pingedTasks;
            b.push(k);
            1 === b.length && $47e94abb28b53633$var$Cb(a);
        },
        blockedBoundary: c,
        blockedSegment: d,
        abortSet: f,
        legacyContext: e,
        context: g,
        treeContext: h
    };
    f.add(k);
    return k;
}
function $47e94abb28b53633$var$U(a, b, c, d, f, e) {
    return {
        status: 0,
        id: -1,
        index: b,
        parentFlushed: !1,
        chunks: [],
        children: [],
        formatContext: d,
        boundary: c,
        lastPushedText: f,
        textEmbedded: e
    };
}
function $47e94abb28b53633$var$V(a, b) {
    a = a.onError(b);
    if (null != a && "string" !== typeof a) throw Error('onError returned something with a type other than "string". onError should return a string and may return null or undefined but must not return anything else. It received something of type "' + typeof a + '" instead');
    return a;
}
function $47e94abb28b53633$var$W(a, b) {
    var c = a.onShellError;
    c(b);
    c = a.onFatalError;
    c(b);
    null !== a.destination ? (a.status = 2, a.destination.destroy(b)) : (a.status = 1, a.fatalError = b);
}
function $47e94abb28b53633$var$Db(a, b, c, d, f) {
    $47e94abb28b53633$var$I = {};
    $47e94abb28b53633$var$ob = b;
    $47e94abb28b53633$var$N = 0;
    for(a = c(d, f); $47e94abb28b53633$var$M;)$47e94abb28b53633$var$M = !1, $47e94abb28b53633$var$N = 0, $47e94abb28b53633$var$P += 1, $47e94abb28b53633$var$K = null, a = c(d, f);
    $47e94abb28b53633$var$rb();
    return a;
}
function $47e94abb28b53633$var$Eb(a, b, c, d) {
    var f = c.render(), e = d.childContextTypes;
    if (null !== e && void 0 !== e) {
        var g = b.legacyContext;
        if ("function" !== typeof c.getChildContext) d = g;
        else {
            c = c.getChildContext();
            for(var h in c)if (!(h in e)) throw Error($47e94abb28b53633$var$l(108, $47e94abb28b53633$var$Xa(d) || "Unknown", h));
            d = $47e94abb28b53633$var$B({}, g, c);
        }
        b.legacyContext = d;
        $47e94abb28b53633$var$X(a, b, f);
        b.legacyContext = g;
    } else $47e94abb28b53633$var$X(a, b, f);
}
function $47e94abb28b53633$var$Fb(a, b) {
    if (a && a.defaultProps) {
        b = $47e94abb28b53633$var$B({}, b);
        a = a.defaultProps;
        for(var c in a)void 0 === b[c] && (b[c] = a[c]);
        return b;
    }
    return b;
}
function $47e94abb28b53633$var$Gb(a, b, c, d, f) {
    if ("function" === typeof c) {
        if (c.prototype && c.prototype.isReactComponent) {
            f = $47e94abb28b53633$var$Za(c, b.legacyContext);
            var e = c.contextType;
            e = new c(d, "object" === typeof e && null !== e ? e._currentValue2 : f);
            $47e94abb28b53633$var$eb(e, c, d, f);
            $47e94abb28b53633$var$Eb(a, b, e, c);
        } else {
            e = $47e94abb28b53633$var$Za(c, b.legacyContext);
            f = $47e94abb28b53633$var$Db(a, b, c, d, e);
            var g = 0 !== $47e94abb28b53633$var$N;
            if ("object" === typeof f && null !== f && "function" === typeof f.render && void 0 === f.$$typeof) $47e94abb28b53633$var$eb(f, c, d, e), $47e94abb28b53633$var$Eb(a, b, f, c);
            else if (g) {
                d = b.treeContext;
                b.treeContext = $47e94abb28b53633$var$gb(d, 1, 0);
                try {
                    $47e94abb28b53633$var$X(a, b, f);
                } finally{
                    b.treeContext = d;
                }
            } else $47e94abb28b53633$var$X(a, b, f);
        }
    } else if ("string" === typeof c) {
        f = b.blockedSegment;
        e = $47e94abb28b53633$var$ya(f.chunks, c, d, a.responseState, f.formatContext);
        f.lastPushedText = !1;
        g = f.formatContext;
        f.formatContext = $47e94abb28b53633$var$ra(g, c, d);
        $47e94abb28b53633$var$Hb(a, b, e);
        f.formatContext = g;
        switch(c){
            case "area":
            case "base":
            case "br":
            case "col":
            case "embed":
            case "hr":
            case "img":
            case "input":
            case "keygen":
            case "link":
            case "meta":
            case "param":
            case "source":
            case "track":
            case "wbr":
                break;
            default:
                f.chunks.push("</", c, ">");
        }
        f.lastPushedText = !1;
    } else {
        switch(c){
            case $47e94abb28b53633$var$Ua:
            case $47e94abb28b53633$var$Ta:
            case $47e94abb28b53633$var$Ja:
            case $47e94abb28b53633$var$Ka:
            case $47e94abb28b53633$var$Ia:
                $47e94abb28b53633$var$X(a, b, d.children);
                return;
            case $47e94abb28b53633$var$Pa:
                $47e94abb28b53633$var$X(a, b, d.children);
                return;
            case $47e94abb28b53633$var$Sa:
                throw Error($47e94abb28b53633$var$l(343));
            case $47e94abb28b53633$var$Oa:
                a: {
                    c = b.blockedBoundary;
                    f = b.blockedSegment;
                    e = d.fallback;
                    d = d.children;
                    g = new Set;
                    var h = {
                        id: null,
                        rootSegmentID: -1,
                        parentFlushed: !1,
                        pendingTasks: 0,
                        forceClientRender: !1,
                        completedSegments: [],
                        byteSize: 0,
                        fallbackAbortableTasks: g,
                        errorDigest: null
                    }, k = $47e94abb28b53633$var$U(a, f.chunks.length, h, f.formatContext, !1, !1);
                    f.children.push(k);
                    f.lastPushedText = !1;
                    var m = $47e94abb28b53633$var$U(a, 0, null, f.formatContext, !1, !1);
                    m.parentFlushed = !0;
                    b.blockedBoundary = h;
                    b.blockedSegment = m;
                    try {
                        if ($47e94abb28b53633$var$Hb(a, b, d), a.responseState.generateStaticMarkup || m.lastPushedText && m.textEmbedded && m.chunks.push("\x3c!-- --\x3e"), m.status = 1, $47e94abb28b53633$var$Y(h, m), 0 === h.pendingTasks) break a;
                    } catch (n) {
                        m.status = 4, h.forceClientRender = !0, h.errorDigest = $47e94abb28b53633$var$V(a, n);
                    } finally{
                        b.blockedBoundary = c, b.blockedSegment = f;
                    }
                    b = $47e94abb28b53633$var$Bb(a, e, c, k, g, b.legacyContext, b.context, b.treeContext);
                    a.pingedTasks.push(b);
                }
                return;
        }
        if ("object" === typeof c && null !== c) switch(c.$$typeof){
            case $47e94abb28b53633$var$Na:
                d = $47e94abb28b53633$var$Db(a, b, c.render, d, f);
                if (0 !== $47e94abb28b53633$var$N) {
                    c = b.treeContext;
                    b.treeContext = $47e94abb28b53633$var$gb(c, 1, 0);
                    try {
                        $47e94abb28b53633$var$X(a, b, d);
                    } finally{
                        b.treeContext = c;
                    }
                } else $47e94abb28b53633$var$X(a, b, d);
                return;
            case $47e94abb28b53633$var$Qa:
                c = c.type;
                d = $47e94abb28b53633$var$Fb(c, d);
                $47e94abb28b53633$var$Gb(a, b, c, d, f);
                return;
            case $47e94abb28b53633$var$La:
                f = d.children;
                c = c._context;
                d = d.value;
                e = c._currentValue2;
                c._currentValue2 = d;
                g = $47e94abb28b53633$var$E;
                $47e94abb28b53633$var$E = d = {
                    parent: g,
                    depth: null === g ? 0 : g.depth + 1,
                    context: c,
                    parentValue: e,
                    value: d
                };
                b.context = d;
                $47e94abb28b53633$var$X(a, b, f);
                a = $47e94abb28b53633$var$E;
                if (null === a) throw Error($47e94abb28b53633$var$l(403));
                d = a.parentValue;
                a.context._currentValue2 = d === $47e94abb28b53633$var$Va ? a.context._defaultValue : d;
                a = $47e94abb28b53633$var$E = a.parent;
                b.context = a;
                return;
            case $47e94abb28b53633$var$Ma:
                d = d.children;
                d = d(c._currentValue2);
                $47e94abb28b53633$var$X(a, b, d);
                return;
            case $47e94abb28b53633$var$Ra:
                f = c._init;
                c = f(c._payload);
                d = $47e94abb28b53633$var$Fb(c, d);
                $47e94abb28b53633$var$Gb(a, b, c, d, void 0);
                return;
        }
        throw Error($47e94abb28b53633$var$l(130, null == c ? c : typeof c, ""));
    }
}
function $47e94abb28b53633$var$X(a, b, c) {
    b.node = c;
    if ("object" === typeof c && null !== c) {
        switch(c.$$typeof){
            case $47e94abb28b53633$var$Ga:
                $47e94abb28b53633$var$Gb(a, b, c.type, c.props, c.ref);
                return;
            case $47e94abb28b53633$var$Ha:
                throw Error($47e94abb28b53633$var$l(257));
            case $47e94abb28b53633$var$Ra:
                var d = c._init;
                c = d(c._payload);
                $47e94abb28b53633$var$X(a, b, c);
                return;
        }
        if ($47e94abb28b53633$var$qa(c)) {
            $47e94abb28b53633$var$Ib(a, b, c);
            return;
        }
        null === c || "object" !== typeof c ? d = null : (d = $47e94abb28b53633$var$Wa && c[$47e94abb28b53633$var$Wa] || c["@@iterator"], d = "function" === typeof d ? d : null);
        if (d && (d = d.call(c))) {
            c = d.next();
            if (!c.done) {
                var f = [];
                do f.push(c.value), c = d.next();
                while (!c.done);
                $47e94abb28b53633$var$Ib(a, b, f);
            }
            return;
        }
        a = Object.prototype.toString.call(c);
        throw Error($47e94abb28b53633$var$l(31, "[object Object]" === a ? "object with keys {" + Object.keys(c).join(", ") + "}" : a));
    }
    "string" === typeof c ? (d = b.blockedSegment, d.lastPushedText = $47e94abb28b53633$var$Fa(b.blockedSegment.chunks, c, a.responseState, d.lastPushedText)) : "number" === typeof c && (d = b.blockedSegment, d.lastPushedText = $47e94abb28b53633$var$Fa(b.blockedSegment.chunks, "" + c, a.responseState, d.lastPushedText));
}
function $47e94abb28b53633$var$Ib(a, b, c) {
    for(var d = c.length, f = 0; f < d; f++){
        var e = b.treeContext;
        b.treeContext = $47e94abb28b53633$var$gb(e, d, f);
        try {
            $47e94abb28b53633$var$Hb(a, b, c[f]);
        } finally{
            b.treeContext = e;
        }
    }
}
function $47e94abb28b53633$var$Hb(a, b, c) {
    var d = b.blockedSegment.formatContext, f = b.legacyContext, e = b.context;
    try {
        return $47e94abb28b53633$var$X(a, b, c);
    } catch (k) {
        if ($47e94abb28b53633$var$rb(), "object" === typeof k && null !== k && "function" === typeof k.then) {
            c = k;
            var g = b.blockedSegment, h = $47e94abb28b53633$var$U(a, g.chunks.length, null, g.formatContext, g.lastPushedText, !0);
            g.children.push(h);
            g.lastPushedText = !1;
            a = $47e94abb28b53633$var$Bb(a, b.node, b.blockedBoundary, h, b.abortSet, b.legacyContext, b.context, b.treeContext).ping;
            c.then(a, a);
            b.blockedSegment.formatContext = d;
            b.legacyContext = f;
            b.context = e;
            $47e94abb28b53633$var$G(e);
        } else throw b.blockedSegment.formatContext = d, b.legacyContext = f, b.context = e, $47e94abb28b53633$var$G(e), k;
    }
}
function $47e94abb28b53633$var$Jb(a) {
    var b = a.blockedBoundary;
    a = a.blockedSegment;
    a.status = 3;
    $47e94abb28b53633$var$Kb(this, b, a);
}
function $47e94abb28b53633$var$Lb(a, b, c) {
    var d = a.blockedBoundary;
    a.blockedSegment.status = 3;
    null === d ? (b.allPendingTasks--, 2 !== b.status && (b.status = 2, null !== b.destination && b.destination.push(null))) : (d.pendingTasks--, d.forceClientRender || (d.forceClientRender = !0, a = void 0 === c ? Error($47e94abb28b53633$var$l(432)) : c, d.errorDigest = b.onError(a), d.parentFlushed && b.clientRenderedBoundaries.push(d)), d.fallbackAbortableTasks.forEach(function(a) {
        return $47e94abb28b53633$var$Lb(a, b, c);
    }), d.fallbackAbortableTasks.clear(), b.allPendingTasks--, 0 === b.allPendingTasks && (d = b.onAllReady, d()));
}
function $47e94abb28b53633$var$Y(a, b) {
    if (0 === b.chunks.length && 1 === b.children.length && null === b.children[0].boundary) {
        var c = b.children[0];
        c.id = b.id;
        c.parentFlushed = !0;
        1 === c.status && $47e94abb28b53633$var$Y(a, c);
    } else a.completedSegments.push(b);
}
function $47e94abb28b53633$var$Kb(a, b, c) {
    if (null === b) {
        if (c.parentFlushed) {
            if (null !== a.completedRootSegment) throw Error($47e94abb28b53633$var$l(389));
            a.completedRootSegment = c;
        }
        a.pendingRootTasks--;
        0 === a.pendingRootTasks && (a.onShellError = $47e94abb28b53633$var$T, b = a.onShellReady, b());
    } else b.pendingTasks--, b.forceClientRender || (0 === b.pendingTasks ? (c.parentFlushed && 1 === c.status && $47e94abb28b53633$var$Y(b, c), b.parentFlushed && a.completedBoundaries.push(b), b.fallbackAbortableTasks.forEach($47e94abb28b53633$var$Jb, a), b.fallbackAbortableTasks.clear()) : c.parentFlushed && 1 === c.status && ($47e94abb28b53633$var$Y(b, c), 1 === b.completedSegments.length && b.parentFlushed && a.partialBoundaries.push(b)));
    a.allPendingTasks--;
    0 === a.allPendingTasks && (a = a.onAllReady, a());
}
function $47e94abb28b53633$var$Cb(a) {
    if (2 !== a.status) {
        var b = $47e94abb28b53633$var$E, c = $47e94abb28b53633$var$yb.current;
        $47e94abb28b53633$var$yb.current = $47e94abb28b53633$var$xb;
        var d = $47e94abb28b53633$var$S;
        $47e94abb28b53633$var$S = a.responseState;
        try {
            var f = a.pingedTasks, e;
            for(e = 0; e < f.length; e++){
                var g = f[e];
                var h = a, k = g.blockedSegment;
                if (0 === k.status) {
                    $47e94abb28b53633$var$G(g.context);
                    try {
                        $47e94abb28b53633$var$X(h, g, g.node), h.responseState.generateStaticMarkup || k.lastPushedText && k.textEmbedded && k.chunks.push("\x3c!-- --\x3e"), g.abortSet.delete(g), k.status = 1, $47e94abb28b53633$var$Kb(h, g.blockedBoundary, k);
                    } catch (z) {
                        if ($47e94abb28b53633$var$rb(), "object" === typeof z && null !== z && "function" === typeof z.then) {
                            var m = g.ping;
                            z.then(m, m);
                        } else {
                            g.abortSet.delete(g);
                            k.status = 4;
                            var n = g.blockedBoundary, q = z, C = $47e94abb28b53633$var$V(h, q);
                            null === n ? $47e94abb28b53633$var$W(h, q) : (n.pendingTasks--, n.forceClientRender || (n.forceClientRender = !0, n.errorDigest = C, n.parentFlushed && h.clientRenderedBoundaries.push(n)));
                            h.allPendingTasks--;
                            if (0 === h.allPendingTasks) {
                                var D = h.onAllReady;
                                D();
                            }
                        }
                    } finally{}
                }
            }
            f.splice(0, e);
            null !== a.destination && $47e94abb28b53633$var$Mb(a, a.destination);
        } catch (z) {
            $47e94abb28b53633$var$V(a, z), $47e94abb28b53633$var$W(a, z);
        } finally{
            $47e94abb28b53633$var$S = d, $47e94abb28b53633$var$yb.current = c, c === $47e94abb28b53633$var$xb && $47e94abb28b53633$var$G(b);
        }
    }
}
function $47e94abb28b53633$var$Z(a, b, c) {
    c.parentFlushed = !0;
    switch(c.status){
        case 0:
            var d = c.id = a.nextSegmentId++;
            c.lastPushedText = !1;
            c.textEmbedded = !1;
            a = a.responseState;
            b.push('<template id="');
            b.push(a.placeholderPrefix);
            a = d.toString(16);
            b.push(a);
            return b.push('"></template>');
        case 1:
            c.status = 2;
            var f = !0;
            d = c.chunks;
            var e = 0;
            c = c.children;
            for(var g = 0; g < c.length; g++){
                for(f = c[g]; e < f.index; e++)b.push(d[e]);
                f = $47e94abb28b53633$var$Nb(a, b, f);
            }
            for(; e < d.length - 1; e++)b.push(d[e]);
            e < d.length && (f = b.push(d[e]));
            return f;
        default:
            throw Error($47e94abb28b53633$var$l(390));
    }
}
function $47e94abb28b53633$var$Nb(a, b, c) {
    var d = c.boundary;
    if (null === d) return $47e94abb28b53633$var$Z(a, b, c);
    d.parentFlushed = !0;
    if (d.forceClientRender) return a.responseState.generateStaticMarkup || (d = d.errorDigest, b.push("\x3c!--$!--\x3e"), b.push("<template"), d && (b.push(' data-dgst="'), d = $47e94abb28b53633$var$v(d), b.push(d), b.push('"')), b.push("></template>")), $47e94abb28b53633$var$Z(a, b, c), a = a.responseState.generateStaticMarkup ? !0 : b.push("\x3c!--/$--\x3e"), a;
    if (0 < d.pendingTasks) {
        d.rootSegmentID = a.nextSegmentId++;
        0 < d.completedSegments.length && a.partialBoundaries.push(d);
        var f = a.responseState;
        var e = f.nextSuspenseID++;
        f = f.boundaryPrefix + e.toString(16);
        d = d.id = f;
        $47e94abb28b53633$var$za(b, a.responseState, d);
        $47e94abb28b53633$var$Z(a, b, c);
        return b.push("\x3c!--/$--\x3e");
    }
    if (d.byteSize > a.progressiveChunkSize) return d.rootSegmentID = a.nextSegmentId++, a.completedBoundaries.push(d), $47e94abb28b53633$var$za(b, a.responseState, d.id), $47e94abb28b53633$var$Z(a, b, c), b.push("\x3c!--/$--\x3e");
    a.responseState.generateStaticMarkup || b.push("\x3c!--$--\x3e");
    c = d.completedSegments;
    if (1 !== c.length) throw Error($47e94abb28b53633$var$l(391));
    $47e94abb28b53633$var$Nb(a, b, c[0]);
    a = a.responseState.generateStaticMarkup ? !0 : b.push("\x3c!--/$--\x3e");
    return a;
}
function $47e94abb28b53633$var$Ob(a, b, c) {
    $47e94abb28b53633$var$Aa(b, a.responseState, c.formatContext, c.id);
    $47e94abb28b53633$var$Nb(a, b, c);
    return $47e94abb28b53633$var$Ba(b, c.formatContext);
}
function $47e94abb28b53633$var$Pb(a, b, c) {
    for(var d = c.completedSegments, f = 0; f < d.length; f++)$47e94abb28b53633$var$Qb(a, b, c, d[f]);
    d.length = 0;
    a = a.responseState;
    d = c.id;
    c = c.rootSegmentID;
    b.push(a.startInlineScript);
    a.sentCompleteBoundaryFunction ? b.push('$RC("') : (a.sentCompleteBoundaryFunction = !0, b.push('function $RC(a,b){a=document.getElementById(a);b=document.getElementById(b);b.parentNode.removeChild(b);if(a){a=a.previousSibling;var f=a.parentNode,c=a.nextSibling,e=0;do{if(c&&8===c.nodeType){var d=c.data;if("/$"===d)if(0===e)break;else e--;else"$"!==d&&"$?"!==d&&"$!"!==d||e++}d=c.nextSibling;f.removeChild(c);c=d}while(c);for(;b.firstChild;)f.insertBefore(b.firstChild,c);a.data="$";a._reactRetry&&a._reactRetry()}};$RC("'));
    if (null === d) throw Error($47e94abb28b53633$var$l(395));
    c = c.toString(16);
    b.push(d);
    b.push('","');
    b.push(a.segmentPrefix);
    b.push(c);
    return b.push('")\x3c/script>');
}
function $47e94abb28b53633$var$Qb(a, b, c, d) {
    if (2 === d.status) return !0;
    var f = d.id;
    if (-1 === f) {
        if (-1 === (d.id = c.rootSegmentID)) throw Error($47e94abb28b53633$var$l(392));
        return $47e94abb28b53633$var$Ob(a, b, d);
    }
    $47e94abb28b53633$var$Ob(a, b, d);
    a = a.responseState;
    b.push(a.startInlineScript);
    a.sentCompleteSegmentFunction ? b.push('$RS("') : (a.sentCompleteSegmentFunction = !0, b.push('function $RS(a,b){a=document.getElementById(a);b=document.getElementById(b);for(a.parentNode.removeChild(a);a.firstChild;)b.parentNode.insertBefore(a.firstChild,b);b.parentNode.removeChild(b)};$RS("'));
    b.push(a.segmentPrefix);
    f = f.toString(16);
    b.push(f);
    b.push('","');
    b.push(a.placeholderPrefix);
    b.push(f);
    return b.push('")\x3c/script>');
}
function $47e94abb28b53633$var$Mb(a, b) {
    try {
        var c = a.completedRootSegment;
        if (null !== c && 0 === a.pendingRootTasks) {
            $47e94abb28b53633$var$Nb(a, b, c);
            a.completedRootSegment = null;
            var d = a.responseState.bootstrapChunks;
            for(c = 0; c < d.length - 1; c++)b.push(d[c]);
            c < d.length && b.push(d[c]);
        }
        var f = a.clientRenderedBoundaries, e;
        for(e = 0; e < f.length; e++){
            var g = f[e];
            d = b;
            var h = a.responseState, k = g.id, m = g.errorDigest, n = g.errorMessage, q = g.errorComponentStack;
            d.push(h.startInlineScript);
            h.sentClientRenderFunction ? d.push('$RX("') : (h.sentClientRenderFunction = !0, d.push('function $RX(b,c,d,e){var a=document.getElementById(b);a&&(b=a.previousSibling,b.data="$!",a=a.dataset,c&&(a.dgst=c),d&&(a.msg=d),e&&(a.stck=e),b._reactRetry&&b._reactRetry())};$RX("'));
            if (null === k) throw Error($47e94abb28b53633$var$l(395));
            d.push(k);
            d.push('"');
            if (m || n || q) {
                d.push(",");
                var C = $47e94abb28b53633$var$Da(m || "");
                d.push(C);
            }
            if (n || q) {
                d.push(",");
                var D = $47e94abb28b53633$var$Da(n || "");
                d.push(D);
            }
            if (q) {
                d.push(",");
                var z = $47e94abb28b53633$var$Da(q);
                d.push(z);
            }
            if (!d.push(")\x3c/script>")) {
                a.destination = null;
                e++;
                f.splice(0, e);
                return;
            }
        }
        f.splice(0, e);
        var ba = a.completedBoundaries;
        for(e = 0; e < ba.length; e++)if (!$47e94abb28b53633$var$Pb(a, b, ba[e])) {
            a.destination = null;
            e++;
            ba.splice(0, e);
            return;
        }
        ba.splice(0, e);
        var ca = a.partialBoundaries;
        for(e = 0; e < ca.length; e++){
            var mb = ca[e];
            a: {
                f = a;
                g = b;
                var da = mb.completedSegments;
                for(h = 0; h < da.length; h++)if (!$47e94abb28b53633$var$Qb(f, g, mb, da[h])) {
                    h++;
                    da.splice(0, h);
                    var nb = !1;
                    break a;
                }
                da.splice(0, h);
                nb = !0;
            }
            if (!nb) {
                a.destination = null;
                e++;
                ca.splice(0, e);
                return;
            }
        }
        ca.splice(0, e);
        var ea = a.completedBoundaries;
        for(e = 0; e < ea.length; e++)if (!$47e94abb28b53633$var$Pb(a, b, ea[e])) {
            a.destination = null;
            e++;
            ea.splice(0, e);
            return;
        }
        ea.splice(0, e);
    } finally{
        0 === a.allPendingTasks && 0 === a.pingedTasks.length && 0 === a.clientRenderedBoundaries.length && 0 === a.completedBoundaries.length && b.push(null);
    }
}
function $47e94abb28b53633$var$Rb(a, b) {
    try {
        var c = a.abortableTasks;
        c.forEach(function(c) {
            return $47e94abb28b53633$var$Lb(c, a, b);
        });
        c.clear();
        null !== a.destination && $47e94abb28b53633$var$Mb(a, a.destination);
    } catch (d) {
        $47e94abb28b53633$var$V(a, d), $47e94abb28b53633$var$W(a, d);
    }
}
function $47e94abb28b53633$var$Sb() {}
function $47e94abb28b53633$var$Tb(a, b, c, d) {
    var f = !1, e = null, g = "", h = {
        push: function(a) {
            null !== a && (g += a);
            return !0;
        },
        destroy: function(a) {
            f = !0;
            e = a;
        }
    }, k = !1;
    a = $47e94abb28b53633$var$Ab(a, $47e94abb28b53633$var$Ea(c, b ? b.identifierPrefix : void 0), {
        insertionMode: 1,
        selectedValue: null
    }, Infinity, $47e94abb28b53633$var$Sb, void 0, function() {
        k = !0;
    }, void 0, void 0);
    $47e94abb28b53633$var$Cb(a);
    $47e94abb28b53633$var$Rb(a, d);
    if (1 === a.status) a.status = 2, h.destroy(a.fatalError);
    else if (2 !== a.status && null === a.destination) {
        a.destination = h;
        try {
            $47e94abb28b53633$var$Mb(a, h);
        } catch (m) {
            $47e94abb28b53633$var$V(a, m), $47e94abb28b53633$var$W(a, m);
        }
    }
    if (f) throw e;
    if (!k) throw Error($47e94abb28b53633$var$l(426));
    return g;
}
$47e94abb28b53633$export$307591e98609eddd = function() {
    throw Error($47e94abb28b53633$var$l(207));
};
$47e94abb28b53633$export$eb3a06aef9e6ee51 = function(a, b) {
    return $47e94abb28b53633$var$Tb(a, b, !0, 'The server used "renderToStaticMarkup" which does not support Suspense. If you intended to have the server wait for the suspended component please switch to "renderToReadableStream" which supports Suspense on the server');
};
$47e94abb28b53633$export$b23711c915539651 = function() {
    throw Error($47e94abb28b53633$var$l(208));
};
$47e94abb28b53633$export$80e7718417253a51 = function(a, b) {
    return $47e94abb28b53633$var$Tb(a, b, !1, 'The server used "renderToString" which does not support Suspense. If you intended for this Suspense boundary to render the fallback content on the server consider throwing an Error somewhere within the Suspense boundary. If you intended to have the server wait for the suspended component please switch to "renderToReadableStream" which supports Suspense on the server');
};
$47e94abb28b53633$export$83d89fbfd8236492 = "18.2.0";

});

parcelRegister("l7JfX", function(module, exports) {

$parcel$export(module.exports, "renderToReadableStream", () => $f60d5b61c638db60$export$7020a3240b287705, (v) => $f60d5b61c638db60$export$7020a3240b287705 = v);
$parcel$export(module.exports, "version", () => $f60d5b61c638db60$export$83d89fbfd8236492, (v) => $f60d5b61c638db60$export$83d89fbfd8236492 = v);
/**
 * @license React
 * react-dom-server.browser.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $f60d5b61c638db60$export$7020a3240b287705;
var $f60d5b61c638db60$export$83d89fbfd8236492;
'use strict';

var $5uXOq = parcelRequire("5uXOq");
function $f60d5b61c638db60$var$k(a) {
    for(var b = "https://reactjs.org/docs/error-decoder.html?invariant=" + a, c = 1; c < arguments.length; c++)b += "&args[]=" + encodeURIComponent(arguments[c]);
    return "Minified React error #" + a + "; visit " + b + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
var $f60d5b61c638db60$var$l = null, $f60d5b61c638db60$var$n = 0;
function $f60d5b61c638db60$var$p(a, b) {
    if (0 !== b.length) {
        if (512 < b.length) 0 < $f60d5b61c638db60$var$n && (a.enqueue(new Uint8Array($f60d5b61c638db60$var$l.buffer, 0, $f60d5b61c638db60$var$n)), $f60d5b61c638db60$var$l = new Uint8Array(512), $f60d5b61c638db60$var$n = 0), a.enqueue(b);
        else {
            var c = $f60d5b61c638db60$var$l.length - $f60d5b61c638db60$var$n;
            c < b.length && (0 === c ? a.enqueue($f60d5b61c638db60$var$l) : ($f60d5b61c638db60$var$l.set(b.subarray(0, c), $f60d5b61c638db60$var$n), a.enqueue($f60d5b61c638db60$var$l), b = b.subarray(c)), $f60d5b61c638db60$var$l = new Uint8Array(512), $f60d5b61c638db60$var$n = 0);
            $f60d5b61c638db60$var$l.set(b, $f60d5b61c638db60$var$n);
            $f60d5b61c638db60$var$n += b.length;
        }
    }
}
function $f60d5b61c638db60$var$t(a, b) {
    $f60d5b61c638db60$var$p(a, b);
    return !0;
}
function $f60d5b61c638db60$var$ba(a) {
    $f60d5b61c638db60$var$l && 0 < $f60d5b61c638db60$var$n && (a.enqueue(new Uint8Array($f60d5b61c638db60$var$l.buffer, 0, $f60d5b61c638db60$var$n)), $f60d5b61c638db60$var$l = null, $f60d5b61c638db60$var$n = 0);
}
var $f60d5b61c638db60$var$ca = new TextEncoder;
function $f60d5b61c638db60$var$u(a) {
    return $f60d5b61c638db60$var$ca.encode(a);
}
function $f60d5b61c638db60$var$w(a) {
    return $f60d5b61c638db60$var$ca.encode(a);
}
function $f60d5b61c638db60$var$da(a, b) {
    "function" === typeof a.error ? a.error(b) : a.close();
}
var $f60d5b61c638db60$var$x = Object.prototype.hasOwnProperty, $f60d5b61c638db60$var$ea = /^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/, $f60d5b61c638db60$var$fa = {}, $f60d5b61c638db60$var$ha = {};
function $f60d5b61c638db60$var$ia(a) {
    if ($f60d5b61c638db60$var$x.call($f60d5b61c638db60$var$ha, a)) return !0;
    if ($f60d5b61c638db60$var$x.call($f60d5b61c638db60$var$fa, a)) return !1;
    if ($f60d5b61c638db60$var$ea.test(a)) return $f60d5b61c638db60$var$ha[a] = !0;
    $f60d5b61c638db60$var$fa[a] = !0;
    return !1;
}
function $f60d5b61c638db60$var$y(a, b, c, d, f, e, g) {
    this.acceptsBooleans = 2 === b || 3 === b || 4 === b;
    this.attributeName = d;
    this.attributeNamespace = f;
    this.mustUseProperty = c;
    this.propertyName = a;
    this.type = b;
    this.sanitizeURL = e;
    this.removeEmptyString = g;
}
var $f60d5b61c638db60$var$z = {};
"children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(a) {
    $f60d5b61c638db60$var$z[a] = new $f60d5b61c638db60$var$y(a, 0, !1, a, null, !1, !1);
});
[
    [
        "acceptCharset",
        "accept-charset"
    ],
    [
        "className",
        "class"
    ],
    [
        "htmlFor",
        "for"
    ],
    [
        "httpEquiv",
        "http-equiv"
    ]
].forEach(function(a) {
    var b = a[0];
    $f60d5b61c638db60$var$z[b] = new $f60d5b61c638db60$var$y(b, 1, !1, a[1], null, !1, !1);
});
[
    "contentEditable",
    "draggable",
    "spellCheck",
    "value"
].forEach(function(a) {
    $f60d5b61c638db60$var$z[a] = new $f60d5b61c638db60$var$y(a, 2, !1, a.toLowerCase(), null, !1, !1);
});
[
    "autoReverse",
    "externalResourcesRequired",
    "focusable",
    "preserveAlpha"
].forEach(function(a) {
    $f60d5b61c638db60$var$z[a] = new $f60d5b61c638db60$var$y(a, 2, !1, a, null, !1, !1);
});
"allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture disableRemotePlayback formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(a) {
    $f60d5b61c638db60$var$z[a] = new $f60d5b61c638db60$var$y(a, 3, !1, a.toLowerCase(), null, !1, !1);
});
[
    "checked",
    "multiple",
    "muted",
    "selected"
].forEach(function(a) {
    $f60d5b61c638db60$var$z[a] = new $f60d5b61c638db60$var$y(a, 3, !0, a, null, !1, !1);
});
[
    "capture",
    "download"
].forEach(function(a) {
    $f60d5b61c638db60$var$z[a] = new $f60d5b61c638db60$var$y(a, 4, !1, a, null, !1, !1);
});
[
    "cols",
    "rows",
    "size",
    "span"
].forEach(function(a) {
    $f60d5b61c638db60$var$z[a] = new $f60d5b61c638db60$var$y(a, 6, !1, a, null, !1, !1);
});
[
    "rowSpan",
    "start"
].forEach(function(a) {
    $f60d5b61c638db60$var$z[a] = new $f60d5b61c638db60$var$y(a, 5, !1, a.toLowerCase(), null, !1, !1);
});
var $f60d5b61c638db60$var$ja = /[\-:]([a-z])/g;
function $f60d5b61c638db60$var$ka(a) {
    return a[1].toUpperCase();
}
"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(a) {
    var b = a.replace($f60d5b61c638db60$var$ja, $f60d5b61c638db60$var$ka);
    $f60d5b61c638db60$var$z[b] = new $f60d5b61c638db60$var$y(b, 1, !1, a, null, !1, !1);
});
"xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(a) {
    var b = a.replace($f60d5b61c638db60$var$ja, $f60d5b61c638db60$var$ka);
    $f60d5b61c638db60$var$z[b] = new $f60d5b61c638db60$var$y(b, 1, !1, a, "http://www.w3.org/1999/xlink", !1, !1);
});
[
    "xml:base",
    "xml:lang",
    "xml:space"
].forEach(function(a) {
    var b = a.replace($f60d5b61c638db60$var$ja, $f60d5b61c638db60$var$ka);
    $f60d5b61c638db60$var$z[b] = new $f60d5b61c638db60$var$y(b, 1, !1, a, "http://www.w3.org/XML/1998/namespace", !1, !1);
});
[
    "tabIndex",
    "crossOrigin"
].forEach(function(a) {
    $f60d5b61c638db60$var$z[a] = new $f60d5b61c638db60$var$y(a, 1, !1, a.toLowerCase(), null, !1, !1);
});
$f60d5b61c638db60$var$z.xlinkHref = new $f60d5b61c638db60$var$y("xlinkHref", 1, !1, "xlink:href", "http://www.w3.org/1999/xlink", !0, !1);
[
    "src",
    "href",
    "action",
    "formAction"
].forEach(function(a) {
    $f60d5b61c638db60$var$z[a] = new $f60d5b61c638db60$var$y(a, 1, !1, a.toLowerCase(), null, !0, !0);
});
var $f60d5b61c638db60$var$B = {
    animationIterationCount: !0,
    aspectRatio: !0,
    borderImageOutset: !0,
    borderImageSlice: !0,
    borderImageWidth: !0,
    boxFlex: !0,
    boxFlexGroup: !0,
    boxOrdinalGroup: !0,
    columnCount: !0,
    columns: !0,
    flex: !0,
    flexGrow: !0,
    flexPositive: !0,
    flexShrink: !0,
    flexNegative: !0,
    flexOrder: !0,
    gridArea: !0,
    gridRow: !0,
    gridRowEnd: !0,
    gridRowSpan: !0,
    gridRowStart: !0,
    gridColumn: !0,
    gridColumnEnd: !0,
    gridColumnSpan: !0,
    gridColumnStart: !0,
    fontWeight: !0,
    lineClamp: !0,
    lineHeight: !0,
    opacity: !0,
    order: !0,
    orphans: !0,
    tabSize: !0,
    widows: !0,
    zIndex: !0,
    zoom: !0,
    fillOpacity: !0,
    floodOpacity: !0,
    stopOpacity: !0,
    strokeDasharray: !0,
    strokeDashoffset: !0,
    strokeMiterlimit: !0,
    strokeOpacity: !0,
    strokeWidth: !0
}, $f60d5b61c638db60$var$la = [
    "Webkit",
    "ms",
    "Moz",
    "O"
];
Object.keys($f60d5b61c638db60$var$B).forEach(function(a) {
    $f60d5b61c638db60$var$la.forEach(function(b) {
        b = b + a.charAt(0).toUpperCase() + a.substring(1);
        $f60d5b61c638db60$var$B[b] = $f60d5b61c638db60$var$B[a];
    });
});
var $f60d5b61c638db60$var$oa = /["'&<>]/;
function $f60d5b61c638db60$var$C(a) {
    if ("boolean" === typeof a || "number" === typeof a) return "" + a;
    a = "" + a;
    var b = $f60d5b61c638db60$var$oa.exec(a);
    if (b) {
        var c = "", d, f = 0;
        for(d = b.index; d < a.length; d++){
            switch(a.charCodeAt(d)){
                case 34:
                    b = "&quot;";
                    break;
                case 38:
                    b = "&amp;";
                    break;
                case 39:
                    b = "&#x27;";
                    break;
                case 60:
                    b = "&lt;";
                    break;
                case 62:
                    b = "&gt;";
                    break;
                default:
                    continue;
            }
            f !== d && (c += a.substring(f, d));
            f = d + 1;
            c += b;
        }
        a = f !== d ? c + a.substring(f, d) : c;
    }
    return a;
}
var $f60d5b61c638db60$var$pa = /([A-Z])/g, $f60d5b61c638db60$var$qa = /^ms-/, $f60d5b61c638db60$var$ra = Array.isArray, $f60d5b61c638db60$var$sa = $f60d5b61c638db60$var$w("<script>"), $f60d5b61c638db60$var$ta = $f60d5b61c638db60$var$w("\x3c/script>"), $f60d5b61c638db60$var$ua = $f60d5b61c638db60$var$w('<script src="'), $f60d5b61c638db60$var$va = $f60d5b61c638db60$var$w('<script type="module" src="'), $f60d5b61c638db60$var$wa = $f60d5b61c638db60$var$w('" async="">\x3c/script>'), $f60d5b61c638db60$var$xa = /(<\/|<)(s)(cript)/gi;
function $f60d5b61c638db60$var$ya(a, b, c, d) {
    return "" + b + ("s" === c ? "\\u0073" : "\\u0053") + d;
}
function $f60d5b61c638db60$var$za(a, b, c, d, f) {
    a = void 0 === a ? "" : a;
    b = void 0 === b ? $f60d5b61c638db60$var$sa : $f60d5b61c638db60$var$w('<script nonce="' + $f60d5b61c638db60$var$C(b) + '">');
    var e = [];
    void 0 !== c && e.push(b, $f60d5b61c638db60$var$u(("" + c).replace($f60d5b61c638db60$var$xa, $f60d5b61c638db60$var$ya)), $f60d5b61c638db60$var$ta);
    if (void 0 !== d) for(c = 0; c < d.length; c++)e.push($f60d5b61c638db60$var$ua, $f60d5b61c638db60$var$u($f60d5b61c638db60$var$C(d[c])), $f60d5b61c638db60$var$wa);
    if (void 0 !== f) for(d = 0; d < f.length; d++)e.push($f60d5b61c638db60$var$va, $f60d5b61c638db60$var$u($f60d5b61c638db60$var$C(f[d])), $f60d5b61c638db60$var$wa);
    return {
        bootstrapChunks: e,
        startInlineScript: b,
        placeholderPrefix: $f60d5b61c638db60$var$w(a + "P:"),
        segmentPrefix: $f60d5b61c638db60$var$w(a + "S:"),
        boundaryPrefix: a + "B:",
        idPrefix: a,
        nextSuspenseID: 0,
        sentCompleteSegmentFunction: !1,
        sentCompleteBoundaryFunction: !1,
        sentClientRenderFunction: !1
    };
}
function $f60d5b61c638db60$var$D(a, b) {
    return {
        insertionMode: a,
        selectedValue: b
    };
}
function $f60d5b61c638db60$var$Aa(a) {
    return $f60d5b61c638db60$var$D("http://www.w3.org/2000/svg" === a ? 2 : "http://www.w3.org/1998/Math/MathML" === a ? 3 : 0, null);
}
function $f60d5b61c638db60$var$Ba(a, b, c) {
    switch(b){
        case "select":
            return $f60d5b61c638db60$var$D(1, null != c.value ? c.value : c.defaultValue);
        case "svg":
            return $f60d5b61c638db60$var$D(2, null);
        case "math":
            return $f60d5b61c638db60$var$D(3, null);
        case "foreignObject":
            return $f60d5b61c638db60$var$D(1, null);
        case "table":
            return $f60d5b61c638db60$var$D(4, null);
        case "thead":
        case "tbody":
        case "tfoot":
            return $f60d5b61c638db60$var$D(5, null);
        case "colgroup":
            return $f60d5b61c638db60$var$D(7, null);
        case "tr":
            return $f60d5b61c638db60$var$D(6, null);
    }
    return 4 <= a.insertionMode || 0 === a.insertionMode ? $f60d5b61c638db60$var$D(1, null) : a;
}
var $f60d5b61c638db60$var$Ca = $f60d5b61c638db60$var$w("\x3c!-- --\x3e");
function $f60d5b61c638db60$var$Da(a, b, c, d) {
    if ("" === b) return d;
    d && a.push($f60d5b61c638db60$var$Ca);
    a.push($f60d5b61c638db60$var$u($f60d5b61c638db60$var$C(b)));
    return !0;
}
var $f60d5b61c638db60$var$Ea = new Map, $f60d5b61c638db60$var$Fa = $f60d5b61c638db60$var$w(' style="'), $f60d5b61c638db60$var$Ga = $f60d5b61c638db60$var$w(":"), $f60d5b61c638db60$var$Ha = $f60d5b61c638db60$var$w(";");
function $f60d5b61c638db60$var$Ia(a, b, c) {
    if ("object" !== typeof c) throw Error($f60d5b61c638db60$var$k(62));
    b = !0;
    for(var d in c)if ($f60d5b61c638db60$var$x.call(c, d)) {
        var f = c[d];
        if (null != f && "boolean" !== typeof f && "" !== f) {
            if (0 === d.indexOf("--")) {
                var e = $f60d5b61c638db60$var$u($f60d5b61c638db60$var$C(d));
                f = $f60d5b61c638db60$var$u($f60d5b61c638db60$var$C(("" + f).trim()));
            } else {
                e = d;
                var g = $f60d5b61c638db60$var$Ea.get(e);
                void 0 !== g ? e = g : (g = $f60d5b61c638db60$var$w($f60d5b61c638db60$var$C(e.replace($f60d5b61c638db60$var$pa, "-$1").toLowerCase().replace($f60d5b61c638db60$var$qa, "-ms-"))), $f60d5b61c638db60$var$Ea.set(e, g), e = g);
                f = "number" === typeof f ? 0 === f || $f60d5b61c638db60$var$x.call($f60d5b61c638db60$var$B, d) ? $f60d5b61c638db60$var$u("" + f) : $f60d5b61c638db60$var$u(f + "px") : $f60d5b61c638db60$var$u($f60d5b61c638db60$var$C(("" + f).trim()));
            }
            b ? (b = !1, a.push($f60d5b61c638db60$var$Fa, e, $f60d5b61c638db60$var$Ga, f)) : a.push($f60d5b61c638db60$var$Ha, e, $f60d5b61c638db60$var$Ga, f);
        }
    }
    b || a.push($f60d5b61c638db60$var$E);
}
var $f60d5b61c638db60$var$H = $f60d5b61c638db60$var$w(" "), $f60d5b61c638db60$var$I = $f60d5b61c638db60$var$w('="'), $f60d5b61c638db60$var$E = $f60d5b61c638db60$var$w('"'), $f60d5b61c638db60$var$Ja = $f60d5b61c638db60$var$w('=""');
function $f60d5b61c638db60$var$J(a, b, c, d) {
    switch(c){
        case "style":
            $f60d5b61c638db60$var$Ia(a, b, d);
            return;
        case "defaultValue":
        case "defaultChecked":
        case "innerHTML":
        case "suppressContentEditableWarning":
        case "suppressHydrationWarning":
            return;
    }
    if (!(2 < c.length) || "o" !== c[0] && "O" !== c[0] || "n" !== c[1] && "N" !== c[1]) {
        if (b = $f60d5b61c638db60$var$z.hasOwnProperty(c) ? $f60d5b61c638db60$var$z[c] : null, null !== b) {
            switch(typeof d){
                case "function":
                case "symbol":
                    return;
                case "boolean":
                    if (!b.acceptsBooleans) return;
            }
            c = $f60d5b61c638db60$var$u(b.attributeName);
            switch(b.type){
                case 3:
                    d && a.push($f60d5b61c638db60$var$H, c, $f60d5b61c638db60$var$Ja);
                    break;
                case 4:
                    !0 === d ? a.push($f60d5b61c638db60$var$H, c, $f60d5b61c638db60$var$Ja) : !1 !== d && a.push($f60d5b61c638db60$var$H, c, $f60d5b61c638db60$var$I, $f60d5b61c638db60$var$u($f60d5b61c638db60$var$C(d)), $f60d5b61c638db60$var$E);
                    break;
                case 5:
                    isNaN(d) || a.push($f60d5b61c638db60$var$H, c, $f60d5b61c638db60$var$I, $f60d5b61c638db60$var$u($f60d5b61c638db60$var$C(d)), $f60d5b61c638db60$var$E);
                    break;
                case 6:
                    !isNaN(d) && 1 <= d && a.push($f60d5b61c638db60$var$H, c, $f60d5b61c638db60$var$I, $f60d5b61c638db60$var$u($f60d5b61c638db60$var$C(d)), $f60d5b61c638db60$var$E);
                    break;
                default:
                    b.sanitizeURL && (d = "" + d), a.push($f60d5b61c638db60$var$H, c, $f60d5b61c638db60$var$I, $f60d5b61c638db60$var$u($f60d5b61c638db60$var$C(d)), $f60d5b61c638db60$var$E);
            }
        } else if ($f60d5b61c638db60$var$ia(c)) {
            switch(typeof d){
                case "function":
                case "symbol":
                    return;
                case "boolean":
                    if (b = c.toLowerCase().slice(0, 5), "data-" !== b && "aria-" !== b) return;
            }
            a.push($f60d5b61c638db60$var$H, $f60d5b61c638db60$var$u(c), $f60d5b61c638db60$var$I, $f60d5b61c638db60$var$u($f60d5b61c638db60$var$C(d)), $f60d5b61c638db60$var$E);
        }
    }
}
var $f60d5b61c638db60$var$K = $f60d5b61c638db60$var$w(">"), $f60d5b61c638db60$var$Ka = $f60d5b61c638db60$var$w("/>");
function $f60d5b61c638db60$var$L(a, b, c) {
    if (null != b) {
        if (null != c) throw Error($f60d5b61c638db60$var$k(60));
        if ("object" !== typeof b || !("__html" in b)) throw Error($f60d5b61c638db60$var$k(61));
        b = b.__html;
        null !== b && void 0 !== b && a.push($f60d5b61c638db60$var$u("" + b));
    }
}
function $f60d5b61c638db60$var$La(a) {
    var b = "";
    $5uXOq.Children.forEach(a, function(a) {
        null != a && (b += a);
    });
    return b;
}
var $f60d5b61c638db60$var$Ma = $f60d5b61c638db60$var$w(' selected=""');
function $f60d5b61c638db60$var$Na(a, b, c, d) {
    a.push($f60d5b61c638db60$var$M(c));
    var f = c = null, e;
    for(e in b)if ($f60d5b61c638db60$var$x.call(b, e)) {
        var g = b[e];
        if (null != g) switch(e){
            case "children":
                c = g;
                break;
            case "dangerouslySetInnerHTML":
                f = g;
                break;
            default:
                $f60d5b61c638db60$var$J(a, d, e, g);
        }
    }
    a.push($f60d5b61c638db60$var$K);
    $f60d5b61c638db60$var$L(a, f, c);
    return "string" === typeof c ? (a.push($f60d5b61c638db60$var$u($f60d5b61c638db60$var$C(c))), null) : c;
}
var $f60d5b61c638db60$var$Oa = $f60d5b61c638db60$var$w("\n"), $f60d5b61c638db60$var$Pa = /^[a-zA-Z][a-zA-Z:_\.\-\d]*$/, $f60d5b61c638db60$var$Qa = new Map;
function $f60d5b61c638db60$var$M(a) {
    var b = $f60d5b61c638db60$var$Qa.get(a);
    if (void 0 === b) {
        if (!$f60d5b61c638db60$var$Pa.test(a)) throw Error($f60d5b61c638db60$var$k(65, a));
        b = $f60d5b61c638db60$var$w("<" + a);
        $f60d5b61c638db60$var$Qa.set(a, b);
    }
    return b;
}
var $f60d5b61c638db60$var$Ra = $f60d5b61c638db60$var$w("<!DOCTYPE html>");
function $f60d5b61c638db60$var$Sa(a, b, c, d, f) {
    switch(b){
        case "select":
            a.push($f60d5b61c638db60$var$M("select"));
            var e = null, g = null;
            for(r in c)if ($f60d5b61c638db60$var$x.call(c, r)) {
                var h = c[r];
                if (null != h) switch(r){
                    case "children":
                        e = h;
                        break;
                    case "dangerouslySetInnerHTML":
                        g = h;
                        break;
                    case "defaultValue":
                    case "value":
                        break;
                    default:
                        $f60d5b61c638db60$var$J(a, d, r, h);
                }
            }
            a.push($f60d5b61c638db60$var$K);
            $f60d5b61c638db60$var$L(a, g, e);
            return e;
        case "option":
            g = f.selectedValue;
            a.push($f60d5b61c638db60$var$M("option"));
            var m = h = null, q = null;
            var r = null;
            for(e in c)if ($f60d5b61c638db60$var$x.call(c, e)) {
                var v = c[e];
                if (null != v) switch(e){
                    case "children":
                        h = v;
                        break;
                    case "selected":
                        q = v;
                        break;
                    case "dangerouslySetInnerHTML":
                        r = v;
                        break;
                    case "value":
                        m = v;
                    default:
                        $f60d5b61c638db60$var$J(a, d, e, v);
                }
            }
            if (null != g) {
                if (c = null !== m ? "" + m : $f60d5b61c638db60$var$La(h), $f60d5b61c638db60$var$ra(g)) {
                    for(d = 0; d < g.length; d++)if ("" + g[d] === c) {
                        a.push($f60d5b61c638db60$var$Ma);
                        break;
                    }
                } else "" + g === c && a.push($f60d5b61c638db60$var$Ma);
            } else q && a.push($f60d5b61c638db60$var$Ma);
            a.push($f60d5b61c638db60$var$K);
            $f60d5b61c638db60$var$L(a, r, h);
            return h;
        case "textarea":
            a.push($f60d5b61c638db60$var$M("textarea"));
            r = g = e = null;
            for(h in c)if ($f60d5b61c638db60$var$x.call(c, h) && (m = c[h], null != m)) switch(h){
                case "children":
                    r = m;
                    break;
                case "value":
                    e = m;
                    break;
                case "defaultValue":
                    g = m;
                    break;
                case "dangerouslySetInnerHTML":
                    throw Error($f60d5b61c638db60$var$k(91));
                default:
                    $f60d5b61c638db60$var$J(a, d, h, m);
            }
            null === e && null !== g && (e = g);
            a.push($f60d5b61c638db60$var$K);
            if (null != r) {
                if (null != e) throw Error($f60d5b61c638db60$var$k(92));
                if ($f60d5b61c638db60$var$ra(r) && 1 < r.length) throw Error($f60d5b61c638db60$var$k(93));
                e = "" + r;
            }
            "string" === typeof e && "\n" === e[0] && a.push($f60d5b61c638db60$var$Oa);
            null !== e && a.push($f60d5b61c638db60$var$u($f60d5b61c638db60$var$C("" + e)));
            return null;
        case "input":
            a.push($f60d5b61c638db60$var$M("input"));
            m = r = h = e = null;
            for(g in c)if ($f60d5b61c638db60$var$x.call(c, g) && (q = c[g], null != q)) switch(g){
                case "children":
                case "dangerouslySetInnerHTML":
                    throw Error($f60d5b61c638db60$var$k(399, "input"));
                case "defaultChecked":
                    m = q;
                    break;
                case "defaultValue":
                    h = q;
                    break;
                case "checked":
                    r = q;
                    break;
                case "value":
                    e = q;
                    break;
                default:
                    $f60d5b61c638db60$var$J(a, d, g, q);
            }
            null !== r ? $f60d5b61c638db60$var$J(a, d, "checked", r) : null !== m && $f60d5b61c638db60$var$J(a, d, "checked", m);
            null !== e ? $f60d5b61c638db60$var$J(a, d, "value", e) : null !== h && $f60d5b61c638db60$var$J(a, d, "value", h);
            a.push($f60d5b61c638db60$var$Ka);
            return null;
        case "menuitem":
            a.push($f60d5b61c638db60$var$M("menuitem"));
            for(var A in c)if ($f60d5b61c638db60$var$x.call(c, A) && (e = c[A], null != e)) switch(A){
                case "children":
                case "dangerouslySetInnerHTML":
                    throw Error($f60d5b61c638db60$var$k(400));
                default:
                    $f60d5b61c638db60$var$J(a, d, A, e);
            }
            a.push($f60d5b61c638db60$var$K);
            return null;
        case "title":
            a.push($f60d5b61c638db60$var$M("title"));
            e = null;
            for(v in c)if ($f60d5b61c638db60$var$x.call(c, v) && (g = c[v], null != g)) switch(v){
                case "children":
                    e = g;
                    break;
                case "dangerouslySetInnerHTML":
                    throw Error($f60d5b61c638db60$var$k(434));
                default:
                    $f60d5b61c638db60$var$J(a, d, v, g);
            }
            a.push($f60d5b61c638db60$var$K);
            return e;
        case "listing":
        case "pre":
            a.push($f60d5b61c638db60$var$M(b));
            g = e = null;
            for(m in c)if ($f60d5b61c638db60$var$x.call(c, m) && (h = c[m], null != h)) switch(m){
                case "children":
                    e = h;
                    break;
                case "dangerouslySetInnerHTML":
                    g = h;
                    break;
                default:
                    $f60d5b61c638db60$var$J(a, d, m, h);
            }
            a.push($f60d5b61c638db60$var$K);
            if (null != g) {
                if (null != e) throw Error($f60d5b61c638db60$var$k(60));
                if ("object" !== typeof g || !("__html" in g)) throw Error($f60d5b61c638db60$var$k(61));
                c = g.__html;
                null !== c && void 0 !== c && ("string" === typeof c && 0 < c.length && "\n" === c[0] ? a.push($f60d5b61c638db60$var$Oa, $f60d5b61c638db60$var$u(c)) : a.push($f60d5b61c638db60$var$u("" + c)));
            }
            "string" === typeof e && "\n" === e[0] && a.push($f60d5b61c638db60$var$Oa);
            return e;
        case "area":
        case "base":
        case "br":
        case "col":
        case "embed":
        case "hr":
        case "img":
        case "keygen":
        case "link":
        case "meta":
        case "param":
        case "source":
        case "track":
        case "wbr":
            a.push($f60d5b61c638db60$var$M(b));
            for(var F in c)if ($f60d5b61c638db60$var$x.call(c, F) && (e = c[F], null != e)) switch(F){
                case "children":
                case "dangerouslySetInnerHTML":
                    throw Error($f60d5b61c638db60$var$k(399, b));
                default:
                    $f60d5b61c638db60$var$J(a, d, F, e);
            }
            a.push($f60d5b61c638db60$var$Ka);
            return null;
        case "annotation-xml":
        case "color-profile":
        case "font-face":
        case "font-face-src":
        case "font-face-uri":
        case "font-face-format":
        case "font-face-name":
        case "missing-glyph":
            return $f60d5b61c638db60$var$Na(a, c, b, d);
        case "html":
            return 0 === f.insertionMode && a.push($f60d5b61c638db60$var$Ra), $f60d5b61c638db60$var$Na(a, c, b, d);
        default:
            if (-1 === b.indexOf("-") && "string" !== typeof c.is) return $f60d5b61c638db60$var$Na(a, c, b, d);
            a.push($f60d5b61c638db60$var$M(b));
            g = e = null;
            for(q in c)if ($f60d5b61c638db60$var$x.call(c, q) && (h = c[q], null != h)) switch(q){
                case "children":
                    e = h;
                    break;
                case "dangerouslySetInnerHTML":
                    g = h;
                    break;
                case "style":
                    $f60d5b61c638db60$var$Ia(a, d, h);
                    break;
                case "suppressContentEditableWarning":
                case "suppressHydrationWarning":
                    break;
                default:
                    $f60d5b61c638db60$var$ia(q) && "function" !== typeof h && "symbol" !== typeof h && a.push($f60d5b61c638db60$var$H, $f60d5b61c638db60$var$u(q), $f60d5b61c638db60$var$I, $f60d5b61c638db60$var$u($f60d5b61c638db60$var$C(h)), $f60d5b61c638db60$var$E);
            }
            a.push($f60d5b61c638db60$var$K);
            $f60d5b61c638db60$var$L(a, g, e);
            return e;
    }
}
var $f60d5b61c638db60$var$Ta = $f60d5b61c638db60$var$w("</"), $f60d5b61c638db60$var$Ua = $f60d5b61c638db60$var$w(">"), $f60d5b61c638db60$var$Va = $f60d5b61c638db60$var$w('<template id="'), $f60d5b61c638db60$var$Wa = $f60d5b61c638db60$var$w('"></template>'), $f60d5b61c638db60$var$Xa = $f60d5b61c638db60$var$w("\x3c!--$--\x3e"), $f60d5b61c638db60$var$Ya = $f60d5b61c638db60$var$w('\x3c!--$?--\x3e<template id="'), $f60d5b61c638db60$var$Za = $f60d5b61c638db60$var$w('"></template>'), $f60d5b61c638db60$var$$a = $f60d5b61c638db60$var$w("\x3c!--$!--\x3e"), $f60d5b61c638db60$var$ab = $f60d5b61c638db60$var$w("\x3c!--/$--\x3e"), $f60d5b61c638db60$var$bb = $f60d5b61c638db60$var$w("<template"), $f60d5b61c638db60$var$cb = $f60d5b61c638db60$var$w('"'), $f60d5b61c638db60$var$db = $f60d5b61c638db60$var$w(' data-dgst="');
$f60d5b61c638db60$var$w(' data-msg="');
$f60d5b61c638db60$var$w(' data-stck="');
var $f60d5b61c638db60$var$eb = $f60d5b61c638db60$var$w("></template>");
function $f60d5b61c638db60$var$fb(a, b, c) {
    $f60d5b61c638db60$var$p(a, $f60d5b61c638db60$var$Ya);
    if (null === c) throw Error($f60d5b61c638db60$var$k(395));
    $f60d5b61c638db60$var$p(a, c);
    return $f60d5b61c638db60$var$t(a, $f60d5b61c638db60$var$Za);
}
var $f60d5b61c638db60$var$gb = $f60d5b61c638db60$var$w('<div hidden id="'), $f60d5b61c638db60$var$hb = $f60d5b61c638db60$var$w('">'), $f60d5b61c638db60$var$ib = $f60d5b61c638db60$var$w("</div>"), $f60d5b61c638db60$var$jb = $f60d5b61c638db60$var$w('<svg aria-hidden="true" style="display:none" id="'), $f60d5b61c638db60$var$kb = $f60d5b61c638db60$var$w('">'), $f60d5b61c638db60$var$lb = $f60d5b61c638db60$var$w("</svg>"), $f60d5b61c638db60$var$mb = $f60d5b61c638db60$var$w('<math aria-hidden="true" style="display:none" id="'), $f60d5b61c638db60$var$nb = $f60d5b61c638db60$var$w('">'), $f60d5b61c638db60$var$ob = $f60d5b61c638db60$var$w("</math>"), $f60d5b61c638db60$var$pb = $f60d5b61c638db60$var$w('<table hidden id="'), $f60d5b61c638db60$var$qb = $f60d5b61c638db60$var$w('">'), $f60d5b61c638db60$var$rb = $f60d5b61c638db60$var$w("</table>"), $f60d5b61c638db60$var$sb = $f60d5b61c638db60$var$w('<table hidden><tbody id="'), $f60d5b61c638db60$var$tb = $f60d5b61c638db60$var$w('">'), $f60d5b61c638db60$var$ub = $f60d5b61c638db60$var$w("</tbody></table>"), $f60d5b61c638db60$var$vb = $f60d5b61c638db60$var$w('<table hidden><tr id="'), $f60d5b61c638db60$var$wb = $f60d5b61c638db60$var$w('">'), $f60d5b61c638db60$var$xb = $f60d5b61c638db60$var$w("</tr></table>"), $f60d5b61c638db60$var$yb = $f60d5b61c638db60$var$w('<table hidden><colgroup id="'), $f60d5b61c638db60$var$zb = $f60d5b61c638db60$var$w('">'), $f60d5b61c638db60$var$Ab = $f60d5b61c638db60$var$w("</colgroup></table>");
function $f60d5b61c638db60$var$Bb(a, b, c, d) {
    switch(c.insertionMode){
        case 0:
        case 1:
            return $f60d5b61c638db60$var$p(a, $f60d5b61c638db60$var$gb), $f60d5b61c638db60$var$p(a, b.segmentPrefix), $f60d5b61c638db60$var$p(a, $f60d5b61c638db60$var$u(d.toString(16))), $f60d5b61c638db60$var$t(a, $f60d5b61c638db60$var$hb);
        case 2:
            return $f60d5b61c638db60$var$p(a, $f60d5b61c638db60$var$jb), $f60d5b61c638db60$var$p(a, b.segmentPrefix), $f60d5b61c638db60$var$p(a, $f60d5b61c638db60$var$u(d.toString(16))), $f60d5b61c638db60$var$t(a, $f60d5b61c638db60$var$kb);
        case 3:
            return $f60d5b61c638db60$var$p(a, $f60d5b61c638db60$var$mb), $f60d5b61c638db60$var$p(a, b.segmentPrefix), $f60d5b61c638db60$var$p(a, $f60d5b61c638db60$var$u(d.toString(16))), $f60d5b61c638db60$var$t(a, $f60d5b61c638db60$var$nb);
        case 4:
            return $f60d5b61c638db60$var$p(a, $f60d5b61c638db60$var$pb), $f60d5b61c638db60$var$p(a, b.segmentPrefix), $f60d5b61c638db60$var$p(a, $f60d5b61c638db60$var$u(d.toString(16))), $f60d5b61c638db60$var$t(a, $f60d5b61c638db60$var$qb);
        case 5:
            return $f60d5b61c638db60$var$p(a, $f60d5b61c638db60$var$sb), $f60d5b61c638db60$var$p(a, b.segmentPrefix), $f60d5b61c638db60$var$p(a, $f60d5b61c638db60$var$u(d.toString(16))), $f60d5b61c638db60$var$t(a, $f60d5b61c638db60$var$tb);
        case 6:
            return $f60d5b61c638db60$var$p(a, $f60d5b61c638db60$var$vb), $f60d5b61c638db60$var$p(a, b.segmentPrefix), $f60d5b61c638db60$var$p(a, $f60d5b61c638db60$var$u(d.toString(16))), $f60d5b61c638db60$var$t(a, $f60d5b61c638db60$var$wb);
        case 7:
            return $f60d5b61c638db60$var$p(a, $f60d5b61c638db60$var$yb), $f60d5b61c638db60$var$p(a, b.segmentPrefix), $f60d5b61c638db60$var$p(a, $f60d5b61c638db60$var$u(d.toString(16))), $f60d5b61c638db60$var$t(a, $f60d5b61c638db60$var$zb);
        default:
            throw Error($f60d5b61c638db60$var$k(397));
    }
}
function $f60d5b61c638db60$var$Cb(a, b) {
    switch(b.insertionMode){
        case 0:
        case 1:
            return $f60d5b61c638db60$var$t(a, $f60d5b61c638db60$var$ib);
        case 2:
            return $f60d5b61c638db60$var$t(a, $f60d5b61c638db60$var$lb);
        case 3:
            return $f60d5b61c638db60$var$t(a, $f60d5b61c638db60$var$ob);
        case 4:
            return $f60d5b61c638db60$var$t(a, $f60d5b61c638db60$var$rb);
        case 5:
            return $f60d5b61c638db60$var$t(a, $f60d5b61c638db60$var$ub);
        case 6:
            return $f60d5b61c638db60$var$t(a, $f60d5b61c638db60$var$xb);
        case 7:
            return $f60d5b61c638db60$var$t(a, $f60d5b61c638db60$var$Ab);
        default:
            throw Error($f60d5b61c638db60$var$k(397));
    }
}
var $f60d5b61c638db60$var$Db = $f60d5b61c638db60$var$w('function $RS(a,b){a=document.getElementById(a);b=document.getElementById(b);for(a.parentNode.removeChild(a);a.firstChild;)b.parentNode.insertBefore(a.firstChild,b);b.parentNode.removeChild(b)};$RS("'), $f60d5b61c638db60$var$Eb = $f60d5b61c638db60$var$w('$RS("'), $f60d5b61c638db60$var$Gb = $f60d5b61c638db60$var$w('","'), $f60d5b61c638db60$var$Hb = $f60d5b61c638db60$var$w('")\x3c/script>'), $f60d5b61c638db60$var$Ib = $f60d5b61c638db60$var$w('function $RC(a,b){a=document.getElementById(a);b=document.getElementById(b);b.parentNode.removeChild(b);if(a){a=a.previousSibling;var f=a.parentNode,c=a.nextSibling,e=0;do{if(c&&8===c.nodeType){var d=c.data;if("/$"===d)if(0===e)break;else e--;else"$"!==d&&"$?"!==d&&"$!"!==d||e++}d=c.nextSibling;f.removeChild(c);c=d}while(c);for(;b.firstChild;)f.insertBefore(b.firstChild,c);a.data="$";a._reactRetry&&a._reactRetry()}};$RC("'), $f60d5b61c638db60$var$Jb = $f60d5b61c638db60$var$w('$RC("'), $f60d5b61c638db60$var$Kb = $f60d5b61c638db60$var$w('","'), $f60d5b61c638db60$var$Lb = $f60d5b61c638db60$var$w('")\x3c/script>'), $f60d5b61c638db60$var$Mb = $f60d5b61c638db60$var$w('function $RX(b,c,d,e){var a=document.getElementById(b);a&&(b=a.previousSibling,b.data="$!",a=a.dataset,c&&(a.dgst=c),d&&(a.msg=d),e&&(a.stck=e),b._reactRetry&&b._reactRetry())};$RX("'), $f60d5b61c638db60$var$Nb = $f60d5b61c638db60$var$w('$RX("'), $f60d5b61c638db60$var$Ob = $f60d5b61c638db60$var$w('"'), $f60d5b61c638db60$var$Pb = $f60d5b61c638db60$var$w(")\x3c/script>"), $f60d5b61c638db60$var$Qb = $f60d5b61c638db60$var$w(","), $f60d5b61c638db60$var$Rb = /[<\u2028\u2029]/g;
function $f60d5b61c638db60$var$Sb(a) {
    return JSON.stringify(a).replace($f60d5b61c638db60$var$Rb, function(a) {
        switch(a){
            case "<":
                return "\\u003c";
            case "\u2028":
                return "\\u2028";
            case "\u2029":
                return "\\u2029";
            default:
                throw Error("escapeJSStringsForInstructionScripts encountered a match it does not know how to replace. this means the match regex and the replacement characters are no longer in sync. This is a bug in React");
        }
    });
}
var $f60d5b61c638db60$var$N = Object.assign, $f60d5b61c638db60$var$Tb = Symbol.for("react.element"), $f60d5b61c638db60$var$Ub = Symbol.for("react.portal"), $f60d5b61c638db60$var$Vb = Symbol.for("react.fragment"), $f60d5b61c638db60$var$Wb = Symbol.for("react.strict_mode"), $f60d5b61c638db60$var$Xb = Symbol.for("react.profiler"), $f60d5b61c638db60$var$Yb = Symbol.for("react.provider"), $f60d5b61c638db60$var$Zb = Symbol.for("react.context"), $f60d5b61c638db60$var$$b = Symbol.for("react.forward_ref"), $f60d5b61c638db60$var$ac = Symbol.for("react.suspense"), $f60d5b61c638db60$var$bc = Symbol.for("react.suspense_list"), $f60d5b61c638db60$var$cc = Symbol.for("react.memo"), $f60d5b61c638db60$var$dc = Symbol.for("react.lazy"), $f60d5b61c638db60$var$ec = Symbol.for("react.scope"), $f60d5b61c638db60$var$fc = Symbol.for("react.debug_trace_mode"), $f60d5b61c638db60$var$gc = Symbol.for("react.legacy_hidden"), $f60d5b61c638db60$var$hc = Symbol.for("react.default_value"), $f60d5b61c638db60$var$ic = Symbol.iterator;
function $f60d5b61c638db60$var$jc(a) {
    if (null == a) return null;
    if ("function" === typeof a) return a.displayName || a.name || null;
    if ("string" === typeof a) return a;
    switch(a){
        case $f60d5b61c638db60$var$Vb:
            return "Fragment";
        case $f60d5b61c638db60$var$Ub:
            return "Portal";
        case $f60d5b61c638db60$var$Xb:
            return "Profiler";
        case $f60d5b61c638db60$var$Wb:
            return "StrictMode";
        case $f60d5b61c638db60$var$ac:
            return "Suspense";
        case $f60d5b61c638db60$var$bc:
            return "SuspenseList";
    }
    if ("object" === typeof a) switch(a.$$typeof){
        case $f60d5b61c638db60$var$Zb:
            return (a.displayName || "Context") + ".Consumer";
        case $f60d5b61c638db60$var$Yb:
            return (a._context.displayName || "Context") + ".Provider";
        case $f60d5b61c638db60$var$$b:
            var b = a.render;
            a = a.displayName;
            a || (a = b.displayName || b.name || "", a = "" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
            return a;
        case $f60d5b61c638db60$var$cc:
            return b = a.displayName || null, null !== b ? b : $f60d5b61c638db60$var$jc(a.type) || "Memo";
        case $f60d5b61c638db60$var$dc:
            b = a._payload;
            a = a._init;
            try {
                return $f60d5b61c638db60$var$jc(a(b));
            } catch (c) {}
    }
    return null;
}
var $f60d5b61c638db60$var$kc = {};
function $f60d5b61c638db60$var$lc(a, b) {
    a = a.contextTypes;
    if (!a) return $f60d5b61c638db60$var$kc;
    var c = {}, d;
    for(d in a)c[d] = b[d];
    return c;
}
var $f60d5b61c638db60$var$O = null;
function $f60d5b61c638db60$var$P(a, b) {
    if (a !== b) {
        a.context._currentValue = a.parentValue;
        a = a.parent;
        var c = b.parent;
        if (null === a) {
            if (null !== c) throw Error($f60d5b61c638db60$var$k(401));
        } else {
            if (null === c) throw Error($f60d5b61c638db60$var$k(401));
            $f60d5b61c638db60$var$P(a, c);
        }
        b.context._currentValue = b.value;
    }
}
function $f60d5b61c638db60$var$mc(a) {
    a.context._currentValue = a.parentValue;
    a = a.parent;
    null !== a && $f60d5b61c638db60$var$mc(a);
}
function $f60d5b61c638db60$var$nc(a) {
    var b = a.parent;
    null !== b && $f60d5b61c638db60$var$nc(b);
    a.context._currentValue = a.value;
}
function $f60d5b61c638db60$var$oc(a, b) {
    a.context._currentValue = a.parentValue;
    a = a.parent;
    if (null === a) throw Error($f60d5b61c638db60$var$k(402));
    a.depth === b.depth ? $f60d5b61c638db60$var$P(a, b) : $f60d5b61c638db60$var$oc(a, b);
}
function $f60d5b61c638db60$var$pc(a, b) {
    var c = b.parent;
    if (null === c) throw Error($f60d5b61c638db60$var$k(402));
    a.depth === c.depth ? $f60d5b61c638db60$var$P(a, c) : $f60d5b61c638db60$var$pc(a, c);
    b.context._currentValue = b.value;
}
function $f60d5b61c638db60$var$Q(a) {
    var b = $f60d5b61c638db60$var$O;
    b !== a && (null === b ? $f60d5b61c638db60$var$nc(a) : null === a ? $f60d5b61c638db60$var$mc(b) : b.depth === a.depth ? $f60d5b61c638db60$var$P(b, a) : b.depth > a.depth ? $f60d5b61c638db60$var$oc(b, a) : $f60d5b61c638db60$var$pc(b, a), $f60d5b61c638db60$var$O = a);
}
var $f60d5b61c638db60$var$qc = {
    isMounted: function() {
        return !1;
    },
    enqueueSetState: function(a, b) {
        a = a._reactInternals;
        null !== a.queue && a.queue.push(b);
    },
    enqueueReplaceState: function(a, b) {
        a = a._reactInternals;
        a.replace = !0;
        a.queue = [
            b
        ];
    },
    enqueueForceUpdate: function() {}
};
function $f60d5b61c638db60$var$rc(a, b, c, d) {
    var f = void 0 !== a.state ? a.state : null;
    a.updater = $f60d5b61c638db60$var$qc;
    a.props = c;
    a.state = f;
    var e = {
        queue: [],
        replace: !1
    };
    a._reactInternals = e;
    var g = b.contextType;
    a.context = "object" === typeof g && null !== g ? g._currentValue : d;
    g = b.getDerivedStateFromProps;
    "function" === typeof g && (g = g(c, f), f = null === g || void 0 === g ? f : $f60d5b61c638db60$var$N({}, f, g), a.state = f);
    if ("function" !== typeof b.getDerivedStateFromProps && "function" !== typeof a.getSnapshotBeforeUpdate && ("function" === typeof a.UNSAFE_componentWillMount || "function" === typeof a.componentWillMount)) {
        if (b = a.state, "function" === typeof a.componentWillMount && a.componentWillMount(), "function" === typeof a.UNSAFE_componentWillMount && a.UNSAFE_componentWillMount(), b !== a.state && $f60d5b61c638db60$var$qc.enqueueReplaceState(a, a.state, null), null !== e.queue && 0 < e.queue.length) {
            if (b = e.queue, g = e.replace, e.queue = null, e.replace = !1, g && 1 === b.length) a.state = b[0];
            else {
                e = g ? b[0] : a.state;
                f = !0;
                for(g = g ? 1 : 0; g < b.length; g++){
                    var h = b[g];
                    h = "function" === typeof h ? h.call(a, e, c, d) : h;
                    null != h && (f ? (f = !1, e = $f60d5b61c638db60$var$N({}, e, h)) : $f60d5b61c638db60$var$N(e, h));
                }
                a.state = e;
            }
        } else e.queue = null;
    }
}
var $f60d5b61c638db60$var$sc = {
    id: 1,
    overflow: ""
};
function $f60d5b61c638db60$var$tc(a, b, c) {
    var d = a.id;
    a = a.overflow;
    var f = 32 - $f60d5b61c638db60$var$uc(d) - 1;
    d &= ~(1 << f);
    c += 1;
    var e = 32 - $f60d5b61c638db60$var$uc(b) + f;
    if (30 < e) {
        var g = f - f % 5;
        e = (d & (1 << g) - 1).toString(32);
        d >>= g;
        f -= g;
        return {
            id: 1 << 32 - $f60d5b61c638db60$var$uc(b) + f | c << f | d,
            overflow: e + a
        };
    }
    return {
        id: 1 << e | c << f | d,
        overflow: a
    };
}
var $f60d5b61c638db60$var$uc = Math.clz32 ? Math.clz32 : $f60d5b61c638db60$var$vc, $f60d5b61c638db60$var$wc = Math.log, $f60d5b61c638db60$var$xc = Math.LN2;
function $f60d5b61c638db60$var$vc(a) {
    a >>>= 0;
    return 0 === a ? 32 : 31 - ($f60d5b61c638db60$var$wc(a) / $f60d5b61c638db60$var$xc | 0) | 0;
}
function $f60d5b61c638db60$var$yc(a, b) {
    return a === b && (0 !== a || 1 / a === 1 / b) || a !== a && b !== b;
}
var $f60d5b61c638db60$var$zc = "function" === typeof Object.is ? Object.is : $f60d5b61c638db60$var$yc, $f60d5b61c638db60$var$R = null, $f60d5b61c638db60$var$Ac = null, $f60d5b61c638db60$var$Bc = null, $f60d5b61c638db60$var$S = null, $f60d5b61c638db60$var$T = !1, $f60d5b61c638db60$var$Cc = !1, $f60d5b61c638db60$var$U = 0, $f60d5b61c638db60$var$V = null, $f60d5b61c638db60$var$Dc = 0;
function $f60d5b61c638db60$var$W() {
    if (null === $f60d5b61c638db60$var$R) throw Error($f60d5b61c638db60$var$k(321));
    return $f60d5b61c638db60$var$R;
}
function $f60d5b61c638db60$var$Ec() {
    if (0 < $f60d5b61c638db60$var$Dc) throw Error($f60d5b61c638db60$var$k(312));
    return {
        memoizedState: null,
        queue: null,
        next: null
    };
}
function $f60d5b61c638db60$var$Fc() {
    null === $f60d5b61c638db60$var$S ? null === $f60d5b61c638db60$var$Bc ? ($f60d5b61c638db60$var$T = !1, $f60d5b61c638db60$var$Bc = $f60d5b61c638db60$var$S = $f60d5b61c638db60$var$Ec()) : ($f60d5b61c638db60$var$T = !0, $f60d5b61c638db60$var$S = $f60d5b61c638db60$var$Bc) : null === $f60d5b61c638db60$var$S.next ? ($f60d5b61c638db60$var$T = !1, $f60d5b61c638db60$var$S = $f60d5b61c638db60$var$S.next = $f60d5b61c638db60$var$Ec()) : ($f60d5b61c638db60$var$T = !0, $f60d5b61c638db60$var$S = $f60d5b61c638db60$var$S.next);
    return $f60d5b61c638db60$var$S;
}
function $f60d5b61c638db60$var$Gc() {
    $f60d5b61c638db60$var$Ac = $f60d5b61c638db60$var$R = null;
    $f60d5b61c638db60$var$Cc = !1;
    $f60d5b61c638db60$var$Bc = null;
    $f60d5b61c638db60$var$Dc = 0;
    $f60d5b61c638db60$var$S = $f60d5b61c638db60$var$V = null;
}
function $f60d5b61c638db60$var$Hc(a, b) {
    return "function" === typeof b ? b(a) : b;
}
function $f60d5b61c638db60$var$Ic(a, b, c) {
    $f60d5b61c638db60$var$R = $f60d5b61c638db60$var$W();
    $f60d5b61c638db60$var$S = $f60d5b61c638db60$var$Fc();
    if ($f60d5b61c638db60$var$T) {
        var d = $f60d5b61c638db60$var$S.queue;
        b = d.dispatch;
        if (null !== $f60d5b61c638db60$var$V && (c = $f60d5b61c638db60$var$V.get(d), void 0 !== c)) {
            $f60d5b61c638db60$var$V.delete(d);
            d = $f60d5b61c638db60$var$S.memoizedState;
            do d = a(d, c.action), c = c.next;
            while (null !== c);
            $f60d5b61c638db60$var$S.memoizedState = d;
            return [
                d,
                b
            ];
        }
        return [
            $f60d5b61c638db60$var$S.memoizedState,
            b
        ];
    }
    a = a === $f60d5b61c638db60$var$Hc ? "function" === typeof b ? b() : b : void 0 !== c ? c(b) : b;
    $f60d5b61c638db60$var$S.memoizedState = a;
    a = $f60d5b61c638db60$var$S.queue = {
        last: null,
        dispatch: null
    };
    a = a.dispatch = $f60d5b61c638db60$var$Jc.bind(null, $f60d5b61c638db60$var$R, a);
    return [
        $f60d5b61c638db60$var$S.memoizedState,
        a
    ];
}
function $f60d5b61c638db60$var$Kc(a, b) {
    $f60d5b61c638db60$var$R = $f60d5b61c638db60$var$W();
    $f60d5b61c638db60$var$S = $f60d5b61c638db60$var$Fc();
    b = void 0 === b ? null : b;
    if (null !== $f60d5b61c638db60$var$S) {
        var c = $f60d5b61c638db60$var$S.memoizedState;
        if (null !== c && null !== b) {
            var d = c[1];
            a: if (null === d) d = !1;
            else {
                for(var f = 0; f < d.length && f < b.length; f++)if (!$f60d5b61c638db60$var$zc(b[f], d[f])) {
                    d = !1;
                    break a;
                }
                d = !0;
            }
            if (d) return c[0];
        }
    }
    a = a();
    $f60d5b61c638db60$var$S.memoizedState = [
        a,
        b
    ];
    return a;
}
function $f60d5b61c638db60$var$Jc(a, b, c) {
    if (25 <= $f60d5b61c638db60$var$Dc) throw Error($f60d5b61c638db60$var$k(301));
    if (a === $f60d5b61c638db60$var$R) {
        if ($f60d5b61c638db60$var$Cc = !0, a = {
            action: c,
            next: null
        }, null === $f60d5b61c638db60$var$V && ($f60d5b61c638db60$var$V = new Map), c = $f60d5b61c638db60$var$V.get(b), void 0 === c) $f60d5b61c638db60$var$V.set(b, a);
        else {
            for(b = c; null !== b.next;)b = b.next;
            b.next = a;
        }
    }
}
function $f60d5b61c638db60$var$Lc() {
    throw Error($f60d5b61c638db60$var$k(394));
}
function $f60d5b61c638db60$var$Mc() {}
var $f60d5b61c638db60$var$Oc = {
    readContext: function(a) {
        return a._currentValue;
    },
    useContext: function(a) {
        $f60d5b61c638db60$var$W();
        return a._currentValue;
    },
    useMemo: $f60d5b61c638db60$var$Kc,
    useReducer: $f60d5b61c638db60$var$Ic,
    useRef: function(a) {
        $f60d5b61c638db60$var$R = $f60d5b61c638db60$var$W();
        $f60d5b61c638db60$var$S = $f60d5b61c638db60$var$Fc();
        var b = $f60d5b61c638db60$var$S.memoizedState;
        return null === b ? (a = {
            current: a
        }, $f60d5b61c638db60$var$S.memoizedState = a) : b;
    },
    useState: function(a) {
        return $f60d5b61c638db60$var$Ic($f60d5b61c638db60$var$Hc, a);
    },
    useInsertionEffect: $f60d5b61c638db60$var$Mc,
    useLayoutEffect: function() {},
    useCallback: function(a, b) {
        return $f60d5b61c638db60$var$Kc(function() {
            return a;
        }, b);
    },
    useImperativeHandle: $f60d5b61c638db60$var$Mc,
    useEffect: $f60d5b61c638db60$var$Mc,
    useDebugValue: $f60d5b61c638db60$var$Mc,
    useDeferredValue: function(a) {
        $f60d5b61c638db60$var$W();
        return a;
    },
    useTransition: function() {
        $f60d5b61c638db60$var$W();
        return [
            !1,
            $f60d5b61c638db60$var$Lc
        ];
    },
    useId: function() {
        var a = $f60d5b61c638db60$var$Ac.treeContext;
        var b = a.overflow;
        a = a.id;
        a = (a & ~(1 << 32 - $f60d5b61c638db60$var$uc(a) - 1)).toString(32) + b;
        var c = $f60d5b61c638db60$var$Nc;
        if (null === c) throw Error($f60d5b61c638db60$var$k(404));
        b = $f60d5b61c638db60$var$U++;
        a = ":" + c.idPrefix + "R" + a;
        0 < b && (a += "H" + b.toString(32));
        return a + ":";
    },
    useMutableSource: function(a, b) {
        $f60d5b61c638db60$var$W();
        return b(a._source);
    },
    useSyncExternalStore: function(a, b, c) {
        if (void 0 === c) throw Error($f60d5b61c638db60$var$k(407));
        return c();
    }
}, $f60d5b61c638db60$var$Nc = null, $f60d5b61c638db60$var$Pc = $5uXOq.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentDispatcher;
function $f60d5b61c638db60$var$Qc(a) {
    console.error(a);
    return null;
}
function $f60d5b61c638db60$var$X() {}
function $f60d5b61c638db60$var$Rc(a, b, c, d, f, e, g, h, m) {
    var q = [], r = new Set;
    b = {
        destination: null,
        responseState: b,
        progressiveChunkSize: void 0 === d ? 12800 : d,
        status: 0,
        fatalError: null,
        nextSegmentId: 0,
        allPendingTasks: 0,
        pendingRootTasks: 0,
        completedRootSegment: null,
        abortableTasks: r,
        pingedTasks: q,
        clientRenderedBoundaries: [],
        completedBoundaries: [],
        partialBoundaries: [],
        onError: void 0 === f ? $f60d5b61c638db60$var$Qc : f,
        onAllReady: void 0 === e ? $f60d5b61c638db60$var$X : e,
        onShellReady: void 0 === g ? $f60d5b61c638db60$var$X : g,
        onShellError: void 0 === h ? $f60d5b61c638db60$var$X : h,
        onFatalError: void 0 === m ? $f60d5b61c638db60$var$X : m
    };
    c = $f60d5b61c638db60$var$Sc(b, 0, null, c, !1, !1);
    c.parentFlushed = !0;
    a = $f60d5b61c638db60$var$Tc(b, a, null, c, r, $f60d5b61c638db60$var$kc, null, $f60d5b61c638db60$var$sc);
    q.push(a);
    return b;
}
function $f60d5b61c638db60$var$Tc(a, b, c, d, f, e, g, h) {
    a.allPendingTasks++;
    null === c ? a.pendingRootTasks++ : c.pendingTasks++;
    var m = {
        node: b,
        ping: function() {
            var b = a.pingedTasks;
            b.push(m);
            1 === b.length && $f60d5b61c638db60$var$Uc(a);
        },
        blockedBoundary: c,
        blockedSegment: d,
        abortSet: f,
        legacyContext: e,
        context: g,
        treeContext: h
    };
    f.add(m);
    return m;
}
function $f60d5b61c638db60$var$Sc(a, b, c, d, f, e) {
    return {
        status: 0,
        id: -1,
        index: b,
        parentFlushed: !1,
        chunks: [],
        children: [],
        formatContext: d,
        boundary: c,
        lastPushedText: f,
        textEmbedded: e
    };
}
function $f60d5b61c638db60$var$Y(a, b) {
    a = a.onError(b);
    if (null != a && "string" !== typeof a) throw Error('onError returned something with a type other than "string". onError should return a string and may return null or undefined but must not return anything else. It received something of type "' + typeof a + '" instead');
    return a;
}
function $f60d5b61c638db60$var$Vc(a, b) {
    var c = a.onShellError;
    c(b);
    c = a.onFatalError;
    c(b);
    null !== a.destination ? (a.status = 2, $f60d5b61c638db60$var$da(a.destination, b)) : (a.status = 1, a.fatalError = b);
}
function $f60d5b61c638db60$var$Wc(a, b, c, d, f) {
    $f60d5b61c638db60$var$R = {};
    $f60d5b61c638db60$var$Ac = b;
    $f60d5b61c638db60$var$U = 0;
    for(a = c(d, f); $f60d5b61c638db60$var$Cc;)$f60d5b61c638db60$var$Cc = !1, $f60d5b61c638db60$var$U = 0, $f60d5b61c638db60$var$Dc += 1, $f60d5b61c638db60$var$S = null, a = c(d, f);
    $f60d5b61c638db60$var$Gc();
    return a;
}
function $f60d5b61c638db60$var$Xc(a, b, c, d) {
    var f = c.render(), e = d.childContextTypes;
    if (null !== e && void 0 !== e) {
        var g = b.legacyContext;
        if ("function" !== typeof c.getChildContext) d = g;
        else {
            c = c.getChildContext();
            for(var h in c)if (!(h in e)) throw Error($f60d5b61c638db60$var$k(108, $f60d5b61c638db60$var$jc(d) || "Unknown", h));
            d = $f60d5b61c638db60$var$N({}, g, c);
        }
        b.legacyContext = d;
        $f60d5b61c638db60$var$Z(a, b, f);
        b.legacyContext = g;
    } else $f60d5b61c638db60$var$Z(a, b, f);
}
function $f60d5b61c638db60$var$Yc(a, b) {
    if (a && a.defaultProps) {
        b = $f60d5b61c638db60$var$N({}, b);
        a = a.defaultProps;
        for(var c in a)void 0 === b[c] && (b[c] = a[c]);
        return b;
    }
    return b;
}
function $f60d5b61c638db60$var$Zc(a, b, c, d, f) {
    if ("function" === typeof c) {
        if (c.prototype && c.prototype.isReactComponent) {
            f = $f60d5b61c638db60$var$lc(c, b.legacyContext);
            var e = c.contextType;
            e = new c(d, "object" === typeof e && null !== e ? e._currentValue : f);
            $f60d5b61c638db60$var$rc(e, c, d, f);
            $f60d5b61c638db60$var$Xc(a, b, e, c);
        } else {
            e = $f60d5b61c638db60$var$lc(c, b.legacyContext);
            f = $f60d5b61c638db60$var$Wc(a, b, c, d, e);
            var g = 0 !== $f60d5b61c638db60$var$U;
            if ("object" === typeof f && null !== f && "function" === typeof f.render && void 0 === f.$$typeof) $f60d5b61c638db60$var$rc(f, c, d, e), $f60d5b61c638db60$var$Xc(a, b, f, c);
            else if (g) {
                d = b.treeContext;
                b.treeContext = $f60d5b61c638db60$var$tc(d, 1, 0);
                try {
                    $f60d5b61c638db60$var$Z(a, b, f);
                } finally{
                    b.treeContext = d;
                }
            } else $f60d5b61c638db60$var$Z(a, b, f);
        }
    } else if ("string" === typeof c) {
        f = b.blockedSegment;
        e = $f60d5b61c638db60$var$Sa(f.chunks, c, d, a.responseState, f.formatContext);
        f.lastPushedText = !1;
        g = f.formatContext;
        f.formatContext = $f60d5b61c638db60$var$Ba(g, c, d);
        $f60d5b61c638db60$var$$c(a, b, e);
        f.formatContext = g;
        switch(c){
            case "area":
            case "base":
            case "br":
            case "col":
            case "embed":
            case "hr":
            case "img":
            case "input":
            case "keygen":
            case "link":
            case "meta":
            case "param":
            case "source":
            case "track":
            case "wbr":
                break;
            default:
                f.chunks.push($f60d5b61c638db60$var$Ta, $f60d5b61c638db60$var$u(c), $f60d5b61c638db60$var$Ua);
        }
        f.lastPushedText = !1;
    } else {
        switch(c){
            case $f60d5b61c638db60$var$gc:
            case $f60d5b61c638db60$var$fc:
            case $f60d5b61c638db60$var$Wb:
            case $f60d5b61c638db60$var$Xb:
            case $f60d5b61c638db60$var$Vb:
                $f60d5b61c638db60$var$Z(a, b, d.children);
                return;
            case $f60d5b61c638db60$var$bc:
                $f60d5b61c638db60$var$Z(a, b, d.children);
                return;
            case $f60d5b61c638db60$var$ec:
                throw Error($f60d5b61c638db60$var$k(343));
            case $f60d5b61c638db60$var$ac:
                a: {
                    c = b.blockedBoundary;
                    f = b.blockedSegment;
                    e = d.fallback;
                    d = d.children;
                    g = new Set;
                    var h = {
                        id: null,
                        rootSegmentID: -1,
                        parentFlushed: !1,
                        pendingTasks: 0,
                        forceClientRender: !1,
                        completedSegments: [],
                        byteSize: 0,
                        fallbackAbortableTasks: g,
                        errorDigest: null
                    }, m = $f60d5b61c638db60$var$Sc(a, f.chunks.length, h, f.formatContext, !1, !1);
                    f.children.push(m);
                    f.lastPushedText = !1;
                    var q = $f60d5b61c638db60$var$Sc(a, 0, null, f.formatContext, !1, !1);
                    q.parentFlushed = !0;
                    b.blockedBoundary = h;
                    b.blockedSegment = q;
                    try {
                        if ($f60d5b61c638db60$var$$c(a, b, d), q.lastPushedText && q.textEmbedded && q.chunks.push($f60d5b61c638db60$var$Ca), q.status = 1, $f60d5b61c638db60$var$ad(h, q), 0 === h.pendingTasks) break a;
                    } catch (r) {
                        q.status = 4, h.forceClientRender = !0, h.errorDigest = $f60d5b61c638db60$var$Y(a, r);
                    } finally{
                        b.blockedBoundary = c, b.blockedSegment = f;
                    }
                    b = $f60d5b61c638db60$var$Tc(a, e, c, m, g, b.legacyContext, b.context, b.treeContext);
                    a.pingedTasks.push(b);
                }
                return;
        }
        if ("object" === typeof c && null !== c) switch(c.$$typeof){
            case $f60d5b61c638db60$var$$b:
                d = $f60d5b61c638db60$var$Wc(a, b, c.render, d, f);
                if (0 !== $f60d5b61c638db60$var$U) {
                    c = b.treeContext;
                    b.treeContext = $f60d5b61c638db60$var$tc(c, 1, 0);
                    try {
                        $f60d5b61c638db60$var$Z(a, b, d);
                    } finally{
                        b.treeContext = c;
                    }
                } else $f60d5b61c638db60$var$Z(a, b, d);
                return;
            case $f60d5b61c638db60$var$cc:
                c = c.type;
                d = $f60d5b61c638db60$var$Yc(c, d);
                $f60d5b61c638db60$var$Zc(a, b, c, d, f);
                return;
            case $f60d5b61c638db60$var$Yb:
                f = d.children;
                c = c._context;
                d = d.value;
                e = c._currentValue;
                c._currentValue = d;
                g = $f60d5b61c638db60$var$O;
                $f60d5b61c638db60$var$O = d = {
                    parent: g,
                    depth: null === g ? 0 : g.depth + 1,
                    context: c,
                    parentValue: e,
                    value: d
                };
                b.context = d;
                $f60d5b61c638db60$var$Z(a, b, f);
                a = $f60d5b61c638db60$var$O;
                if (null === a) throw Error($f60d5b61c638db60$var$k(403));
                d = a.parentValue;
                a.context._currentValue = d === $f60d5b61c638db60$var$hc ? a.context._defaultValue : d;
                a = $f60d5b61c638db60$var$O = a.parent;
                b.context = a;
                return;
            case $f60d5b61c638db60$var$Zb:
                d = d.children;
                d = d(c._currentValue);
                $f60d5b61c638db60$var$Z(a, b, d);
                return;
            case $f60d5b61c638db60$var$dc:
                f = c._init;
                c = f(c._payload);
                d = $f60d5b61c638db60$var$Yc(c, d);
                $f60d5b61c638db60$var$Zc(a, b, c, d, void 0);
                return;
        }
        throw Error($f60d5b61c638db60$var$k(130, null == c ? c : typeof c, ""));
    }
}
function $f60d5b61c638db60$var$Z(a, b, c) {
    b.node = c;
    if ("object" === typeof c && null !== c) {
        switch(c.$$typeof){
            case $f60d5b61c638db60$var$Tb:
                $f60d5b61c638db60$var$Zc(a, b, c.type, c.props, c.ref);
                return;
            case $f60d5b61c638db60$var$Ub:
                throw Error($f60d5b61c638db60$var$k(257));
            case $f60d5b61c638db60$var$dc:
                var d = c._init;
                c = d(c._payload);
                $f60d5b61c638db60$var$Z(a, b, c);
                return;
        }
        if ($f60d5b61c638db60$var$ra(c)) {
            $f60d5b61c638db60$var$bd(a, b, c);
            return;
        }
        null === c || "object" !== typeof c ? d = null : (d = $f60d5b61c638db60$var$ic && c[$f60d5b61c638db60$var$ic] || c["@@iterator"], d = "function" === typeof d ? d : null);
        if (d && (d = d.call(c))) {
            c = d.next();
            if (!c.done) {
                var f = [];
                do f.push(c.value), c = d.next();
                while (!c.done);
                $f60d5b61c638db60$var$bd(a, b, f);
            }
            return;
        }
        a = Object.prototype.toString.call(c);
        throw Error($f60d5b61c638db60$var$k(31, "[object Object]" === a ? "object with keys {" + Object.keys(c).join(", ") + "}" : a));
    }
    "string" === typeof c ? (d = b.blockedSegment, d.lastPushedText = $f60d5b61c638db60$var$Da(b.blockedSegment.chunks, c, a.responseState, d.lastPushedText)) : "number" === typeof c && (d = b.blockedSegment, d.lastPushedText = $f60d5b61c638db60$var$Da(b.blockedSegment.chunks, "" + c, a.responseState, d.lastPushedText));
}
function $f60d5b61c638db60$var$bd(a, b, c) {
    for(var d = c.length, f = 0; f < d; f++){
        var e = b.treeContext;
        b.treeContext = $f60d5b61c638db60$var$tc(e, d, f);
        try {
            $f60d5b61c638db60$var$$c(a, b, c[f]);
        } finally{
            b.treeContext = e;
        }
    }
}
function $f60d5b61c638db60$var$$c(a, b, c) {
    var d = b.blockedSegment.formatContext, f = b.legacyContext, e = b.context;
    try {
        return $f60d5b61c638db60$var$Z(a, b, c);
    } catch (m) {
        if ($f60d5b61c638db60$var$Gc(), "object" === typeof m && null !== m && "function" === typeof m.then) {
            c = m;
            var g = b.blockedSegment, h = $f60d5b61c638db60$var$Sc(a, g.chunks.length, null, g.formatContext, g.lastPushedText, !0);
            g.children.push(h);
            g.lastPushedText = !1;
            a = $f60d5b61c638db60$var$Tc(a, b.node, b.blockedBoundary, h, b.abortSet, b.legacyContext, b.context, b.treeContext).ping;
            c.then(a, a);
            b.blockedSegment.formatContext = d;
            b.legacyContext = f;
            b.context = e;
            $f60d5b61c638db60$var$Q(e);
        } else throw b.blockedSegment.formatContext = d, b.legacyContext = f, b.context = e, $f60d5b61c638db60$var$Q(e), m;
    }
}
function $f60d5b61c638db60$var$cd(a) {
    var b = a.blockedBoundary;
    a = a.blockedSegment;
    a.status = 3;
    $f60d5b61c638db60$var$dd(this, b, a);
}
function $f60d5b61c638db60$var$ed(a, b, c) {
    var d = a.blockedBoundary;
    a.blockedSegment.status = 3;
    null === d ? (b.allPendingTasks--, 2 !== b.status && (b.status = 2, null !== b.destination && b.destination.close())) : (d.pendingTasks--, d.forceClientRender || (d.forceClientRender = !0, a = void 0 === c ? Error($f60d5b61c638db60$var$k(432)) : c, d.errorDigest = b.onError(a), d.parentFlushed && b.clientRenderedBoundaries.push(d)), d.fallbackAbortableTasks.forEach(function(a) {
        return $f60d5b61c638db60$var$ed(a, b, c);
    }), d.fallbackAbortableTasks.clear(), b.allPendingTasks--, 0 === b.allPendingTasks && (d = b.onAllReady, d()));
}
function $f60d5b61c638db60$var$ad(a, b) {
    if (0 === b.chunks.length && 1 === b.children.length && null === b.children[0].boundary) {
        var c = b.children[0];
        c.id = b.id;
        c.parentFlushed = !0;
        1 === c.status && $f60d5b61c638db60$var$ad(a, c);
    } else a.completedSegments.push(b);
}
function $f60d5b61c638db60$var$dd(a, b, c) {
    if (null === b) {
        if (c.parentFlushed) {
            if (null !== a.completedRootSegment) throw Error($f60d5b61c638db60$var$k(389));
            a.completedRootSegment = c;
        }
        a.pendingRootTasks--;
        0 === a.pendingRootTasks && (a.onShellError = $f60d5b61c638db60$var$X, b = a.onShellReady, b());
    } else b.pendingTasks--, b.forceClientRender || (0 === b.pendingTasks ? (c.parentFlushed && 1 === c.status && $f60d5b61c638db60$var$ad(b, c), b.parentFlushed && a.completedBoundaries.push(b), b.fallbackAbortableTasks.forEach($f60d5b61c638db60$var$cd, a), b.fallbackAbortableTasks.clear()) : c.parentFlushed && 1 === c.status && ($f60d5b61c638db60$var$ad(b, c), 1 === b.completedSegments.length && b.parentFlushed && a.partialBoundaries.push(b)));
    a.allPendingTasks--;
    0 === a.allPendingTasks && (a = a.onAllReady, a());
}
function $f60d5b61c638db60$var$Uc(a) {
    if (2 !== a.status) {
        var b = $f60d5b61c638db60$var$O, c = $f60d5b61c638db60$var$Pc.current;
        $f60d5b61c638db60$var$Pc.current = $f60d5b61c638db60$var$Oc;
        var d = $f60d5b61c638db60$var$Nc;
        $f60d5b61c638db60$var$Nc = a.responseState;
        try {
            var f = a.pingedTasks, e;
            for(e = 0; e < f.length; e++){
                var g = f[e];
                var h = a, m = g.blockedSegment;
                if (0 === m.status) {
                    $f60d5b61c638db60$var$Q(g.context);
                    try {
                        $f60d5b61c638db60$var$Z(h, g, g.node), m.lastPushedText && m.textEmbedded && m.chunks.push($f60d5b61c638db60$var$Ca), g.abortSet.delete(g), m.status = 1, $f60d5b61c638db60$var$dd(h, g.blockedBoundary, m);
                    } catch (G) {
                        if ($f60d5b61c638db60$var$Gc(), "object" === typeof G && null !== G && "function" === typeof G.then) {
                            var q = g.ping;
                            G.then(q, q);
                        } else {
                            g.abortSet.delete(g);
                            m.status = 4;
                            var r = g.blockedBoundary, v = G, A = $f60d5b61c638db60$var$Y(h, v);
                            null === r ? $f60d5b61c638db60$var$Vc(h, v) : (r.pendingTasks--, r.forceClientRender || (r.forceClientRender = !0, r.errorDigest = A, r.parentFlushed && h.clientRenderedBoundaries.push(r)));
                            h.allPendingTasks--;
                            if (0 === h.allPendingTasks) {
                                var F = h.onAllReady;
                                F();
                            }
                        }
                    } finally{}
                }
            }
            f.splice(0, e);
            null !== a.destination && $f60d5b61c638db60$var$fd(a, a.destination);
        } catch (G) {
            $f60d5b61c638db60$var$Y(a, G), $f60d5b61c638db60$var$Vc(a, G);
        } finally{
            $f60d5b61c638db60$var$Nc = d, $f60d5b61c638db60$var$Pc.current = c, c === $f60d5b61c638db60$var$Oc && $f60d5b61c638db60$var$Q(b);
        }
    }
}
function $f60d5b61c638db60$var$gd(a, b, c) {
    c.parentFlushed = !0;
    switch(c.status){
        case 0:
            var d = c.id = a.nextSegmentId++;
            c.lastPushedText = !1;
            c.textEmbedded = !1;
            a = a.responseState;
            $f60d5b61c638db60$var$p(b, $f60d5b61c638db60$var$Va);
            $f60d5b61c638db60$var$p(b, a.placeholderPrefix);
            a = $f60d5b61c638db60$var$u(d.toString(16));
            $f60d5b61c638db60$var$p(b, a);
            return $f60d5b61c638db60$var$t(b, $f60d5b61c638db60$var$Wa);
        case 1:
            c.status = 2;
            var f = !0;
            d = c.chunks;
            var e = 0;
            c = c.children;
            for(var g = 0; g < c.length; g++){
                for(f = c[g]; e < f.index; e++)$f60d5b61c638db60$var$p(b, d[e]);
                f = $f60d5b61c638db60$var$hd(a, b, f);
            }
            for(; e < d.length - 1; e++)$f60d5b61c638db60$var$p(b, d[e]);
            e < d.length && (f = $f60d5b61c638db60$var$t(b, d[e]));
            return f;
        default:
            throw Error($f60d5b61c638db60$var$k(390));
    }
}
function $f60d5b61c638db60$var$hd(a, b, c) {
    var d = c.boundary;
    if (null === d) return $f60d5b61c638db60$var$gd(a, b, c);
    d.parentFlushed = !0;
    if (d.forceClientRender) d = d.errorDigest, $f60d5b61c638db60$var$t(b, $f60d5b61c638db60$var$$a), $f60d5b61c638db60$var$p(b, $f60d5b61c638db60$var$bb), d && ($f60d5b61c638db60$var$p(b, $f60d5b61c638db60$var$db), $f60d5b61c638db60$var$p(b, $f60d5b61c638db60$var$u($f60d5b61c638db60$var$C(d))), $f60d5b61c638db60$var$p(b, $f60d5b61c638db60$var$cb)), $f60d5b61c638db60$var$t(b, $f60d5b61c638db60$var$eb), $f60d5b61c638db60$var$gd(a, b, c);
    else if (0 < d.pendingTasks) {
        d.rootSegmentID = a.nextSegmentId++;
        0 < d.completedSegments.length && a.partialBoundaries.push(d);
        var f = a.responseState;
        var e = f.nextSuspenseID++;
        f = $f60d5b61c638db60$var$w(f.boundaryPrefix + e.toString(16));
        d = d.id = f;
        $f60d5b61c638db60$var$fb(b, a.responseState, d);
        $f60d5b61c638db60$var$gd(a, b, c);
    } else if (d.byteSize > a.progressiveChunkSize) d.rootSegmentID = a.nextSegmentId++, a.completedBoundaries.push(d), $f60d5b61c638db60$var$fb(b, a.responseState, d.id), $f60d5b61c638db60$var$gd(a, b, c);
    else {
        $f60d5b61c638db60$var$t(b, $f60d5b61c638db60$var$Xa);
        c = d.completedSegments;
        if (1 !== c.length) throw Error($f60d5b61c638db60$var$k(391));
        $f60d5b61c638db60$var$hd(a, b, c[0]);
    }
    return $f60d5b61c638db60$var$t(b, $f60d5b61c638db60$var$ab);
}
function $f60d5b61c638db60$var$id(a, b, c) {
    $f60d5b61c638db60$var$Bb(b, a.responseState, c.formatContext, c.id);
    $f60d5b61c638db60$var$hd(a, b, c);
    return $f60d5b61c638db60$var$Cb(b, c.formatContext);
}
function $f60d5b61c638db60$var$jd(a, b, c) {
    for(var d = c.completedSegments, f = 0; f < d.length; f++)$f60d5b61c638db60$var$kd(a, b, c, d[f]);
    d.length = 0;
    a = a.responseState;
    d = c.id;
    c = c.rootSegmentID;
    $f60d5b61c638db60$var$p(b, a.startInlineScript);
    a.sentCompleteBoundaryFunction ? $f60d5b61c638db60$var$p(b, $f60d5b61c638db60$var$Jb) : (a.sentCompleteBoundaryFunction = !0, $f60d5b61c638db60$var$p(b, $f60d5b61c638db60$var$Ib));
    if (null === d) throw Error($f60d5b61c638db60$var$k(395));
    c = $f60d5b61c638db60$var$u(c.toString(16));
    $f60d5b61c638db60$var$p(b, d);
    $f60d5b61c638db60$var$p(b, $f60d5b61c638db60$var$Kb);
    $f60d5b61c638db60$var$p(b, a.segmentPrefix);
    $f60d5b61c638db60$var$p(b, c);
    return $f60d5b61c638db60$var$t(b, $f60d5b61c638db60$var$Lb);
}
function $f60d5b61c638db60$var$kd(a, b, c, d) {
    if (2 === d.status) return !0;
    var f = d.id;
    if (-1 === f) {
        if (-1 === (d.id = c.rootSegmentID)) throw Error($f60d5b61c638db60$var$k(392));
        return $f60d5b61c638db60$var$id(a, b, d);
    }
    $f60d5b61c638db60$var$id(a, b, d);
    a = a.responseState;
    $f60d5b61c638db60$var$p(b, a.startInlineScript);
    a.sentCompleteSegmentFunction ? $f60d5b61c638db60$var$p(b, $f60d5b61c638db60$var$Eb) : (a.sentCompleteSegmentFunction = !0, $f60d5b61c638db60$var$p(b, $f60d5b61c638db60$var$Db));
    $f60d5b61c638db60$var$p(b, a.segmentPrefix);
    f = $f60d5b61c638db60$var$u(f.toString(16));
    $f60d5b61c638db60$var$p(b, f);
    $f60d5b61c638db60$var$p(b, $f60d5b61c638db60$var$Gb);
    $f60d5b61c638db60$var$p(b, a.placeholderPrefix);
    $f60d5b61c638db60$var$p(b, f);
    return $f60d5b61c638db60$var$t(b, $f60d5b61c638db60$var$Hb);
}
function $f60d5b61c638db60$var$fd(a, b) {
    $f60d5b61c638db60$var$l = new Uint8Array(512);
    $f60d5b61c638db60$var$n = 0;
    try {
        var c = a.completedRootSegment;
        if (null !== c && 0 === a.pendingRootTasks) {
            $f60d5b61c638db60$var$hd(a, b, c);
            a.completedRootSegment = null;
            var d = a.responseState.bootstrapChunks;
            for(c = 0; c < d.length - 1; c++)$f60d5b61c638db60$var$p(b, d[c]);
            c < d.length && $f60d5b61c638db60$var$t(b, d[c]);
        }
        var f = a.clientRenderedBoundaries, e;
        for(e = 0; e < f.length; e++){
            var g = f[e];
            d = b;
            var h = a.responseState, m = g.id, q = g.errorDigest, r = g.errorMessage, v = g.errorComponentStack;
            $f60d5b61c638db60$var$p(d, h.startInlineScript);
            h.sentClientRenderFunction ? $f60d5b61c638db60$var$p(d, $f60d5b61c638db60$var$Nb) : (h.sentClientRenderFunction = !0, $f60d5b61c638db60$var$p(d, $f60d5b61c638db60$var$Mb));
            if (null === m) throw Error($f60d5b61c638db60$var$k(395));
            $f60d5b61c638db60$var$p(d, m);
            $f60d5b61c638db60$var$p(d, $f60d5b61c638db60$var$Ob);
            if (q || r || v) $f60d5b61c638db60$var$p(d, $f60d5b61c638db60$var$Qb), $f60d5b61c638db60$var$p(d, $f60d5b61c638db60$var$u($f60d5b61c638db60$var$Sb(q || "")));
            if (r || v) $f60d5b61c638db60$var$p(d, $f60d5b61c638db60$var$Qb), $f60d5b61c638db60$var$p(d, $f60d5b61c638db60$var$u($f60d5b61c638db60$var$Sb(r || "")));
            v && ($f60d5b61c638db60$var$p(d, $f60d5b61c638db60$var$Qb), $f60d5b61c638db60$var$p(d, $f60d5b61c638db60$var$u($f60d5b61c638db60$var$Sb(v))));
            if (!$f60d5b61c638db60$var$t(d, $f60d5b61c638db60$var$Pb)) {
                a.destination = null;
                e++;
                f.splice(0, e);
                return;
            }
        }
        f.splice(0, e);
        var A = a.completedBoundaries;
        for(e = 0; e < A.length; e++)if (!$f60d5b61c638db60$var$jd(a, b, A[e])) {
            a.destination = null;
            e++;
            A.splice(0, e);
            return;
        }
        A.splice(0, e);
        $f60d5b61c638db60$var$ba(b);
        $f60d5b61c638db60$var$l = new Uint8Array(512);
        $f60d5b61c638db60$var$n = 0;
        var F = a.partialBoundaries;
        for(e = 0; e < F.length; e++){
            var G = F[e];
            a: {
                f = a;
                g = b;
                var ma = G.completedSegments;
                for(h = 0; h < ma.length; h++)if (!$f60d5b61c638db60$var$kd(f, g, G, ma[h])) {
                    h++;
                    ma.splice(0, h);
                    var Fb = !1;
                    break a;
                }
                ma.splice(0, h);
                Fb = !0;
            }
            if (!Fb) {
                a.destination = null;
                e++;
                F.splice(0, e);
                return;
            }
        }
        F.splice(0, e);
        var na = a.completedBoundaries;
        for(e = 0; e < na.length; e++)if (!$f60d5b61c638db60$var$jd(a, b, na[e])) {
            a.destination = null;
            e++;
            na.splice(0, e);
            return;
        }
        na.splice(0, e);
    } finally{
        $f60d5b61c638db60$var$ba(b), 0 === a.allPendingTasks && 0 === a.pingedTasks.length && 0 === a.clientRenderedBoundaries.length && 0 === a.completedBoundaries.length && b.close();
    }
}
function $f60d5b61c638db60$var$ld(a, b) {
    try {
        var c = a.abortableTasks;
        c.forEach(function(c) {
            return $f60d5b61c638db60$var$ed(c, a, b);
        });
        c.clear();
        null !== a.destination && $f60d5b61c638db60$var$fd(a, a.destination);
    } catch (d) {
        $f60d5b61c638db60$var$Y(a, d), $f60d5b61c638db60$var$Vc(a, d);
    }
}
$f60d5b61c638db60$export$7020a3240b287705 = function(a, b) {
    return new Promise(function(c, d) {
        var f, e, g = new Promise(function(a, b) {
            e = a;
            f = b;
        }), h = $f60d5b61c638db60$var$Rc(a, $f60d5b61c638db60$var$za(b ? b.identifierPrefix : void 0, b ? b.nonce : void 0, b ? b.bootstrapScriptContent : void 0, b ? b.bootstrapScripts : void 0, b ? b.bootstrapModules : void 0), $f60d5b61c638db60$var$Aa(b ? b.namespaceURI : void 0), b ? b.progressiveChunkSize : void 0, b ? b.onError : void 0, e, function() {
            var a = new ReadableStream({
                type: "bytes",
                pull: function(a) {
                    if (1 === h.status) h.status = 2, $f60d5b61c638db60$var$da(a, h.fatalError);
                    else if (2 !== h.status && null === h.destination) {
                        h.destination = a;
                        try {
                            $f60d5b61c638db60$var$fd(h, a);
                        } catch (A) {
                            $f60d5b61c638db60$var$Y(h, A), $f60d5b61c638db60$var$Vc(h, A);
                        }
                    }
                },
                cancel: function() {
                    $f60d5b61c638db60$var$ld(h);
                }
            }, {
                highWaterMark: 0
            });
            a.allReady = g;
            c(a);
        }, function(a) {
            g.catch(function() {});
            d(a);
        }, f);
        if (b && b.signal) {
            var m = b.signal, q = function() {
                $f60d5b61c638db60$var$ld(h, m.reason);
                m.removeEventListener("abort", q);
            };
            m.addEventListener("abort", q);
        }
        $f60d5b61c638db60$var$Uc(h);
    });
};
$f60d5b61c638db60$export$83d89fbfd8236492 = "18.2.0";

});


parcelRegister("j7UP0", function(module, exports) {

$parcel$export(module.exports, "CONSENT_DISPLAYED_TEXT_ITEMS", () => $42c02c06ad27adb5$export$99df83ca0f45bd54);

var $8FFpF = parcelRequire("8FFpF");
const $42c02c06ad27adb5$export$99df83ca0f45bd54 = [
    (0, $8FFpF.PreferenceCategory).Analytics,
    (0, $8FFpF.PreferenceCategory).Functional,
    (0, $8FFpF.PreferenceCategory).Marketing,
    (0, $8FFpF.PreferenceCategory).StrictlyNecessary,
    (0, $8FFpF.PreferenceCategory).Unknown
];

});

parcelRegister("krMbB", function(module, exports) {

$parcel$export(module.exports, "CookieCategorySection", () => $da8b62141b5f3ac8$export$3c97a3b492e10ae9);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $kkJfY = parcelRequire("kkJfY");

var $dC5iT = parcelRequire("dC5iT");
var $cgL5K = parcelRequire("cgL5K");
var $8CUq3 = parcelRequire("8CUq3");

var $3MsQ9 = parcelRequire("3MsQ9");

var $8FFpF = parcelRequire("8FFpF");
const $da8b62141b5f3ac8$var$tmpTrelloClassNameOverride = 'atl-bsc-preference-modal-checkbox';
// Styles
const $da8b62141b5f3ac8$var$categoryBoxStyles = (0, $8CUq3.xcss)({
    paddingBlockStart: 'space.200'
});
const $da8b62141b5f3ac8$var$categoryDescriptionStyles = (0, $8CUq3.xcss)({
    paddingInlineStart: 'space.300',
    marginInlineStart: 'space.050'
});
// We don't bother tracking unknown checkbox toggles
const $da8b62141b5f3ac8$var$categoryToEventSubjectMap = {
    [(0, $8FFpF.PreferenceCategory).Analytics]: 'performanceConsent',
    [(0, $8FFpF.PreferenceCategory).Functional]: 'functionalConsent',
    [(0, $8FFpF.PreferenceCategory).Marketing]: 'targetingConsent',
    [(0, $8FFpF.PreferenceCategory).Unknown]: null
};
const $da8b62141b5f3ac8$export$3c97a3b492e10ae9 = ({ category: category, titleElement: titleElement, titleString: titleString, descriptionElement: descriptionElement, isChecked: isChecked, setPreferencesData: setPreferencesData })=>{
    const onCheckboxChange = (0, $5uXOq.useCallback)(()=>{
        // Don't alter cookies that are strictly necessary
        if (category === (0, $8FFpF.PreferenceCategory).StrictlyNecessary) return;
        setPreferencesData((prevPrefsData)=>{
            const isSelected = prevPrefsData.prefs && !prevPrefsData.prefs[category];
            const actionSubjectId = $da8b62141b5f3ac8$var$categoryToEventSubjectMap[category];
            if (actionSubjectId) (0, $3MsQ9.sendUIEvent)({
                actionSubjectId: actionSubjectId,
                action: 'clicked',
                actionSubject: 'checkbox',
                source: 'cookieConsentModal',
                attributes: {
                    isSelected: isSelected
                }
            });
            return {
                ...prevPrefsData,
                prefs: {
                    ...prevPrefsData.prefs,
                    [category]: isSelected
                }
            };
        });
    }, [
        category,
        setPreferencesData
    ]);
    return /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $dC5iT.default), {
        xcss: $da8b62141b5f3ac8$var$categoryBoxStyles,
        children: [
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $kkJfY.default), {
                // eslint-disable-next-line @atlaskit/design-system/no-unsafe-style-overrides, @atlaskit/ui-styling-standard/no-classname-prop
                className: `${$da8b62141b5f3ac8$var$tmpTrelloClassNameOverride}`,
                isChecked: isChecked,
                value: isChecked.toString(),
                onChange: onCheckboxChange,
                label: titleElement,
                name: `${titleString}`
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $dC5iT.default), {
                xcss: $da8b62141b5f3ac8$var$categoryDescriptionStyles,
                children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $cgL5K.default), {
                    size: "UNSAFE_small",
                    color: "color.text.subtle",
                    children: descriptionElement
                })
            })
        ]
    });
};

});
parcelRegister("kkJfY", function(module, exports) {

$parcel$export(module.exports, "default", () => $3106eb14f9b0a593$export$2e2bcd8739ae039);
/* checkbox.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $6QvkM = parcelRequire("6QvkM");

var $5JjdN = parcelRequire("5JjdN");

var $kag1C = parcelRequire("kag1C");
var $7xteU = parcelRequire("7xteU");
var $hsLv2 = parcelRequire("hsLv2");
var $e62YQ = parcelRequire("e62YQ");
const $3106eb14f9b0a593$var$checkboxStyles = {
    root: "_19itglyw _nd5lfibj _12ji1r31 _1qu2glyw _12y31o36 _1bsb1osq _4t3i1osq _r06hglyw _6rthze3t _1pfhze3t _12l2ze3t _ahbqze3t _tzy4idpf _r050fibj _9bg71mn3 _19op11so _a30fhteq _1610e4h9 _13wo93zu _q5a61gyf _8gq114p8 _wje2mov0 _1fo21cni _eyedglyw _1ef7js4s _1h6rjs4s _smzgj3jf _1dk7j3jf _l71j1i6y _t34a1i6y _y32gkivo _1ah9199y _1frj180l _h78e1g3k _dwvb1ps2 _1bok170n _1mhr17cl _fx2i3rva _10oaq2ws _w12s155b _15y61vek _e6ww155b _sg1j1vek _rphw18jz _y9y9mz2b _141bmz2b _255gmz2b _jj67mz2b _swhgmz2b _axq81diq _1jiz1diq _s9051diq _1efy1diq _1oav1diq _10y313gf _1wt913gf _qq8613gf _1adw13gf _12sr13gf _16jiglyw _693jglyw _1niqglyw _cl9tglyw _1jbnglyw _j1ta1hou _18qu1ps2 _1g52170n _1log17cl _32hzmz2b _1vv91diq _yjhd1hou _w1cowc43 _jdqn1onz _4y4t1onz _lvfrwc43 _g68dwc43 _13dk1onz _w1el1onz _a9yw1onz _1l3g1onz _dcdpgir2 _wobcgir2 _rp9wgir2 _9ebfwc43 _e43iwc43 _1tkuwc43 _1lehwc43 _b9q3wc43 _tu2918qt _1uxv18qt _1ufw18qt _opo918qt _1e8318qt _1k3d18qt _25yv18qt _1igz18qt _c7cc18qt _1swg18qt"
}; /**
    * __Checkbox__
    *
    * A checkbox an input control that allows a user to select one or more options from a number of choices.
    *
    * - [Examples](https://atlassian.design/components/checkbox/examples)
    * - [Code](https://atlassian.design/components/checkbox/code)
    * - [Usage](https://atlassian.design/components/checkbox/usage)
    */ 
const $3106eb14f9b0a593$var$Checkbox = /*#__PURE__*/ (0, $5uXOq.memo)(/*#__PURE__*/ (0, $5uXOq.forwardRef)(function Checkbox({ isChecked: isCheckedProp, isDisabled: isDisabled = false, isInvalid: isInvalid = false, defaultChecked: defaultChecked = false, isIndeterminate: isIndeterminate = false, onChange: onChangeProps, analyticsContext: analyticsContext, label: label, name: name, value: value, isRequired: isRequired, testId: testId, xcss: xcss, className: className, ...rest }, ref) {
    const [isCheckedState, setIsCheckedState] = (0, $5uXOq.useState)(isCheckedProp !== undefined ? isCheckedProp : defaultChecked);
    const onChange = (0, $5uXOq.useCallback)((e, analyticsEvent)=>{
        setIsCheckedState(e.target.checked);
        if (onChangeProps) onChangeProps(e, analyticsEvent);
    }, [
        onChangeProps
    ]);
    const onChangeAnalytics = (0, $6QvkM.usePlatformLeafEventHandler)({
        fn: onChange,
        action: 'changed',
        analyticsData: analyticsContext,
        componentName: 'checkbox',
        packageName: "platform-pkg",
        packageVersion: "0.0.0-use.local"
    });
    const internalRef = (0, $5uXOq.useRef)(null);
    const mergedRefs = (0, $5JjdN.default)([
        internalRef,
        ref
    ]); // Use isChecked from the state if it is controlled
    const isChecked = isCheckedProp === undefined ? isCheckedState : isCheckedProp;
    (0, $5uXOq.useEffect)(()=>{
        if (internalRef.current) internalRef.current.indeterminate = isIndeterminate;
    }, [
        isIndeterminate
    ]);
    return /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $7xteU.default), {
        isDisabled: isDisabled,
        label: label,
        id: rest.id ? `${rest.id}-label` : undefined,
        testId: testId && `${testId}--checkbox-label`,
        // When there is more usage of this pattern we'll update the lint rule.
        xcss: xcss,
        children: [
            /*#__PURE__*/ (0, $2OMIu.jsx)("input" // It is necessary only for Safari. It allows to render focus styles.
            , {
                tabIndex: 0,
                ...rest,
                type: "checkbox",
                ref: mergedRefs,
                disabled: isDisabled,
                checked: isChecked,
                value: value,
                name: name,
                required: isRequired,
                className: (0, $bwpsq.default)([
                    $3106eb14f9b0a593$var$checkboxStyles.root,
                    className
                ]),
                onChange: onChangeAnalytics,
                "aria-invalid": isInvalid ? 'true' : undefined,
                "data-testid": testId && `${testId}--hidden-checkbox`,
                "data-invalid": isInvalid ? 'true' : undefined
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $kag1C.default), {
                isIndeterminate: isIndeterminate,
                isChecked: isChecked
            }),
            label && /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $hsLv2.default), {
                children: [
                    label,
                    isRequired && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $e62YQ.default), {})
                ]
            })
        ]
    });
}));
$3106eb14f9b0a593$var$Checkbox.displayName = 'Checkbox';
var $3106eb14f9b0a593$export$2e2bcd8739ae039 = $3106eb14f9b0a593$var$Checkbox;

});
parcelRegister("kag1C", function(module, exports) {

$parcel$export(module.exports, "default", () => $a0746a27410bc168$export$2e2bcd8739ae039);
/* checkbox-icon.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $dV6Te = parcelRequire("dV6Te");

var $VSDnB = parcelRequire("VSDnB");
function $a0746a27410bc168$var$getIcon(isIndeterminate, isChecked) {
    if (isIndeterminate) {
        // eslint-disable-next-line @atlaskit/platform/ensure-feature-flag-prefix
        if ((0, $VSDnB.fg)('platform-visual-refresh-icons')) return /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M7.75 12.75H16.25V11.25H7.75V12.75Z",
            fill: "inherit"
        });
        else return /*#__PURE__*/ (0, $2OMIu.jsx)("rect", {
            fill: "inherit",
            x: "8",
            y: "11",
            width: "8",
            height: "2",
            rx: "1"
        });
    }
    if (isChecked) {
        // eslint-disable-next-line @atlaskit/platform/ensure-feature-flag-prefix
        if ((0, $VSDnB.fg)('platform-visual-refresh-icons')) return /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M16.3262 9.48011L15.1738 8.51984L10.75 13.8284L8.82616 11.5198L7.67383 12.4801L10.1738 15.4801C10.3163 15.6511 10.5274 15.75 10.75 15.75C10.9726 15.75 11.1837 15.6511 11.3262 15.4801L16.3262 9.48011Z",
            fill: "inherit"
        });
        else return /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
            d: "M9.707 11.293a1 1 0 1 0-1.414 1.414l2 2a1 1 0 0 0 1.414 0l4-4a1 1 0 1 0-1.414-1.414L11 12.586l-1.293-1.293z",
            fill: "inherit"
        });
    }
    // No icon
    return null;
}
/**
 * __Checkbox icon__
 *
 * A checkbox icon is the visual representation of checkbox state,
 * which is shown instead of the native input.
 *
 * @internal
 */ const $a0746a27410bc168$var$CheckboxIcon = /*#__PURE__*/ (0, $5uXOq.memo)(({ isIndeterminate: isIndeterminate, isChecked: isChecked })=>{
    const icon = (0, $5uXOq.useMemo)(()=>$a0746a27410bc168$var$getIcon(isIndeterminate, isChecked), [
        isIndeterminate,
        isChecked
    ]);
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $dV6Te.default), {
        label: "",
        primaryColor: "var(--checkbox-background-color)",
        secondaryColor: "var(--checkbox-tick-color)",
        children: /*#__PURE__*/ (0, $2OMIu.jsxs)("g", {
            fillRule: "evenodd",
            children: [
                // eslint-disable-next-line @atlaskit/platform/ensure-feature-flag-prefix
                (0, $VSDnB.fg)('platform-visual-refresh-icons') ? /*#__PURE__*/ (0, $2OMIu.jsx)("rect", {
                    fill: "currentColor",
                    x: "5.5",
                    y: "5.5",
                    width: "13",
                    height: "13",
                    rx: "1.5"
                }) : /*#__PURE__*/ (0, $2OMIu.jsx)("rect", {
                    fill: "currentColor",
                    x: "6",
                    y: "6",
                    width: "12",
                    height: "12",
                    rx: "2"
                }),
                icon
            ]
        })
    });
});
var $a0746a27410bc168$export$2e2bcd8739ae039 = $a0746a27410bc168$var$CheckboxIcon;

});

parcelRegister("7xteU", function(module, exports) {

$parcel$export(module.exports, "default", () => $7b368d644c230660$export$2e2bcd8739ae039);
/* label.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
const $7b368d644c230660$var$baseStyles = null;
const $7b368d644c230660$var$textLabelLayoutStyles = null;
const $7b368d644c230660$var$disabledStyles = null;
const $7b368d644c230660$var$labelStyles = null;
function $7b368d644c230660$export$2e2bcd8739ae039({ children: children, isDisabled: isDisabled, testId: testId, label: label, id: id, xcss: xcss }) {
    return /*#__PURE__*/ (0, $2OMIu.jsx)("label", {
        className: (0, $bwpsq.default)([
            "_11c82smr _1e0c11p5 _1ejihkll _umai184x _syazj3m3 _80om73ad",
            label && "_zulp1nu5 _yv0ey09t",
            isDisabled && "_syaz1tvo _80om13gf",
            "_h5e3mag2 _1nzs11d3 _1eszzyvw _yp0jhh5a _ay2w1y1w _d51u10ko _phft1fmg _1g1funzk _l6wkzyvw _1dikhh5a _1sfg1q3k _fpdj1y1w _1yjc194a _oaj11fmg _1j3h1q3k _eawb1dzn _1rda1qbb _18q015t7 _13hr3acm",
            xcss
        ]),
        "data-testid": testId,
        "data-disabled": isDisabled || undefined,
        id: id,
        children: children
    });
}

});

parcelRegister("hsLv2", function(module, exports) {

$parcel$export(module.exports, "default", () => $ce636d67b4ff1120$export$2e2bcd8739ae039);
/* label-text.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
const $ce636d67b4ff1120$var$labelTextStyles = null;
function $ce636d67b4ff1120$export$2e2bcd8739ae039({ children: children }) {
    return /*#__PURE__*/ (0, $2OMIu.jsx)("span", {
        className: (0, $bwpsq.default)([
            "_nd5l11ig _1wpz1h6o"
        ]),
        children: children
    });
}

});

parcelRegister("e62YQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $d2156c28a3894cac$export$2e2bcd8739ae039);
/* required-indicator.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
const $d2156c28a3894cac$var$requiredIndicatorStyles = null;
function $d2156c28a3894cac$export$2e2bcd8739ae039() {
    return /*#__PURE__*/ (0, $2OMIu.jsx)("span", {
        "aria-hidden": true,
        className: (0, $bwpsq.default)([
            "_syaz1gtz _bozgv77o"
        ]),
        children: "*"
    });
}

});



parcelRegister("bcqPo", function(module, exports) {

$parcel$export(module.exports, "i18n", () => $a6b378e994b1a844$export$a7357cdd1f0b0168);

var $7VHMR = parcelRequire("7VHMR");
const $a6b378e994b1a844$export$a7357cdd1f0b0168 = (0, $7VHMR.defineMessages)({
    title: {
        id: 'browser-storage-controls.consent-banner-modal.title',
        defaultMessage: 'Cookie preferences',
        description: 'Cookie preferences modal dialog title.'
    },
    summaryDescription: {
        id: 'browser-storage-controls.consent-banner-modal.summary.description.082624',
        defaultMessage: 'Because we value your privacy, you can select which cookies you allow. {link}',
        description: 'Cookie preferences modal dialog summary description.'
    },
    strictDescription: {
        id: 'browser-storage-controls.consent-banner-modal.strict.description.082624',
        defaultMessage: "Atlassian tracks <bold>strictly necessary</bold> cookies that are essential for our products to function, so you can't adjust these. These cookies don't store personally identifiable information or track browsing habits.",
        description: 'Cookie preferences modal strict description.'
    },
    confirmBtn: {
        id: 'browser-storage-controls.consent-banner-modal.confirm.button',
        defaultMessage: 'Confirm',
        description: 'Cookie preferences modal dialog confirm button.'
    },
    cancelBtn: {
        id: 'browser-storage-controls.consent-banner-modal.cancel.button',
        defaultMessage: 'Cancel',
        description: 'Cookie preferences modal dialog cancel button.'
    },
    trackingLink: {
        id: 'browser-storage-controls.consent-banner-modal.tracking.link.082624',
        defaultMessage: 'Review our cookies and tracking notice',
        description: 'Cookie preferences modal link to tracking notice page.'
    },
    functionalOption: {
        id: 'browser-storage-controls.consent-banner-modal.functional.option.082624',
        defaultMessage: 'Allow functional cookies',
        description: 'Cookie preferences modal functional option.'
    },
    functionalOptionDescription: {
        id: 'browser-storage-controls.consent-banner-modal.functional.description.082624',
        defaultMessage: 'Provides enhanced functionality and personalization.',
        description: 'Cookie preferences modal functional option description.'
    },
    analyticalOption: {
        id: 'browser-storage-controls.consent-banner-modal.analytical.option.082624',
        defaultMessage: 'Allow analytical cookies',
        description: 'Cookie preferences modal analytical option.'
    },
    analyticalOptionDescription: {
        id: 'browser-storage-controls.consent-banner-modal.analytical.description.101024',
        defaultMessage: 'Measures usage to improve product performance.',
        description: 'Cookie preferences modal analytical option description.'
    },
    marketingOption: {
        id: 'browser-storage-controls.consent-banner-modal.marketing.option.082624',
        defaultMessage: 'Allow marketing cookies',
        description: 'Cookie preferences modal marketing option.'
    },
    marketingOptionDescription: {
        id: 'browser-storage-controls.consent-banner-modal.marketing.description.082624',
        defaultMessage: 'Used for targeted advertising.',
        description: 'Cookie preferences modal marketing option description.'
    }
});

});


parcelRegister("bLuwV", function(module, exports) {

$parcel$export(module.exports, "default", () => $1c34df2578f41ce1$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $gHrGQ = parcelRequire("gHrGQ");

var $waH4c = parcelRequire("waH4c");

var $k49WR = parcelRequire("k49WR");
/**
 * This function is responsible for loading the user's preferences from storage, and setting the state accordingly.
 * If the user's preferences are not found in storage, the default preferences will be used.
 */ const $1c34df2578f41ce1$var$loadStoredPreferences = async ({ setPreferencesData: setPreferencesData, isInitialRender: isInitialRender })=>{
    const prefs = await (0, $waH4c.getPreferences)();
    // If something has gone wrong during this `get` process (invalid token, failed request, etc.)
    // these preferences will be undefined and we'll need to show the banner as we're in an unknown state
    setPreferencesData({
        prefs: prefs,
        isPrefetchedPrefsInternalState: Boolean(prefs)
    });
    // Set the initialRender flag to false so we can skip logic in banner rendering
    if (isInitialRender) isInitialRender.current = false;
};
/**
 * This hook is responsible for handling any initially provided preference data, and/or fetching missing preference
 * data from ConsentHub. It will then set the appropriate cookies and state for the user's preferences to be used
 * throughout the application.

 * @param (optional) initialPreferences - Any initially provided preferences from consuming applications (used for SSR)
 * @returns (object) {
 * 	preferences - The current state of the user's preferences after fetching/transforming/setting cookies
 *	isPrefetchedPreferencesState - A boolean that indicates if we are in a prefetched internal state
 *	setPreferencesData - Setter function to update the preferences state
 *	isInitialRender - A boolean that indicates if this is the first render of the component
 * }
 */ const $1c34df2578f41ce1$var$usePreferences = ({ initialPreferences: initialPreferences })=>{
    /**
	 * isInitialRender is used to ensure consistent banner visibility by addressing potential mismatches that occur
	 *  during the initial render. Without this flag, the application might incorrectly display a banner based on
	 * incomplete or missing preference data. During the rehydration process, this initial render triggers
	 * the useMemo and useEffect hooks which means that initialPreferences may be undefined due to the asynchronous
	 * nature of setting props. This can lead to discrepancies in banner visibility between the SSR state
	 * and the client-rendered state.
	 */ const isInitialRender = (0, $5uXOq.useRef)(true);
    const prefetchedPreferencesData = (0, $5uXOq.useRef)(initialPreferences);
    const [preferencesData, setPreferencesData] = (0, $5uXOq.useState)((0, $gHrGQ.initializePreferencesData)(initialPreferences));
    (0, $5uXOq.useEffect)(()=>{
        const { prefs: unpackedPrefetchedPrefs, isPrefetchedPrefsInternalState: isPrefetchedPrefsInternalState } = (0, $gHrGQ.initializePreferencesData)(prefetchedPreferencesData.current);
        if (!isPrefetchedPrefsInternalState && unpackedPrefetchedPrefs) // With a valid set of prefs, set them on the cookies, but don't save to ConsentHub
        (0, $k49WR.updatePreferences)(unpackedPrefetchedPrefs, undefined, true);
        // On initial render, this will either set the proper preferences in state + required cookies based on the
        // prefetched data, or fetch all of that data from ConsentHub and then set appropriate cookies + state.
        $1c34df2578f41ce1$var$loadStoredPreferences({
            setPreferencesData: setPreferencesData,
            isInitialRender: isInitialRender
        });
    }, [
        isInitialRender
    ]);
    return {
        preferences: preferencesData?.prefs,
        isPrefetchedPreferencesState: preferencesData?.isPrefetchedPrefsInternalState,
        setPreferencesData: setPreferencesData,
        isInitialRender: isInitialRender.current
    };
};
var $1c34df2578f41ce1$export$2e2bcd8739ae039 = $1c34df2578f41ce1$var$usePreferences;

});


parcelRegister("dAiBk", function(module, exports) {

$parcel$export(module.exports, "PresentationalConsentBanner", () => $baa4cfd1039a69b1$export$dd3e60478510f81d);
/* eslint-disable @atlassian/tangerine/import/no-parent-imports */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $ousew = parcelRequire("ousew");
var $koVbs = parcelRequire("koVbs");

var $fVnbM = parcelRequire("fVnbM");

var $ky7e4 = parcelRequire("ky7e4");

var $VSDnB = parcelRequire("VSDnB");

var $jhmo0 = parcelRequire("jhmo0");
var $dC5iT = parcelRequire("dC5iT");
var $f5TWP = parcelRequire("f5TWP");
var $8CUq3 = parcelRequire("8CUq3");

var $h9kUS = parcelRequire("h9kUS");

var $j7UP0 = parcelRequire("j7UP0");

var $lhsMz = parcelRequire("lhsMz");
const $baa4cfd1039a69b1$var$boxStylesBlue = (0, $8CUq3.xcss)({
    padding: 'space.200',
    backgroundColor: 'color.background.information',
    borderStyle: 'solid',
    borderWidth: 'border.width',
    borderColor: 'color.border',
    overflowY: 'hidden'
});
const $baa4cfd1039a69b1$var$boxStylesBlueWithMinHeight = (0, $8CUq3.xcss)({
    padding: 'space.200',
    backgroundColor: 'color.background.information',
    borderStyle: 'solid',
    borderWidth: 'border.width',
    borderColor: 'color.border',
    overflowY: 'hidden',
    // If you are updating the minHeight, please also update the MIN_BANNER_HEIGHT in confluence/next/packages/cookies-consent-banner/src/useCookiesConsentBanner.ts
    minHeight: '74px',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center'
});
const $baa4cfd1039a69b1$var$inlineWrapperStyles = (0, $8CUq3.xcss)({
    // Small viewport defaults
    gap: 'space.200',
    alignItems: 'flex-start',
    flexDirection: 'column',
    // Larger viewports
    [(0, $h9kUS.media).above.sm]: {
        gap: 'space.300',
        flexDirection: 'row',
        alignItems: 'center'
    }
});
const $baa4cfd1039a69b1$var$noticeContainerStyles = (0, $8CUq3.xcss)({
    flexDirection: 'column'
});
const $baa4cfd1039a69b1$var$buttonContainerStyles = (0, $8CUq3.xcss)({
    // Prevents the button text from truncating when the screen width decreases
    minWidth: 'fit-content',
    // Applies to below sm size
    flexDirection: 'row-reverse',
    flexWrap: 'wrap-reverse',
    justifyContent: 'start',
    [(0, $h9kUS.media).above.sm]: {
        marginLeft: 'auto',
        flexWrap: 'nowrap',
        flexDirection: 'row'
    }
});
const $baa4cfd1039a69b1$var$noop = ()=>{};
const $baa4cfd1039a69b1$var$getDisplayedTextMap = (intl)=>{
    // We'll use this mapping to send the `displayedText` for each checkbox when saving to ConsentHub
    const displayedTextMap = (0, $j7UP0.CONSENT_DISPLAYED_TEXT_ITEMS).reduce((translatedTextMap, category)=>{
        const linkToCookiesTrackingNotice = intl.formatMessage((0, $lhsMz.i18n).cookiesTrackingNotice);
        const bannerDescription = intl.formatMessage((0, $lhsMz.i18n).useCookiesDescription, {
            linkToCookiesTrackingNotice: linkToCookiesTrackingNotice
        });
        // Set this for all items (including items with checkboxes in the UI), we'll override as needed below
        // for things like strictlyNecessary/acceptAll
        translatedTextMap[category] = bannerDescription;
        return translatedTextMap;
    }, {});
    return displayedTextMap;
};
const $baa4cfd1039a69b1$var$updateDisplayedTextMap = (intl, displayTextMap, isOnlyNecessary)=>{
    const updatedDisplayedTextMap = {
        ...displayTextMap
    };
    // Use description as message to translate
    const onlyNecessaryContent = intl.formatMessage((0, $lhsMz.i18n).onlyNecessaryBtn);
    const acceptAllContent = intl.formatMessage((0, $lhsMz.i18n).acceptAllBtn);
    // For additional auditing content, append the description related to the button when pressed
    Object.keys(updatedDisplayedTextMap).forEach((key)=>{
        const preferenceCategory = key;
        const additionalContent = isOnlyNecessary ? onlyNecessaryContent : acceptAllContent;
        const textContent = updatedDisplayedTextMap[preferenceCategory];
        updatedDisplayedTextMap[preferenceCategory] = `${additionalContent} \u{2014} ${textContent}`;
    });
    return updatedDisplayedTextMap;
};
const $baa4cfd1039a69b1$export$dd3e60478510f81d = ({ onClickOnlyNecessary: onClickOnlyNecessary = $baa4cfd1039a69b1$var$noop, onClickAcceptAll: onClickAcceptAll = $baa4cfd1039a69b1$var$noop, onClickPreferences: onClickPreferences = $baa4cfd1039a69b1$var$noop, onClickTrackingNoticeLink: onClickTrackingNoticeLink = $baa4cfd1039a69b1$var$noop, minWidth: minWidth = 400 })=>{
    const intl = (0, $koVbs.default)();
    const displayedTextMap = (0, $5uXOq.useMemo)(()=>{
        return $baa4cfd1039a69b1$var$getDisplayedTextMap(intl);
    }, [
        intl
    ]);
    const handleOnlyNecessaryClick = (0, $5uXOq.useCallback)(()=>{
        const displayedTextOnlyNecessaryMap = $baa4cfd1039a69b1$var$updateDisplayedTextMap(intl, displayedTextMap, true);
        onClickOnlyNecessary(displayedTextOnlyNecessaryMap);
    }, [
        onClickOnlyNecessary,
        intl,
        displayedTextMap
    ]);
    const handleAcceptAllClick = (0, $5uXOq.useCallback)(()=>{
        const displayedTextAcceptAllMap = $baa4cfd1039a69b1$var$updateDisplayedTextMap(intl, displayedTextMap);
        onClickAcceptAll(displayedTextAcceptAllMap);
    }, [
        onClickAcceptAll,
        intl,
        displayedTextMap
    ]);
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $dC5iT.default), {
        role: "dialog",
        "aria-labelledby": "cookiesTrackingNoticeLink",
        xcss: (0, $VSDnB.fg)('platform_fix_banner_spacer_vc') ? $baa4cfd1039a69b1$var$boxStylesBlueWithMinHeight : $baa4cfd1039a69b1$var$boxStylesBlue,
        style: {
            minWidth: `${minWidth}px`
        },
        children: /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $f5TWP.default), {
            xcss: $baa4cfd1039a69b1$var$inlineWrapperStyles,
            children: [
                /*#__PURE__*/ (0, $2OMIu.jsx)((0, $f5TWP.default), {
                    xcss: $baa4cfd1039a69b1$var$noticeContainerStyles,
                    children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
                        ...(0, $lhsMz.i18n).useCookiesDescription,
                        tagName: "span",
                        values: {
                            linkToCookiesTrackingNotice: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $jhmo0.default), {
                                id: "cookiesTrackingNoticeLink",
                                href: "https://www.atlassian.com/legal/cookies",
                                target: "_blank",
                                onClick: onClickTrackingNoticeLink,
                                children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
                                    ...(0, $lhsMz.i18n).cookiesTrackingNotice
                                })
                            })
                        }
                    })
                }),
                /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $f5TWP.default), {
                    space: "space.100",
                    xcss: $baa4cfd1039a69b1$var$buttonContainerStyles,
                    children: [
                        /*#__PURE__*/ (0, $2OMIu.jsx)((0, $fVnbM.default), {
                            appearance: "subtle",
                            onClick: onClickPreferences,
                            children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
                                ...(0, $lhsMz.i18n).preferencesBtn
                            })
                        }),
                        /*#__PURE__*/ (0, $2OMIu.jsx)((0, $fVnbM.default), {
                            onClick: handleOnlyNecessaryClick,
                            children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
                                ...(0, $lhsMz.i18n).onlyNecessaryBtn
                            })
                        }),
                        /*#__PURE__*/ (0, $2OMIu.jsx)((0, $fVnbM.default), {
                            iconBefore: /*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($ky7e4))), {
                                color: "currentColor",
                                spacing: "none",
                                testId: "experiment-one-button-icon",
                                label: ""
                            }),
                            onClick: handleAcceptAllClick,
                            children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
                                ...(0, $lhsMz.i18n).acceptAllBtn
                            })
                        })
                    ]
                })
            ]
        })
    });
};

});
parcelRegister("ky7e4", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::4eca488eebd24f6b0c74ed2566069d9c>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $ef5c96854bbf6178$var$_react = $ef5c96854bbf6178$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $ef5c96854bbf6178$var$_checkMark = $ef5c96854bbf6178$var$_interopRequireDefault((parcelRequire("bjo8S")));

var $ef5c96854bbf6178$var$_check = $ef5c96854bbf6178$var$_interopRequireDefault((parcelRequire("kbxJz")));
function $ef5c96854bbf6178$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for CheckMarkIcon.
 * This component is CheckMarkIcon, with `UNSAFE_fallbackIcon` set to "CheckIcon".
 *
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: table cells, checkboxes.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $ef5c96854bbf6178$var$CheckMarkIcon = (props)=>/*#__PURE__*/ $ef5c96854bbf6178$var$_react.default.createElement($ef5c96854bbf6178$var$_checkMark.default, Object.assign({
        LEGACY_fallbackIcon: $ef5c96854bbf6178$var$_check.default
    }, props));
$ef5c96854bbf6178$var$CheckMarkIcon.Name = 'CheckMarkIconMigration';
var $ef5c96854bbf6178$var$_default = module.exports.default = $ef5c96854bbf6178$var$CheckMarkIcon;

});
parcelRegister("bjo8S", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::a3e71f4112aeb66b16fbd284cc49bbc6>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $83c43234bc70a485$var$_react = $83c43234bc70a485$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $83c43234bc70a485$var$_baseNew = $83c43234bc70a485$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $83c43234bc70a485$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "CheckMark".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: table cells, checkboxes.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $83c43234bc70a485$var$CheckMarkIcon = (props)=>/*#__PURE__*/ $83c43234bc70a485$var$_react.default.createElement($83c43234bc70a485$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="m15.076 3.23-8.75 10.5a.75.75 0 0 1-1.159-.008l-4.25-5.25 1.166-.944 3.675 4.54 8.166-9.798z" clip-rule="evenodd"/>`
    }, props));
$83c43234bc70a485$var$CheckMarkIcon.displayName = 'CheckMarkIcon';
var $83c43234bc70a485$var$_default = module.exports.default = $83c43234bc70a485$var$CheckMarkIcon;

});

parcelRegister("kbxJz", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $eb1f0098e5a023eb$var$_react = $eb1f0098e5a023eb$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");

var $eb1f0098e5a023eb$var$_checkMark = $eb1f0098e5a023eb$var$_interopRequireDefault((parcelRequire("bjo8S")));
function $eb1f0098e5a023eb$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $eb1f0098e5a023eb$var$CheckIcon = (props)=>/*#__PURE__*/ $eb1f0098e5a023eb$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" d="M6.735 12.322a1 1 0 0 0-1.47 1.356l3.612 3.919c.537.526 1.337.526 1.834.03l.364-.359a2336 2336 0 0 0 3.939-3.883l.04-.04a493 493 0 0 0 3.658-3.643 1 1 0 0 0-1.424-1.404 518 518 0 0 1-3.64 3.625l-.04.04a2049 2049 0 0 1-3.775 3.722z"/></svg>`
    }, props, {
        newIcon: $eb1f0098e5a023eb$var$_checkMark.default
    }));
$eb1f0098e5a023eb$var$CheckIcon.displayName = 'CheckIcon';
var $eb1f0098e5a023eb$var$_default = module.exports.default = $eb1f0098e5a023eb$var$CheckIcon;

});



parcelRegister("j4fP5", function(module, exports) {

$parcel$export(module.exports, "default", () => $d5898be9aab69d20$export$2e2bcd8739ae039);
/* eslint-disable @atlassian/tangerine/import/no-parent-imports */ 
var $5uXOq = parcelRequire("5uXOq");

var $gMWuT = parcelRequire("gMWuT");
var $3MsQ9 = parcelRequire("3MsQ9");

var $ljmYJ = parcelRequire("ljmYJ");

var $21KEY = parcelRequire("21KEY");

var $7RRGT = parcelRequire("7RRGT");

var $4uHy1 = parcelRequire("4uHy1");

var $e62TO = parcelRequire("e62TO");
const $d5898be9aab69d20$export$f6e8c8e54d2f31fe = (isInitialRender, initialPreferences, isSSRPrefetchImplemented)=>{
    // We don't have a great way to handle dealing with consent timestamps right here, as we have no global state/store, so we have to precompute
    // banner visibility state when we fetch consents, and store it in a cookie to be read later, here.
    const shouldShowBannerBit = isSSRPrefetchImplemented && isInitialRender ? window.__SHOW_COOKIE_BANNER__ : (0, $4uHy1.getCookie)((0, $21KEY.ATLASSIAN_SHOW_BANNER_COOKIE_KEY));
    const inFlowWhereBannerStateIsUnknown = initialPreferences && isInitialRender && shouldShowBannerBit === undefined;
    if (((0, $ljmYJ.isSSR)() || inFlowWhereBannerStateIsUnknown) && !isSSRPrefetchImplemented) // When coming from SSR, this hook will only execute once and won't update later
    // Instead, if we're on the server, have initial preference data with valid consents, don't render
    // On later checks (rehydration), this will always fail and skip to the normal rendering logic
    // Once we're rehydrating, if have been provided initial prefs (from SSR), on the "first render", the banner cookie may still be missing.
    // Due to React lifecycle where this useMemo is executing prior to the useEffect in the usePreferences hook, which sets the core cookies.
    // We should give this flow the same treatment as rendering in an SSR context to match the behavior of the SSR flow to reduce any potential UX flicker.
    return (0, $e62TO.shouldShowBannerInSSRContext)(initialPreferences);
    const shouldShowBanner = shouldShowBannerBit ? !!Number(shouldShowBannerBit) : false;
    return shouldShowBanner;
};
/**
 * This hook is responsible for determining whether or not the consent banner should be shown based on the user's
 * preferences and the current state of the banner cookie, as well as if the we're rendering from an SSR context.
 *
 * @param preferences - The current state of the user's preferences
 * @param initialPreferences - Any initially provided preferences from consuming applications (used for SSR)
 * @param isInitialRender - A boolean to track if this is the "first" render of the component
 * @param isPrefetchedPreferencesState - A boolean that indicates if are fetching consents internally to our component
 * @returns showBanner - Whether or not the banner should be shown
 * @returns setIsDismissed - Setter function to update the dismissed state of the banner
 */ const $d5898be9aab69d20$var$useBannerVisibility = ({ preferences: preferences, initialPreferences: initialPreferences, isInitialRender: isInitialRender, isPrefetchedPreferencesState: isPrefetchedPreferencesState, isSSRPrefetchImplemented: isSSRPrefetchImplemented })=>{
    const isEventSent = (0, $5uXOq.useRef)(false);
    const [isDismissed, setIsDismissedProp] = (0, $5uXOq.useState)(false);
    const setIsDismissed = (isDismissed)=>{
        if (isDismissed) (0, $7RRGT.setStrictlyNecessaryCookie)((0, $21KEY.ATLASSIAN_BANNER_LAST_DISMISSED_TIME_COOKIE_KEY), Date.now().toString(), {
            path: '/'
        });
        setIsDismissedProp(isDismissed);
    };
    const showBanner = (0, $5uXOq.useMemo)(()=>{
        return $d5898be9aab69d20$export$4ea0ccb8ff519056({
            preferences: preferences,
            initialPreferences: initialPreferences,
            isInitialRender: isInitialRender,
            isPrefetchedPreferencesState: isPrefetchedPreferencesState,
            isDismissed: isDismissed,
            isSSRPrefetchImplemented: isSSRPrefetchImplemented
        });
    }, [
        isInitialRender,
        initialPreferences,
        isPrefetchedPreferencesState,
        preferences,
        isDismissed,
        isSSRPrefetchImplemented
    ]);
    (0, $5uXOq.useEffect)(()=>{
        if (!isEventSent.current && showBanner) {
            (0, $3MsQ9.sendScreenEvent)({
                name: 'cookieConsentBanner'
            });
            isEventSent.current = true;
        }
    }, [
        isEventSent,
        showBanner
    ]);
    return {
        showBanner: showBanner,
        setIsDismissed: setIsDismissed
    };
};
const $d5898be9aab69d20$export$4ea0ccb8ff519056 = ({ preferences: preferences, initialPreferences: initialPreferences, isInitialRender: isInitialRender, isPrefetchedPreferencesState: isPrefetchedPreferencesState, isDismissed: isDismissed, isSSRPrefetchImplemented: isSSRPrefetchImplemented })=>{
    if ((0, $gMWuT.getBscGlobalState)().localConsentMode) {
        // In V1, we only checked based on the existence of the preferences
        const prefsMissing = !preferences;
        if ((0, $ljmYJ.isSSR)() && !isSSRPrefetchImplemented) // This logic will execute normally in V2, but for now, as SSR prefetching has not been implemented completely
        // just hide the banner if we're missing the data (always will be in SSR-context) and let the UI handle it on rehydration
        return !prefsMissing && !isDismissed;
        return prefsMissing && !isDismissed;
    }
    const shouldShowBanner = $d5898be9aab69d20$export$f6e8c8e54d2f31fe(isInitialRender, initialPreferences, isSSRPrefetchImplemented);
    const unknownPreferences = !isPrefetchedPreferencesState && !preferences;
    return (unknownPreferences || shouldShowBanner) && !isDismissed;
};
var $d5898be9aab69d20$export$2e2bcd8739ae039 = $d5898be9aab69d20$var$useBannerVisibility;

});
parcelRegister("e62TO", function(module, exports) {

$parcel$export(module.exports, "shouldShowBannerInSSRContext", () => $ba4b05d025c5f83e$export$1a7f5824c34ba94b);

var $VSDnB = parcelRequire("VSDnB");

var $gHrGQ = parcelRequire("gHrGQ");

var $bF6aU = parcelRequire("bF6aU");

var $8FFpF = parcelRequire("8FFpF");
const $ba4b05d025c5f83e$export$1a7f5824c34ba94b = (initialPreferences)=>{
    if ((0, $VSDnB.fg)('platform_moonjelly_bsc_ssr_killswitch')) // If our bsc ssr killswitch is enabled, we should not show the banner
    // in SSR context
    return false;
    if (initialPreferences === (0, $8FFpF.PrefetchedPreferenceState).INTERNAL) // If we're in the "fetch internally" state, we have no prefetched data and we can't determine
    // if the user has consented or not yet since we need to fetch, so show the banner
    return true;
    // Confluence the banner will render on the UI, so we should plan to render here too
    if (!initialPreferences || (0, $gHrGQ.initialPreferencesAreMissing)(initialPreferences)) return true;
    // If prefetched data has a consentToken or the consents array is there and populated
    // we want to hide the banner, as the user has has made consents already.
    const prefetchedToken = 'consentToken' in initialPreferences && initialPreferences.consentToken;
    const prefetchedTokenIsDefault = (0, $bF6aU.checkIfTokenIsDefault)(prefetchedToken || '');
    const hasLegitConsentToken = prefetchedToken && !prefetchedTokenIsDefault;
    const prefetchedConsents = 'consents' in initialPreferences && initialPreferences.consents;
    const hasLegitConsents = prefetchedConsents && prefetchedConsents.length > 0;
    const prefetchedDataHasConsents = Boolean(hasLegitConsentToken || hasLegitConsents);
    const showBannerSinceUserHasNotConsented = !prefetchedDataHasConsents;
    return showBannerSinceUserHasNotConsented;
};

});


parcelRegister("faR9h", function(module, exports) {

$parcel$export(module.exports, "default", () => $3051100a19b8c3bd$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");
const $3051100a19b8c3bd$var$usePrevious = (value)=>{
    // The ref object is a generic container whose current property is mutable ...
    // ... and can hold any value, similar to an instance property on a class
    const ref = (0, $5uXOq.useRef)();
    // Store current value in ref
    (0, $5uXOq.useEffect)(()=>{
        ref.current = value;
    }, [
        value
    ]); // Only re-run if value changes
    // Return previous value (happens before update in useEffect above)
    return ref.current;
};
var $3051100a19b8c3bd$export$2e2bcd8739ae039 = $3051100a19b8c3bd$var$usePrevious;

});



const $91be75e714d10b24$export$41956b146268af93 = 'COOKIE_CONSENT_BANNER';
const $91be75e714d10b24$export$ed7cc0d417ee89e = 74;
const $91be75e714d10b24$export$ff6e18f7d82b549c = 320;



//# sourceMappingURL=async-ccb.f9187697.js.map
